import { AppState, Primitive } from "../types";
import {
  DEFAULT_ELEMENT_BACKGROUND_COLOR_PALETTE,
  DEFAULT_ELEMENT_BACKGROUND_PICKS,
  DEFAULT_ELEMENT_STROKE_COLOR_PALETTE,
  DEFAULT_ELEMENT_STROKE_PICKS,
} from "../colors";
import { trackEvent } from "../analytics";
import { ButtonIconSelect } from "../components/ButtonIconSelect";
// import { ColorPicker } from "../components/ColorPicker/ColorPicker";
import { IconPicker } from "../components/IconPicker";
// TODO barnabasmolnar/editor-redesign
// TextAlignTopIcon, TextAlignBottomIcon,TextAlignMiddleIcon,
// ArrowHead icons
import {
  ArrowheadArrowIcon,
  ArrowheadBarIcon,
  ArrowheadCircleIcon,
  ArrowheadTriangleIcon,
  ArrowheadNoneIcon,
  StrokeStyleDashedIcon,
  StrokeStyleDottedIcon,
  TextAlignTopIcon,
  TextAlignBottomIcon,
  TextAlignMiddleIcon,
  FillHachureIcon,
  FillCrossHatchIcon,
  FillSolidIcon,
  SloppinessArchitectIcon,
  SloppinessArtistIcon,
  SloppinessCartoonistIcon,
  StrokeWidthBaseIcon,
  FreedrawIcon,
  FontFamilyNormalIcon,
  FontFamilyCodeIcon,
  FillZigZagIcon,
  ArrowheadTriangleOutlineIcon,
  ArrowheadCircleOutlineIcon,
  ArrowheadDiamondIcon,
  ArrowheadDiamondOutlineIcon,
  ArrowheadRectangleOutlineIcon,
  ArrowheadRectangleIcon,
  FontSizeSmallIcon,
  FontSizeMediumIcon, FontSizeLargeIcon,
} from "../components/icons";
import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_FONT_SIZE, DEFAULT_LINE_HEIGHT, DEFAULT_MAX_FONT_SIZE,
  FONT_FAMILY, IMAGE_MIME_TYPES,
  ROUNDNESS,
  STROKE_WIDTH,
  VERTICAL_ALIGN,
} from "../constants";
import {
  getNonDeletedElements,
  isTextElement,
  redrawTextBoundingBox,
} from "../element";
import { mutateElement, newElementWith } from "../element/mutateElement";
import {
  getBoundTextElement,
  getContainerElement,
  getDefaultLineHeight,
} from "../element/textElement";
import {
  isArrowElement,
  isBindableElement,
  isBoundToContainer, isEmbedableBookmarkElement, isEmbeddableElement, isFreeDrawElement, isImageElement,
  isLinearElement, isMindmapElement, isShapeElement, isStickyNotesElement, isTextOrBoundElement,
  isUsingAdaptiveRadius,
} from "../element/typeChecks";
import {
  Arrowhead,
  ExcalidrawElement,
  ExcalidrawLinearElement, ExcalidrawStickyNotesElement,
  ExcalidrawTextElement, FileId,
  FontFamilyValues,
  TextAlign,
  VerticalAlign,
} from "../element/types";
import { getLanguage, t } from "../i18n";
import { KEYS } from "../keys";
import { randomInteger } from "../random";
import {
  canHaveArrowheads,
  getCommonAttributeOfSelectedElements,
  getSelectedElements,
  getTargetElements,
  isSomeElementSelected,
} from "../scene";
import { hasStrokeColor } from "../scene/comparisons";
import { arrayToMap, getShortcutKey } from "../utils";
import { register } from "./register";
import { FieldType } from "./types";
import {
  Button,
  Form,
  InputNumber,
  Modal,
  ColorPicker as AntdColorPicker,
  theme,
  ColorPickerProps,
} from "antd";
import {
  AutoComplete,
  Dropdown,
  Input,
  Select,
  ColorPicker,
  Popover,
  List,
  ConfigProvider,
  Checkbox,
  Slider
} from "antd";
import {
  BoldOutlined,
  DownOutlined, ItalicOutlined,
  MinusOutlined,
  PlusOutlined,
  StrikethroughOutlined,
  UnderlineOutlined
} from "@ant-design/icons";
import {
  changeSvgColor,
  generateUUID2, getImagePath, getImagePathSvg,
  getImagePathWithTheme, hasDesktopBaseLicense,
  hasLicense,
  imgPathPerfix, isAnnoElement, isDarkMode, isNoteElement, isNumber,
  isStringNullOrEmpty, sleep
} from "../../../../src/utils";
import React, {useCallback, useEffect, useLayoutEffect, useMemo, useReducer, useState} from "react";
import {normalizeSVG} from "../element/image";
import {generateIdFromFile, getDataURL, resizeImageFile, SVGStringToFile} from "../data/blob";
import {IconDropdownGray, IconDropdownSelected, IconDropdownTriangle} from "../../../../src/Icon";
import {
  hexToHsva, hsvaToHexa, validHex, hexToRgba, rgbaToHexa
} from '@uiw/react-color';
import { Alpha, Hue, ShadeSlider, Saturation, Interactive, hsvaToHslaString } from '@uiw/react-color';
import {HsvaColor} from "@uiw/color-convert/src/index";
import {
  ARRAY_COLORS,
  ARRAY_DEFAULT_BORDER_COLORS,
  ARRAY_DEFAULT_CARD_COLORS,
  ARRAY_DEFAULT_COLORS,
  ARRAY_DEFAULT_COLORS_1,
  ARRAY_DEFAULT_DARK_USE_COLOR,
  ARRAY_DEFAULT_USE_COLOR,
  COLOR_E5E5E5,
  COLOR_TRANSPARENT,
  DEFAULT_ATTR_SELECT_COLOR,
  DEFAULT_ELEMENT_STROKE_WITHD,
  DRAW_TOOL_POPOVER_TOP,
  ENABLE_STICKYNOTE_RICHTEXT_20250815,
  EVENT_BACKGROUND_COLOR_CHANGE,
  EVENT_CANVAS_DELETE_ELEMENT,
  EVENT_FONT_STROKE_COLOR_CHANGE,
  EVENT_FORCE_UPDATE_TOOLBAR_MENU,
  EVENT_KEY_ESCAPSE_ESC,
  EVENT_OPEN_SELECT_FONT_FAMILY,
  EVENT_SHOW_FONT_CHOOSE,
  EVENT_STROKE_COLOR_CHANGE,
  EVENT_STROKE_COLOR_CHANGE_1,
  EVENT_UPDATE_FONT_SIZE,
  EVENT_UPDATE_FRAME_LIST,
  HAS_ENABLE_TIPTAP_TEXT, KEY_CARD_ELEMENT_DEFAULT_STYLE,
  KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,
  KEY_DEFAULT_TEXT_BACKGROUND_COLOR,
  KEY_DEFAULT_TEXT_FONT_FAMILY,
  KEY_DEFAULT_TEXT_FONT_SIZE, KEY_DRAW_ARROW_LINE_STYLE, KEY_DRAW_ARROW_STROKE_COLOR, KEY_DRAW_ARROW_STROKE_WIDTH,
  KEY_FREE_DRAW_STROKE_WIDTH
} from "../../../../src/Const";
import {activeEyeDropperAtom, EyeDropper} from "../components/EyeDropper";
import {useAtom} from "jotai";
import {jotaiScope} from "../jotai";
import {postMessage, recvMessage} from "../../../../src/common/event";
import {nanoid} from "nanoid";
import style from "../components/ActionToolbar.module.scss";
import './actionProperties.css'
import global from "@/global";
import {OFFSET, addMindMapControls, mindMapCache, lineWidthList, fontFamilyList} from "../element/mindMap";
import { generate, green, presetPalettes, red } from "@ant-design/colors";
import addIcon from "../assets/add.svg";
import addIconWhite from "../assets/add_white.svg";
import {get} from "idb-keyval";
import {text} from "express";
import {useExcalidrawSetAppState} from "../components/App";
import i18next from "i18next";
import { DropdownSelector } from "../components/DropdownSelector";
import {debugLog} from "../../../../src/LogUtils";
import {oldRange,QuillCache, StickyNoteEmitter} from "../components/StickyNote/StickyNote";
import {StickyNoteTiptapCache} from "../components/StickyNote/StickyNoteTiptap";
import {TextTiptapCache} from "../components/TextTiptap/TextTiptap";
import {getFocusPointForConnection} from "../element/binding";
import {getSizeFromPoints} from "../points";
type Presets = Required<ColorPickerProps>["presets"][number];

const FONT_SIZE_RELATIVE_INCREASE_STEP = 0.1;
const ARRAY_FONT_SIZE=[];
for (let i=1;i<=50;i++){
  ARRAY_FONT_SIZE.push({
    label:i,
    key:i+''
  });
}

const ARRAY_STROKE_WIDTH = [];
for (let i=1;i<=12;i++){
  ARRAY_STROKE_WIDTH.push({
    label:i+'',
    value:i+'',
    key:i+''
  })
}

let mLastestAlphaColor='';
let mLastestA=0;
let mIsDropColor = false;
let mInputValue:any = 0;

// const isNumber = (inputStr)=>{
//   if (isStringNullOrEmpty(inputStr))return false;
//   const reg = /^-?\d*(\.\d*)?$/;
//   return (reg.test(inputStr));
// }

/**
 * 最近颜色
 */
const getLastestColors = ()=>{
  let arrayColors = [];
  const colors = localStorage.getItem("lastestColor");
  if (colors != null && colors !== ''){
    arrayColors = JSON.parse(colors);
  }
  return arrayColors;
}
//保存最近的颜色
const setLastestColors = (szNewHexColor:string)=>{
  let arrayColors = getLastestColors();
  //remove 重复的...
  for (let i=arrayColors.length-1;i>=0;i--){
    if (arrayColors[i].toLowerCase() === szNewHexColor.toLowerCase()){
      arrayColors.splice(i,1);
    }
  }
  let maxCount = arrayColors.length;
  if (maxCount > 17){
    maxCount = 17;
  }
  let arrayNewColors = [szNewHexColor];
  for (let i=0;i<maxCount;i++){
    arrayNewColors.push(arrayColors[i]);
  }
  localStorage.setItem("lastestColor",JSON.stringify(arrayNewColors));
}

export const changeProperty = (
  elements: readonly ExcalidrawElement[],
  appState: AppState,
  callback: (element: ExcalidrawElement) => ExcalidrawElement,
  includeBoundText = false,
) => {
  const selectedElementIds = arrayToMap(
    getSelectedElements(elements, appState, {
      includeBoundTextElement: includeBoundText,
    }),
  );

  return elements.map((element) => {
    // if (isTextElement(element)){
    //   if (selectedElementIds.get(element.id) ||
    //       element.id === appState.editingElement?.id || element.id === mEditingElement?.id) {
    //     return callback(element);
    //   }
    // }
    if (
      selectedElementIds.get(element.id) ||
      element.id === appState.editingElement?.id
    ) {
      return callback(element);
    }
    return element;
  });
};

export const getFormValue = function <T extends Primitive>(
  elements: readonly ExcalidrawElement[],
  appState: AppState,
  getAttribute: (element: ExcalidrawElement) => T,
  isRelevantElement: true | ((element: ExcalidrawElement) => boolean),
  defaultValue: T | ((isSomeElementSelected: boolean) => T),
): T {
  const editingElement = appState.editingElement;
  const nonDeletedElements = getNonDeletedElements(elements);

  let ret: T | null = null;

  if (editingElement) {
    ret = getAttribute(editingElement);
  }

  if (!ret) {
    const hasSelection = isSomeElementSelected(nonDeletedElements, appState);

    if (hasSelection) {
      ret =
        getCommonAttributeOfSelectedElements(
          isRelevantElement === true
            ? nonDeletedElements
            : nonDeletedElements.filter((el) => isRelevantElement(el)),
          appState,
          getAttribute,
        ) ??
        (typeof defaultValue === "function"
          ? defaultValue(true)
          : defaultValue);
    } else {
      ret =
        typeof defaultValue === "function" ? defaultValue(false) : defaultValue;
    }
  }

  return ret;
};


const offsetElementAfterFontResize = (
  prevElement: ExcalidrawTextElement,
  nextElement: ExcalidrawTextElement,
) => {
  if (isBoundToContainer(nextElement)) {
    return nextElement;
  }
  const nextWidth = nextElement.width;
  const preWidthSubNextWidth = (prevElement.width - nextWidth);
  const x = prevElement.textAlign === "left"
    ? prevElement.x
    : prevElement.x +
    preWidthSubNextWidth /
    (prevElement.textAlign === "center" ? 2 : 1);
  return mutateElement(
    nextElement,
    {
      x:x,
      // centering vertically is non-standard, but for Excalidraw I think
      // it makes sense
      y: prevElement.y + (prevElement.height - nextElement.height) / 2,
    },
    false,
  );
};

const changeFontSizeInOrDe = (
    elements: readonly ExcalidrawElement[],
    appState: AppState,
    getNewFontSize: (element: ExcalidrawTextElement) => number,
    fallbackValue?: ExcalidrawTextElement["fontSize"],
) => {
  const newFontSizes = new Set<number>();

  return {
    elements: changeProperty(
        elements,
        appState,
        (oldElement) => {
          if (isTextElement(oldElement) || isStickyNotesElement(oldElement)) {
            const newFontSize = getNewFontSize(oldElement);
            newFontSizes.add(newFontSize);

            //字体大小更改
            postMessage(EVENT_UPDATE_FONT_SIZE,{fontSize:newFontSize});

            let newElement: ExcalidrawTextElement = newElementWith(oldElement, {
              fontSize: newFontSize,
            });

            if (isTextElement(oldElement)){
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
            }

            newElement = offsetElementAfterFontResize(oldElement, newElement);

            return newElement;
          }

          return oldElement;
        },
        true,
    ),
    appState: {
      ...appState,
      // update state only if we've set all select text elements to
      // the same font size
      currentItemFontSize:
          newFontSizes.size === 1
              ? [...newFontSizes][0]
              : fallbackValue ?? appState.currentItemFontSize,
    },
    commitToHistory: true,
  };
};


// -----------------------------------------------------------------------------
 async function handleSvgFile(app,el, value) {
   if (!el)return;
  var extra = el.extra;
  var imageFile;
  if (isImageElement(el) && el.extra?.svg) {
    // el.fileId = generateUUID2();
    extra.svgText = changeSvgColor(el.extra.svgText, value.currentItemStrokeColor);
    imageFile = SVGStringToFile(await normalizeSVG(extra.svgText));
    const uuid = generateUUID2();
    el.fileId = uuid;//nanoid();//await generateIdFromFile(imageFile);
    // mutateElement(el,{fileId:uuid});

    const dataURL = await getDataURL(imageFile);

    var item = {
      mimeType: IMAGE_MIME_TYPES.svg,
      id: el.fileId,
      dataURL: dataURL,
      created: Date.now(),
      lastRetrieved: Date.now()
    }
    var arrayFuckEx = [];
    arrayFuckEx.push(item);
    app.addFiles(arrayFuckEx);
    await createImageToCache(app,el.fileId,dataURL);
  }
  console.log('handle svg end....');
  return el;
}

/*获取一个有效的颜色值*/
const getValidateHexColor = (szHex:string)=>{
  if (!szHex){
    return '#00000000';
  }
  let szHexColor = "#"+szHex.replace("#","");
  if (!isValidateHexColor(szHexColor)){
    szHexColor = "#000000";
  }
  return szHexColor;
}
const isWhiteColor = (szHexColor:string)=>{
  return "#FFF" == szHexColor.toUpperCase() ||
      "#FFFF" == szHexColor.toUpperCase() ||
      "#FFFFFF" == szHexColor.toUpperCase();
}

const isValidateHexColor = (szHexColor)=>{
  if (isStringNullOrEmpty(szHexColor))return false;
  return validHex(szHexColor) || szHexColor.toLowerCase() === 'transparent';
}

function createImageToCache(app,szFileId,szSrc){
   return new Promise((resolve, reject) => {
     const img = new Image();
     img.src = szSrc;
     img.onload = function (){
       app.imageCache.set(szFileId, {
         ...app.imageCache,
         image: img,
       });
       resolve();
     }
   })
}

/**
 *
 * @param arrayEles
 * @param nIndex
 * @param app
 * @param szHex
 * @param updateData
 * @param isOnlyStrokeColor 只处理边框颜色，不包括文字
 */
function recursionElement(arrayEles,nIndex,app,szHex,updateData,isOnlyStrokeColor=false){
  if (nIndex >= arrayEles.length)return;

  const element = arrayEles[nIndex];
  if (isOnlyStrokeColor && element.type == 'text'){
    if (nIndex < arrayEles.length){
      recursionElement(arrayEles,(nIndex+1),app,szHex,updateData,isOnlyStrokeColor);
    }
    return;
  }
  handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
    console.log('update......')
    setTimeout(()=>{
      if(element.type === 'highlighter'){
        updateData({currentItemHighlightStrokeColor:szHex})
      }else {
        if (res.extra?.svg){
          const newExtra = {...res.extra};
          updateData({id:res.id,currentItemStrokeColor:szHex,fileId:element.fileId,strokeWidth:0.9,strokeStyle:'none'})
        }else{
          updateData({id:res.id,currentItemStrokeColor:szHex})
        }

      }
      if (nIndex < arrayEles.length){
        recursionElement(arrayEles,(nIndex+1),app,szHex,updateData,isOnlyStrokeColor);
      }
    },100);
  })
}

export const actionChangeStrokeColor = register({
  name: "changeStrokeColor",
  trackEvent: false,
  perform: (elements, appState, value,app) => {

    return {
      elements: changeProperty(
          elements,
          appState, (el:any) => {
            if ("id" in value){
              if (el.id != value.id)return el;
            }
            //只改变边框，不改文字颜色....
            if (el.type == 'text')return el;

            let szStrokeColor = value.currentItemStrokeColor;
            // if (el.type === 'highlighter'){
            //   value.currentItemHighlightStrokeColor = value.currentItemStrokeColor;
            //   delete value.currentItemStrokeColor;
            // }

            if (isValidateHexColor(szStrokeColor)){
              value.strokeColor = szStrokeColor;
            }
            if (el.extra?.svg){
              if(!value.hasOwnProperty("extra")){
                value.extra = {};
              }
              value.extra.svg = true;
              value.extra.svgText = el.extra.svgText;
              value.hasUpdate = true;//标记有更新
            }
            return (hasStrokeColor(el.type) || el.extra?.svg)
                ? newElementWith(el, value)
                : el;
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemStrokeColor,
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps ,app}) => (
    <>
      <div className='flex-row-vertical-center'>
        <Checkbox style={{marginLeft:'-8px',display:getFormValue(elements,appState,
              (element) =>(isTextElement(element))?'none':'inherit',true,appState.activeTool.type === 'highlighter'?appState.currentItemHighlightStrokeColor:appState.currentItemStrokeColor)}}
                  className='mr-8' onChange={(e)=>{
          const isChecked = e.target.checked;
          if (appState.activeTool.type === 'freedraw'){
            return;
          }
          const arrayElements = getSelectedElements(elements,appState);
          if (arrayElements.length > 0){
            const firstEle = arrayElements[0];
            if (firstEle.type == 'image' && firstEle.extra?.svg) {
              //svg禁止取消勾选
              return;
            }
            if (isFreeDrawElement(firstEle)){
              return;
            }
          }
          if (isChecked){
            updateData({currentItemStrokeColor:'#000000'});
          }else{
            updateData({currentItemStrokeColor:'TRANSPARENT'});
          }
        }}
                  checked={
                    getFormValue(elements,appState,(element) =>element.strokeColor.toLowerCase() !== 'transparent',true,appState.currentItemStrokeColor !== 'transparent')
                  }

        />

        <Popover trigger={"click"} placement={"bottom"}
                 onOpenChange={(e)=>{
                   //隐藏...不会触发
                   // const arraySelectedElements = getSelectedElements(elements,appState);
                   // if (arraySelectedElements.length == 1) {
                   //   const element = arraySelectedElements[0];
                   //   if (element.type === "highlighter") {
                   //     updateData({currentItemHighlightStrokeColor:element.strokeColor,extra:element.extra});
                   //   }else {
                   //     updateData({currentItemStrokeColor:element.strokeColor,extra:element.extra});
                   //   }
                   // }else {
                   //   updateData({extra:{}});
                   // }
                 }}
                 content={
          <div className='font-size-12' style={{margin:'-16px',padding:'18px 15px',width:'248px'}}>
            <span>{i18next.t("palette")}</span>
            <div className='mt-2' style={{display:'flex',flexWrap:'wrap',justifyContent:'space-around'}}>
              {
                ARRAY_COLORS.map(item => <div key={generateUUID2()} data-color={item} style={{width: '20px', height: '20px',margin:'3px 2px',
                  backgroundColor: item,borderRadius:'2px',border:("#FFFFFF" === item)?'1px solid #E6E3EE':'0px'}} onClick={(e)=>{
                  let szHex = e.currentTarget.dataset.color;
                  const arraySel = getSelectedElements(elements,appState);
                  if(arraySel.length > 0) {

                    // for (let i=0;i<arraySel.length;i++) {
                    //   const element = arraySel[i];
                    //   handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
                    //     console.log('update......')
                    //     setTimeout(()=>{
                    //       if(element.type === 'highlighter'){
                    //         updateData({currentItemHighlightStrokeColor:szHex})
                    //       }else {
                    //         updateData({id:res.id,currentItemStrokeColor:szHex})
                    //       }
                    //     },100);
                    //   })
                    // }
                    recursionElement(arraySel,0,app,szHex,updateData,true);

                  }else{
                    if (appState.activeTool.type === 'highlighter') {
                      updateData({currentItemHighlightStrokeColor:szHex})
                    }else {
                      updateData({currentItemStrokeColor:szHex})
                    }
                  }
                  setLastestColors(szHex as string);
                }}></div>)
              }
            </div>
            {/*{ h: 0, s: 0, v: 0, a: 1 }*/}
            <div style={{height:'6px'}}></div>
            <div className='flex-row-vertical-center' style={{width:'100%'}}>
              <div className='flex-center'
                   style={{width:'26px',height:'26px',
                     backgroundColor:getFormValue(elements,appState,(element) =>element.extra?.dropColorClick?'#efefef':'transparent',true,appState?.extra?.dropColorClick?'#efefef':'transparent')}}>
                {
                  getFormValue(elements,appState,
                      (element) =>element.extra?.hasDropColor == true,
                      true,
                      false) && mIsDropColor &&
                  <EyeDropper onCancel={()=>{
                    const arraySel = getSelectedElements(elements,appState);
                    if(arraySel.length > 0){
                      const element = arraySel[0];
                      handleSvgFile(app,element,{currentItemStrokeColor: element.strokeColor,extra:{hasDropColor:false,dropColorClick:false}}).then(res=>{
                        if (element.type === 'highlighter'){
                          updateData({currentItemHighlightStrokeColor: element.strokeColor,extra:{...element.extra,hasDropColor:false,dropColorClick:false}})
                        }else{
                          updateData({currentItemStrokeColor: element.strokeColor,extra:{...element.extra,hasDropColor:false,dropColorClick:false}})
                        }
                      })
                    }
                  }}
                              onSelect={(color, event) =>{
                                const arraySel = getSelectedElements(elements,appState);
                                if(arraySel.length > 0) {
                                  const element = arraySel[0];
                                  mIsDropColor = false;
                                  updateData({currentItemStrokeColor: color,extra:{...element.extra,hasDropColor:false,dropColorClick:false}})
                                  handleSvgFile(app,element,{currentItemStrokeColor: color,extra:{...element.extra,hasDropColor:false,dropColorClick:false}}).then(res=>{
                                    app.refreshElement(element,{currentItemStrokeColor: color,extra:{...element.extra,hasDropColor:false,dropColorClick:false}});
                                    updateData({currentItemStrokeColor: color,extra:{...element.extra,hasDropColor:false,dropColorClick:false}})
                                  })
                                }else{
                                  updateData({currentItemStrokeColor: color,extra:{hasDropColor:false,dropColorClick:false}})
                                }

                                setLastestColors(color as string);
                              }} onChange={()=>{

                  }} colorPickerType={"elementStroke"}>

                  </EyeDropper>
                }
                <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')} onClick={()=>{
                  const arraySel = getSelectedElements(elements,appState);
                  if(arraySel.length > 0){
                    const element = arraySel[0];
                    mIsDropColor = true;
                    handleSvgFile(app,element,{currentItemStrokeColor: element.strokeColor,extra:{...element.extra,hasDropColor:true,dropColorClick:true}}).then(res=>{
                      if (element.type === "highlighter"){
                        updateData({currentItemHighlightStrokeColor: element.strokeColor,extra:{...element.extra,hasDropColor:true,dropColorClick:true}})
                      }else {
                        updateData({currentItemStrokeColor: element.strokeColor,extra:{...element.extra,hasDropColor:true,dropColorClick:true}})
                      }
                    })
                  }else {
                    if (appState.activeTool.type === "highlighter") {
                      updateData({currentItemHighlightStrokeColor: appState.currentItemHighlightStrokeColor,extra:{hasDropColor:true,dropColorClick:true}})
                    }else {
                      updateData({currentItemStrokeColor: appState.currentItemStrokeColor,extra:{hasDropColor:true,dropColorClick:true}})
                    }
                  }
                }
                }/>
              </div>

              <Alpha style={{flexGrow:'1',marginLeft:'10px'}}
                  hsva={
                    getFormValue(elements,appState,(element) =>hexToHsva(element.strokeColor.toUpperCase()),true,hexToHsva(appState.currentItemStrokeColor))
                  }
                  onChange={(newShade) => {
                    let szHexColor = hsvaToHexa(newShade as HsvaColor);
                    if (mLastestA != Math.floor(newShade.a*100) ){
                      const arraySel = getSelectedElements(elements,appState);
                      if(arraySel.length > 0) {
                        // const element = arraySel[0];
                        // handleSvgFile(app,element,{currentItemStrokeColor: szHexColor,extra:element.extra}).then(res=>{
                        //   if(element.type === 'highlighter'){
                        //     updateData({currentItemHighlightStrokeColor: szHexColor,extra:element.extra})
                        //   }else {
                        //     updateData({currentItemStrokeColor: szHexColor,extra:element.extra})
                        //   }
                        // })
                        recursionElement(arraySel,0,app,szHexColor,updateData,true);
                      }else{
                        if (appState.activeTool.type === 'highlighter') {
                          updateData({currentItemHighlightStrokeColor: szHexColor})
                        }else {
                          updateData({currentItemStrokeColor: szHexColor})
                        }
                      }
                      mLastestAlphaColor = szHexColor;
                      mLastestA = Math.floor(newShade.a*100);
                    }
                  }}
              />
            </div>

            <div style={{marginTop:'12px',width:'100%'}}>
              <span>HEX</span>
              <input readOnly={false} className={'input-border'}
                     style={{flexGrow:'1',borderRadius: '4px',outline:'none',margin:'0 16px',height:'24px',textAlign:'center',width:'130px'}}
                     value={
                       getFormValue(elements,appState,(element) =>{
                         return element.extra?.hasOwnProperty("tempItemStrokeColor")?element.extra?.tempItemStrokeColor.toUpperCase():element.strokeColor.toUpperCase()
                       },
                           true,
                           appState?.extra?.tempItemStrokeColor || appState.currentItemStrokeColor)
                     }

                     onChange={(e)=>{
                       /*
                       const szHexColor = "#"+e.currentTarget.value.replace("#","");

                       const arraySelectedElements = getSelectedElements(elements,appState);
                       if (arraySelectedElements.length > 0) {
                         const element = arraySelectedElements[0];
                         if(validHex(szHexColor)){
                           //保存到最近
                           setLastestColors(szHexColor as string);
                           handleSvgFile(app,element,{currentItemStrokeColor:szHexColor}).then(res=>{
                             updateData({currentItemStrokeColor:szHexColor,extra:{tempItemStrokeColor:szHexColor}});
                           })
                         }else{
                           let szOriHex='TRANSPARENT';
                           const arraySelectedElements = getSelectedElements(elements,appState);

                           if (arraySelectedElements.length > 0) {
                             const element = arraySelectedElements[0];
                             szOriHex = element.strokeColor;
                           }
                           handleSvgFile(app,element,{currentItemStrokeColor:szOriHex,extra:{tempItemStrokeColor:szHexColor}}).then(res=>{
                             updateData({currentItemStrokeColor:szOriHex,extra:{tempItemStrokeColor:szHexColor}})
                           })
                         }
                       }*/
                       mInputValue = e.currentTarget.value;

                       const arraySelectedElements = getSelectedElements(elements,appState);
                       for (let i=0;i<arraySelectedElements.length;i++) {
                         updateData({id:arraySelectedElements[i].id,extra:{tempItemStrokeColor:e.currentTarget.value}});
                       }

                     }}

                     onFocus={(event => {
                       mInputValue = (event.currentTarget.value)
                       event.currentTarget.select();
                       app.onPointDownEvent((activeTool,pointerDownState)=>{
                         setLastestColors(getValidateHexColor(mInputValue));
                         const arraySelectedElements = getSelectedElements(elements,appState);
                         if (arraySelectedElements.length > 0) {
                           // const element = arraySelectedElements[0];
                           // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                           //   if (element.type === 'highlighter'){
                           //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           //   }else{
                           //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           //   }
                           // })
                           recursionElement(arraySelectedElements,0,app,getValidateHexColor(mInputValue),updateData,true);
                         }else{
                           if (appState.activeTool.type === 'highlighter'){
                             updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           }else{
                             updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           }
                         }

                         app.onPointDownEvent(null);
                       });
                     })}
                     onBlur={(event => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       const arraySelectedElements = getSelectedElements(elements,appState);
                       if (arraySelectedElements.length > 0) {
                         // const element = arraySelectedElements[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                         //   if (element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }else{
                         //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }
                         // })
                         recursionElement(arraySelectedElements,0,app,getValidateHexColor(mInputValue),updateData,true);
                       }else{
                         if (appState.activeTool.type === 'highlighter'){
                           updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         }else{
                           updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         }
                       }

                     })}
                     onKeyDown={(event => {
                       if (event.key === KEYS.ENTER){
                         let szHexColor = getValidateHexColor(event.currentTarget.value)
                         setLastestColors(szHexColor);
                         const arraySelectedElements = getSelectedElements(elements,appState);
                         if (arraySelectedElements.length > 0) {
                           // const element = arraySelectedElements[0];
                           // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                           //   if (element.type === 'highlighter'){
                           //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           //   }else{
                           //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           //   }
                           // })
                           recursionElement(arraySelectedElements,0,app,getValidateHexColor(mInputValue),updateData,true);
                         }else{
                           if (appState.activeTool.type === 'highlighter'){
                             updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           }else{
                             updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                           }
                         }

                         event.currentTarget.blur();
                       }
                     })}
              />
              <span>
                {
                  getFormValue(elements,appState,(element) =>Math.floor(hexToRgba(element.strokeColor.toUpperCase()).a*100)+'%',true,Math.floor(hexToRgba(appState.activeTool.type === 'highlighter'?appState.currentItemHighlightStrokeColor:appState.currentItemStrokeColor).a*100)+'%')
                }
              </span>
            </div>
            <div className='line' style={{margin:'12px 0'}}></div>

            <span className='text-color-a'>{i18next.t("lastestUse")}</span>
            <div style={{display:'flex',flexWrap:'wrap'}}>
              {
                getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{width: '20px', height: '20px',margin:'3px 2px',
                  backgroundColor: item,borderRadius:'2px',border:isWhiteColor(item)?'1px solid #E6E3EE':'0px'}} onClick={(e)=>{
                  let szHex = e.currentTarget.dataset.color;
                  const arraySelectedElements = getSelectedElements(elements,appState);
                  if (arraySelectedElements.length > 0) {
                    // const element = arraySelectedElements[0];
                    // handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
                    //   console.log('update......')
                    //   setTimeout(()=>{
                    //     if (element.type === 'highlighter'){
                    //       updateData({currentItemHighlightStrokeColor:szHex})
                    //     }else{
                    //       updateData({currentItemStrokeColor:szHex})
                    //     }
                    //
                    //   },50)
                    // })
                    recursionElement(arraySelectedElements,0,app,szHex,updateData);
                  }else{
                    if (appState.activeTool.type === 'highlighter') {
                      updateData({currentItemHighlightStrokeColor:szHex})
                    }else {
                      updateData({currentItemStrokeColor:szHex})
                    }
                  }
                }}></div>)
              }
            </div>
          </div>
        }>
          <div className='hovered' style={{width:'16px',height:'16px',border:'1px solid #efefef',
            backgroundColor:getFormValue(elements,appState,(element) =>element.strokeColor,true,appState.activeTool.type === 'highlighter'?appState.currentItemHighlightStrokeColor:appState.currentItemStrokeColor)}}>
          </div>
        </Popover>

      </div>
      {/*<h3 aria-hidden="true">{i18next.t("labels.stroke")}</h3>*/}
      {/*<ColorPicker*/}
      {/*  topPicks={DEFAULT_ELEMENT_STROKE_PICKS}*/}
      {/*  palette={DEFAULT_ELEMENT_STROKE_COLOR_PALETTE}*/}
      {/*  type="elementStroke"*/}
      {/*  label={i18next.t("labels.stroke")}*/}
      {/*  color={getFormValue(*/}
      {/*    elements,*/}
      {/*    appState,*/}
      {/*    (element) => element.strokeColor,*/}
      {/*    true,*/}
      {/*    appState.currentItemStrokeColor,*/}
      {/*  )}*/}
      {/*  onChange={(color) => updateData({ currentItemStrokeColor: color })}*/}
      {/*  elements={elements}*/}
      {/*  appState={appState}*/}
      {/*  updateData={updateData}*/}
      {/*/>*/}
    </>
  ),
});


export const actionChangeStrokeColorPopover = register({
  name: "changeStrokeColorPopover",
  trackEvent: false,
  perform: (elements, appState, value,app) => {

    return {
      elements: changeProperty(
          elements,
          appState, (el:any) => {
            if ("id" in value){
              if (el.id != value.id)return el;
            }
            let szStrokeColor = value.currentItemStrokeColor;
            if (el.type == 'highlighter'){
              szStrokeColor = value.currentItemHighlightStrokeColor;
            }
            if (isValidateHexColor(szStrokeColor)){
              value.strokeColor = szStrokeColor;
              //这里有些元素要设置为固定值了。。。。
              if (!el.extra?.svg){
                if (el.strokeWidth < 1 || isAnnoElement(el) || isEmbedableBookmarkElement(el)){
                  value.strokeWidth = DEFAULT_ELEMENT_STROKE_WITHD;
                }
                if (!el.strokeStyle || el.strokeStyle == 'none'){
                  value.strokeStyle = 'solid';
                }
              }

              if (isNoteElement(el)){
                let jsonConfig:any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
                if (jsonConfig){
                  jsonConfig = JSON.parse(jsonConfig);
                }else{
                  jsonConfig = {};
                }
                jsonConfig.strokeColor = value.strokeColor;
                localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(jsonConfig));
              }
            }

            if (el.extra?.svg){
              if(!value.hasOwnProperty("extra")){
                value.extra = {};
              }
              value.extra.svg = true;
              value.extra.svgText = el.extra.svgText;
              value.hasUpdate = true;//标记有更新
            }
            postMessage(EVENT_STROKE_COLOR_CHANGE, {strokeColor:value.strokeColor})
            return (hasStrokeColor(el.type) || el.extra?.svg)
                ? newElementWith(el, value)
                : el;
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemStrokeColor,
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps ,app}) => {
    const getDefaultStrokeColor = ()=> {
      return getFormValue(elements, appState, (element) => {
            return element.extra?.hasOwnProperty("tempItemStrokeColor") ? element.extra?.tempItemStrokeColor?.toUpperCase() : element.strokeColor?.toUpperCase()
          },
          true,
          appState?.extra?.tempItemStrokeColor || appState.currentItemStrokeColor);
    }

    const [strokeColor,setStrokeColor] = useState(getDefaultStrokeColor());
    const [isDropdownColor,setIsDropdownColor] = useState(false);

    return(
        <div className='font-size-12 popover-box-shadow'
             style={{margin: '-12px', padding: '18px 15px', width: '248px'}}>
          <span>{i18next.t("Default colors")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '2px'}}>
            {
              ARRAY_DEFAULT_BORDER_COLORS.map(item => <div className={'cursor-pointer'} key={generateUUID2()}
                                                    data-color={item} style={{
                width: '20px',
                height: '20px',
                margin: '3px 2px',
                backgroundColor: item,
                borderRadius: '10px',
                border: ("#FFFFFF" === item || "transparent1" === item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setStrokeColor(szHex);
                const arraySel = getSelectedElements(elements, appState);
                if (arraySel.length > 0) {
                  recursionElement(arraySel, 0, app, szHex, updateData, true);

                } else {
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: szHex})
                  } else {
                    updateData({currentItemStrokeColor: szHex})
                  }
                }
                setLastestColors(szHex as string);
              }}>

                {
                  (item == 'transparent' || item == '#00000001') &&
                    <img className={'img-20'} src={getImagePathWithTheme('no_color')}/>
                }

              </div>)
            }
          </div>
          <div className={'line'} style={{margin: '10px 0'}}></div>

          <span>{i18next.t("palette")}</span>
          <div className='mt-2' style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around'}}>
            {
              ARRAY_COLORS.map(item => <div key={generateUUID2()} className={'cursor-pointer'} data-color={item} style={{
                width: '20px', height: '20px', margin: '3px 2px',
                backgroundColor: item, borderRadius: '2px', border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setStrokeColor(szHex);
                const arraySel = getSelectedElements(elements, appState);
                if (arraySel.length > 0) {

                  // for (let i=0;i<arraySel.length;i++) {
                  //   const element = arraySel[i];
                  //   handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
                  //     console.log('update......')
                  //     setTimeout(()=>{
                  //       if(element.type === 'highlighter'){
                  //         updateData({currentItemHighlightStrokeColor:szHex})
                  //       }else {
                  //         updateData({id:res.id,currentItemStrokeColor:szHex})
                  //       }
                  //     },100);
                  //   })
                  // }
                  recursionElement(arraySel, 0, app, szHex, updateData, true);

                } else {
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: szHex})
                  } else {
                    updateData({currentItemStrokeColor: szHex})
                  }
                }
                setLastestColors(szHex as string);
              }}></div>)
            }
          </div>
          {/*{ h: 0, s: 0, v: 0, a: 1 }*/}
          <div style={{height: '6px'}}></div>
          <div className='flex-row-vertical-center' style={{width: '100%'}}>
            <div className='flex-center'
                 style={{
                   width: '26px', height: '26px',
                   backgroundColor: isDropdownColor ? '#efefef' : 'transparent'
                 }}>
              {
                // isDropColor &&
                //  <EyeDropper onCancel={() => {
                //    setIsDropColor(false);
                //    const arraySel = getSelectedElements(elements, appState);
                //    if (arraySel.length > 0) {
                //      const element = arraySel[0];
                //      handleSvgFile(app, element, {
                //        currentItemStrokeColor: element.strokeColor,
                //        extra: {hasDropColor: false, dropColorClick: false}
                //      }).then(res => {
                //        if (element.type === 'highlighter') {
                //          updateData({
                //            currentItemHighlightStrokeColor: element.strokeColor,
                //            extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //          })
                //        } else {
                //          updateData({
                //            currentItemStrokeColor: element.strokeColor,
                //            extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //          })
                //        }
                //      })
                //    }
                //  }}
                //              onSelect={(color, event) => {
                //                const arraySel = getSelectedElements(elements, appState);
                //                if (arraySel.length > 0) {
                //                  const element = arraySel[0];
                //                  mIsDropColor = false;
                //                  updateData({
                //                    currentItemStrokeColor: color,
                //                    extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //                  })
                //                  handleSvgFile(app, element, {
                //                    currentItemStrokeColor: color,
                //                    extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //                  }).then(res => {
                //                    app.refreshElement(element, {
                //                      currentItemStrokeColor: color,
                //                      extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //                    });
                //                    updateData({
                //                      currentItemStrokeColor: color,
                //                      extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                //                    })
                //                  })
                //                } else {
                //                  updateData({
                //                    currentItemStrokeColor: color,
                //                    extra: {hasDropColor: false, dropColorClick: false}
                //                  })
                //                }
                //
                //                setLastestColors(color as string);
                //              }} onChange={() => {
                //
                //  }} colorPickerType={"elementStroke"}>
                //
                //  </EyeDropper>
              }
              <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')}
                   onClick={async () => {
                     setIsDropdownColor(true);
                     const eyeDropper = new (window as any).EyeDropper();
                     try {
                       const result = await eyeDropper.open();
                       console.log(result.sRGBHex)
                       setIsDropdownColor(false);
                       setStrokeColor(result.sRGBHex);
                       setLastestColors(result.sRGBHex);
                       if (appState.activeTool.type === 'highlighter') {
                         updateData({currentItemHighlightStrokeColor: result.sRGBHex})
                       } else {
                         updateData({currentItemStrokeColor: result.sRGBHex})
                       }
                     } catch (err) {
                       setIsDropdownColor(false);
                     }
                   }}/>
            </div>

            <Alpha style={{flexGrow: '1', marginLeft: '10px'}}
                   hsva={hexToHsva(isValidateHexColor(strokeColor) ? strokeColor : getDefaultStrokeColor())}//// getFormValue(elements, appState, (element) => hexToHsva(element.strokeColor.toUpperCase()), true, hexToHsva(appState.currentItemStrokeColor))
                   onChange={(newShade) => {

                     let szHexColor = hsvaToHexa(newShade as HsvaColor);
                     setStrokeColor(szHexColor);
                     if (mLastestA != Math.floor(newShade.a * 100)) {
                       const arraySel = getSelectedElements(elements, appState);
                       if (arraySel.length > 0) {
                         // const element = arraySel[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor: szHexColor,extra:element.extra}).then(res=>{
                         //   if(element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor: szHexColor,extra:element.extra})
                         //   }else {
                         //     updateData({currentItemStrokeColor: szHexColor,extra:element.extra})
                         //   }
                         // })
                         recursionElement(arraySel, 0, app, szHexColor, updateData, true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: szHexColor})
                         } else {
                           updateData({currentItemStrokeColor: szHexColor})
                         }
                       }
                       mLastestAlphaColor = szHexColor;
                       mLastestA = Math.floor(newShade.a * 100);
                     }
                   }}
            />
          </div>

          <div style={{marginTop: '12px', width: '100%'}}>
            <span>HEX</span>
            <input className={'input-border'} readOnly={false} style={{
              flexGrow: '1',
              borderRadius: '4px',
              outline: 'none',
              margin: '0 16px',
              height: '24px',
              textAlign: 'center',
              width: '130px',
            }}
                   value={strokeColor}

                   onChange={(e) => {
                     /*
                     const szHexColor = "#"+e.currentTarget.value.replace("#","");

                     const arraySelectedElements = getSelectedElements(elements,appState);
                     if (arraySelectedElements.length > 0) {
                       const element = arraySelectedElements[0];
                       if(validHex(szHexColor)){
                         //保存到最近
                         setLastestColors(szHexColor as string);
                         handleSvgFile(app,element,{currentItemStrokeColor:szHexColor}).then(res=>{
                           updateData({currentItemStrokeColor:szHexColor,extra:{tempItemStrokeColor:szHexColor}});
                         })
                       }else{
                         let szOriHex='TRANSPARENT';
                         const arraySelectedElements = getSelectedElements(elements,appState);

                         if (arraySelectedElements.length > 0) {
                           const element = arraySelectedElements[0];
                           szOriHex = element.strokeColor;
                         }
                         handleSvgFile(app,element,{currentItemStrokeColor:szOriHex,extra:{tempItemStrokeColor:szHexColor}}).then(res=>{
                           updateData({currentItemStrokeColor:szOriHex,extra:{tempItemStrokeColor:szHexColor}})
                         })
                       }
                     }*/
                     mInputValue = e.currentTarget.value;
                     setStrokeColor(mInputValue);
                     // if (validHex(mInputValue)) {
                     //   const arraySelectedElements = getSelectedElements(elements, appState);
                     //   for (let i = 0; i < arraySelectedElements.length; i++) {
                     //     updateData({
                     //       id: arraySelectedElements[i].id,
                     //       extra: {tempItemStrokeColor: e.currentTarget.value}
                     //     });
                     //   }
                     // }
                   }}

                   onFocus={(event => {
                     mInputValue = (event.currentTarget.value)
                     event.currentTarget.select();
                     app.onPointDownEvent((activeTool, pointerDownState) => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       const arraySelectedElements = getSelectedElements(elements, appState);
                       if (arraySelectedElements.length > 0) {
                         // const element = arraySelectedElements[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                         //   if (element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }else{
                         //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }
                         // })
                         recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData, true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         } else {
                           updateData({currentItemStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         }
                       }

                       app.onPointDownEvent(null);
                     });
                   })}
                   onBlur={(event => {
                     setLastestColors(getValidateHexColor(mInputValue));
                     const arraySelectedElements = getSelectedElements(elements, appState);
                     if (arraySelectedElements.length > 0) {
                       // const element = arraySelectedElements[0];
                       // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                       //   if (element.type === 'highlighter'){
                       //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                       //   }else{
                       //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                       //   }
                       // })
                       recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData, true);
                     } else {
                       if (appState.activeTool.type === 'highlighter') {
                         updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                       } else {
                         updateData({currentItemStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                       }
                     }

                   })}
                   onKeyDown={(event => {
                     if (event.key === KEYS.ENTER) {
                       let szHexColor = getValidateHexColor(event.currentTarget.value)
                       setLastestColors(szHexColor);
                       const arraySelectedElements = getSelectedElements(elements, appState);
                       if (arraySelectedElements.length > 0) {
                         // const element = arraySelectedElements[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                         //   if (element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }else{
                         //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }
                         // })
                         recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData, true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         } else {
                           updateData({currentItemStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         }
                       }

                       event.currentTarget.blur();
                     }
                   })}
            />
            <span>
                {
                  getFormValue(elements, appState, (element) => Math.floor(hexToRgba((element.strokeColor)?.toUpperCase()).a * 100) + '%', true, Math.floor(hexToRgba(appState.activeTool.type === 'highlighter' ? appState.currentItemHighlightStrokeColor : appState.currentItemStrokeColor).a * 100) + '%')
                }
              </span>
          </div>
          <div className='line' style={{margin: '12px 0'}}></div>

          <span className='text-color-a'>{i18next.t("lastestUse")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              getLastestColors().map(item => <div key={generateUUID2()} data-color={item} className={'cursor-pointer'} style={{
                width: '20px', height: '20px', margin: '3px 2px',
                backgroundColor: item, borderRadius: '2px', border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setStrokeColor(szHex);
                const arraySelectedElements = getSelectedElements(elements, appState);
                if (arraySelectedElements.length > 0) {
                  // const element = arraySelectedElements[0];
                  // handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
                  //   console.log('update......')
                  //   setTimeout(()=>{
                  //     if (element.type === 'highlighter'){
                  //       updateData({currentItemHighlightStrokeColor:szHex})
                  //     }else{
                  //       updateData({currentItemStrokeColor:szHex})
                  //     }
                  //
                  //   },50)
                  // })
                  recursionElement(arraySelectedElements, 0, app, szHex, updateData, true);
                } else {
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: szHex})
                  } else {
                    updateData({currentItemStrokeColor: szHex})
                  }
                }
              }}></div>)
            }
          </div>
        </div>
    )
  },
});

export const actionChangeDrawStrokeColorPopover = register({
  name: "changeDrawStrokeColorPopover",
  trackEvent: false,
  perform: (elements, appState, value, app) => {

    return {
      elements: changeProperty(
          elements,
          appState, (el: any) => {
            if ("id" in value) {
              if (el.id != value.id) return el;
            }
            let szStrokeColor = value.currentItemDrawStrokeColor;
            if (isValidateHexColor(szStrokeColor)) {
              value.strokeColor = szStrokeColor;
            }
            if (el.extra?.svg) {
              if (!value.hasOwnProperty("extra")) {
                value.extra = {};
              }
              value.extra.svg = true;
              value.extra.svgText = el.extra.svgText;
              value.hasUpdate = true;//标记有更新
            }
            return (hasStrokeColor(el.type) || el.extra?.svg)
                ? newElementWith(el, value)
                : el;
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemDrawStrokeColor,
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps ,app}) => {
    const getDefaultDrawStrokeColor = getFormValue(elements, appState, (element) => {
          return element.extra?.hasOwnProperty("tempItemStrokeColor") ? element.extra?.tempItemStrokeColor.toUpperCase() : element.strokeColor.toUpperCase()
        },
        true,
        appState?.extra?.tempItemStrokeColor || appState.currentItemDrawStrokeColor);

    const [isDropdownColor,setIsDropdownColor] = useState(false);
    const [drawStrokeColor,setDrawStrokeColor] = useState(getDefaultDrawStrokeColor);
    return (
        <div className='font-size-12 popover-box-shadow' style={{margin: '-16px', padding: '18px 15px', width: '248px'}}>
          <span>{i18next.t("palette")}</span>
          <div className='mt-2' style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around'}}>
            {
              ARRAY_COLORS.map(item => <div key={generateUUID2()} data-color={item} style={{
                width: '20px', height: '20px', margin: '3px 2px',
                backgroundColor: item, borderRadius: '2px', border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                const arraySel = getSelectedElements(elements, appState);
                if (arraySel.length > 0) {

                  // for (let i=0;i<arraySel.length;i++) {
                  //   const element = arraySel[i];
                  //   handleSvgFile(app,element,{currentItemStrokeColor:szHex}).then(res=>{
                  //     console.log('update......')
                  //     setTimeout(()=>{
                  //       if(element.type === 'highlighter'){
                  //         updateData({currentItemHighlightStrokeColor:szHex})
                  //       }else {
                  //         updateData({id:res.id,currentItemStrokeColor:szHex})
                  //       }
                  //     },100);
                  //   })
                  // }
                  recursionElement(arraySel, 0, app, szHex, updateData,true);

                } else {
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: szHex})
                  } else {
                    updateData({currentItemDrawStrokeColor: szHex})
                  }
                }
                setDrawStrokeColor(szHex);
                setLastestColors(szHex as string);
              }}></div>)
            }
          </div>
          {/*{ h: 0, s: 0, v: 0, a: 1 }*/}
          <div style={{height: '6px'}}></div>
          <div className='flex-row-vertical-center' style={{width: '100%'}}>
            <div className='flex-center'
                 style={{
                   width: '26px', height: '26px',
                   backgroundColor: isDropdownColor ? '#efefef' : 'transparent'
                 }}>
              {
                  // getFormValue(elements, appState,
                  //     (element) => element.extra?.hasDropColor == true,
                  //     true,
                  //     false) && mIsDropColor &&
                  // <EyeDropper onCancel={() => {
                  //   const arraySel = getSelectedElements(elements, appState);
                  //   if (arraySel.length > 0) {
                  //     const element = arraySel[0];
                  //     if (element.type === 'highlighter') {
                  //       updateData({
                  //         currentItemHighlightStrokeColor: element.strokeColor,
                  //         extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                  //       })
                  //     } else {
                  //       updateData({
                  //         currentItemDrawStrokeColor: element.strokeColor,
                  //         extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                  //       })
                  //     }
                  //   }
                  // }}
                  //             onSelect={(color, event) => {
                  //               const arraySel = getSelectedElements(elements, appState);
                  //               if (arraySel.length > 0) {
                  //                 const element = arraySel[0];
                  //                 mIsDropColor = false;
                  //                 updateData({
                  //                   currentItemDrawStrokeColor: color,
                  //                   extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                  //                 })
                  //                 app.refreshElement(element, {
                  //                   currentItemDrawStrokeColor: color,
                  //                   extra: {...element.extra, hasDropColor: false, dropColorClick: false}
                  //                 });
                  //               } else {
                  //                 updateData({
                  //                   currentItemDrawStrokeColor: color,
                  //                   extra: {hasDropColor: false, dropColorClick: false}
                  //                 })
                  //               }
                  //
                  //               setLastestColors(color as string);
                  //             }} onChange={() => {
                  //
                  // }} colorPickerType={"elementStroke"}>
                  //
                  // </EyeDropper>
              }
              <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')} onClick={async () => {
                // const arraySel = getSelectedElements(elements, appState);
                // if (arraySel.length > 0) {
                //   const element = arraySel[0];
                //   mIsDropColor = true;
                //   handleSvgFile(app, element, {
                //     currentItemStrokeColor: element.strokeColor,
                //     extra: {...element.extra, hasDropColor: true, dropColorClick: true}
                //   }).then(res => {
                //     if (element.type === "highlighter") {
                //       updateData({
                //         currentItemHighlightStrokeColor: element.strokeColor,
                //         extra: {...element.extra, hasDropColor: true, dropColorClick: true}
                //       })
                //     } else {
                //       updateData({
                //         currentItemDrawStrokeColor: element.strokeColor,
                //         extra: {...element.extra, hasDropColor: true, dropColorClick: true}
                //       })
                //     }
                //   })
                // } else {
                //   if (appState.activeTool.type === "highlighter") {
                //     updateData({
                //       currentItemHighlightStrokeColor: appState.currentItemHighlightStrokeColor,
                //       extra: {hasDropColor: true, dropColorClick: true}
                //     })
                //   } else {
                //     updateData({
                //       currentItemDrawStrokeColor: appState.currentItemStrokeColor,
                //       extra: {hasDropColor: true, dropColorClick: true}
                //     })
                //   }
                // }
                setIsDropdownColor(true);
                const eyeDropper = new (window as any).EyeDropper();
                try {
                  const result = await eyeDropper.open();
                  console.log(result.sRGBHex)
                  setIsDropdownColor(false);
                  setDrawStrokeColor(result.sRGBHex);
                  setLastestColors(result.sRGBHex);
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: result.sRGBHex})
                  } else {
                    updateData({currentItemDrawStrokeColor: result.sRGBHex})
                  }
                }catch (err) {
                  setIsDropdownColor(false);
                }
              }
              }/>
            </div>

            <Alpha style={{flexGrow: '1', marginLeft: '10px'}}
                   hsva={hexToHsva(drawStrokeColor)}
                   onChange={(newShade) => {
                     let szHexColor = hsvaToHexa(newShade as HsvaColor);
                     if (mLastestA != Math.floor(newShade.a * 100)) {
                       const arraySel = getSelectedElements(elements, appState);
                       if (arraySel.length > 0) {
                         // const element = arraySel[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor: szHexColor,extra:element.extra}).then(res=>{
                         //   if(element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor: szHexColor,extra:element.extra})
                         //   }else {
                         //     updateData({currentItemStrokeColor: szHexColor,extra:element.extra})
                         //   }
                         // })
                         recursionElement(arraySel, 0, app, szHexColor, updateData,true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: szHexColor})
                         } else {
                           updateData({currentItemDrawStrokeColor: szHexColor})
                         }
                       }
                       mLastestAlphaColor = szHexColor;
                       mLastestA = Math.floor(newShade.a * 100);
                     }
                   }}
            />
          </div>

          <div style={{marginTop: '12px', width: '100%'}}>
            <span>HEX</span>
            <input readOnly={false} className={'input-border'} style={{
              flexGrow: '1',
              borderRadius: '4px',
              outline: 'none',
              margin: '0 16px',
              height: '24px',
              textAlign: 'center',
              width: '130px',
            }}
                   value={drawStrokeColor}

                   onChange={(e) => {
                     mInputValue = e.currentTarget.value;

                     setDrawStrokeColor(mInputValue);

                     const arraySelectedElements = getSelectedElements(elements, appState);
                     for (let i = 0; i < arraySelectedElements.length; i++) {
                       updateData({id: arraySelectedElements[i].id, extra: {tempItemStrokeColor: e.currentTarget.value}});
                     }

                   }}

                   onFocus={(event => {
                     mInputValue = (event.currentTarget.value)
                     event.currentTarget.select();
                     app.onPointDownEvent((activeTool, pointerDownState) => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       const arraySelectedElements = getSelectedElements(elements, appState);
                       if (arraySelectedElements.length > 0) {
                         // const element = arraySelectedElements[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                         //   if (element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }else{
                         //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }
                         // })
                         recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData,true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         } else {
                           updateData({currentItemDrawStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         }
                       }

                       app.onPointDownEvent(null);
                     });
                   })}
                   onBlur={(event => {
                     setLastestColors(getValidateHexColor(mInputValue));
                     const arraySelectedElements = getSelectedElements(elements, appState);
                     if (arraySelectedElements.length > 0) {
                       // const element = arraySelectedElements[0];
                       // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                       //   if (element.type === 'highlighter'){
                       //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                       //   }else{
                       //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                       //   }
                       // })
                       recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData,true);
                     } else {
                       if (appState.activeTool.type === 'highlighter') {
                         updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                       } else {
                         updateData({currentItemDrawStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                       }
                     }

                   })}
                   onKeyDown={(event => {
                     if (event.key === KEYS.ENTER) {
                       let szHexColor = getValidateHexColor(event.currentTarget.value)
                       setLastestColors(szHexColor);
                       const arraySelectedElements = getSelectedElements(elements, appState);
                       if (arraySelectedElements.length > 0) {
                         // const element = arraySelectedElements[0];
                         // handleSvgFile(app,element,{currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{tempItemStrokeColor:getValidateHexColor(mInputValue)}}).then(res=>{
                         //   if (element.type === 'highlighter'){
                         //     updateData({currentItemHighlightStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }else{
                         //     updateData({currentItemStrokeColor:getValidateHexColor(mInputValue),extra:{}});
                         //   }
                         // })
                         recursionElement(arraySelectedElements, 0, app, getValidateHexColor(mInputValue), updateData,true);
                       } else {
                         if (appState.activeTool.type === 'highlighter') {
                           updateData({currentItemHighlightStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         } else {
                           updateData({currentItemDrawStrokeColor: getValidateHexColor(mInputValue), extra: {}});
                         }
                       }

                       event.currentTarget.blur();
                     }
                   })}
            />
            <span>
                {
                  getFormValue(elements, appState, (element) => Math.floor(hexToRgba(element.strokeColor.toUpperCase()).a * 100) + '%', true, Math.floor(hexToRgba(appState.activeTool.type === 'highlighter' ? appState.currentItemHighlightStrokeColor : appState.currentItemStrokeColor).a * 100) + '%')
                }
              </span>
          </div>
          <div className='line' style={{margin: '12px 0'}}></div>

          <span className='text-color-a'>{i18next.t("lastestUse")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                width: '20px', height: '20px', margin: '3px 2px',
                backgroundColor: item, borderRadius: '2px', border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setDrawStrokeColor(szHex);
                const arraySelectedElements = getSelectedElements(elements, appState);
                if (arraySelectedElements.length > 0) {
                  recursionElement(arraySelectedElements, 0, app, szHex, updateData,true);
                } else {
                  if (appState.activeTool.type === 'highlighter') {
                    updateData({currentItemHighlightStrokeColor: szHex})
                  } else {
                    updateData({currentItemDrawStrokeColor: szHex})
                  }
                }
              }}></div>)
            }
          </div>
        </div>
    )
  },
});

const getElementFontColor = (element: ExcalidrawElement) => {
  if (isTextElement(element)) {
    return element.strokeColor;
  }
  const textElement = getBoundTextElement(element);
  if (textElement != null) {
    return textElement.strokeColor;
  }
  return "#333333";
}

export const actionChangeFontStrokeColor = register({
  name: "changeFontStrokeColor",
  trackEvent: false,
  perform: (elements, appState, value, app) => {
    return {
      // ...(value.currentItemStrokeColor && {
      //   elements: changeProperty(
      //       elements,
      //       appState, (el) => {
      //         handerSvgFile(el);
      //         return (hasStrokeColor(el.type) && isTextElement(el))//只有文本才调整字体颜色
      //             ? newElementWith(el, {
      //               strokeColor: value.currentItemStrokeColor,
      //               fileId:el.fileId,
      //               extra:value.extra
      //             })
      //             : el;
      //       },
      //       true,
      //   ),
      // }),
      elements: changeProperty(
          elements,
          appState, (el: any) => {
            if (isValidateHexColor(value?.currentItemFontColor) && (isTextElement(el) || isStickyNotesElement(el))) {
              /*if (isStickyNotesElement(el) && ENABLE_STICKYNOTE_RICHTEXT_20250815) {
                const quill = QuillCache.get(el.id);
                const range = quill.getSelection();
                if (range) {
                  quill.formatText(
                      range.index,
                      range.length,
                      "color",
                      value.currentItemFontColor,
                  );
                } else {
                  const length = quill.getLength();
                  quill.formatText(
                      0,
                      length - 1,
                      "color",
                      value.currentItemFontColor,
                  );
                }
                return el;
              }*/

              value.strokeColor = value.currentItemFontColor;
              postMessage(EVENT_FONT_STROKE_COLOR_CHANGE, {fontStrokeColor: value.strokeColor});

              if (StickyNoteTiptapCache.get(el.id)){
                const editor = StickyNoteTiptapCache.get(el.id);
                const currentPosition = editor.state.selection.from;
                editor.chain().selectAll().setColor(value.strokeColor).setTextSelection(currentPosition).run();
              }
                if (TextTiptapCache.get(el.id)){
                    const editor = TextTiptapCache.get(el.id);
                    const currentPosition = editor.state.selection.from;
                    editor.chain().selectAll().setColor(value.strokeColor).setTextSelection(currentPosition).run();
                }
            }
            return (hasStrokeColor(el.type) && (isTextOrBoundElement(el) || isStickyNotesElement(el)))
                ? newElementWith(el, value)
                : el;
          },
          true,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemFontColor,
      actionType: "color",
    };
  },
  PanelComponent: ({elements, appState, updateData, appProps, app}) => {
    const getDefaultFontStrokeColor = getFormValue(elements, appState, (element) =>
            (isTextElement(element) || isStickyNotesElement(element)) ? (element.extra?.hasOwnProperty("tempItemStrokeColor") ? element.extra?.tempItemStrokeColor.toUpperCase() : element.strokeColor.toUpperCase())
                : getBoundTextElement(element)?.extra?.hasOwnProperty("tempItemStrokeColor") ? getBoundTextElement(element)?.extra.tempItemStrokeColor.toUpperCase() : getBoundTextElement(element)?.strokeColor.toUpperCase(),
        true, appState.currentItemFontColor);
    const [fontStrokeColor,setFontStrokeColor] = useState(getDefaultFontStrokeColor);
    const [hasDropColor,setHasDropColor] = useState(false);

    // function onKeydownEvent(event){
    //   if (event.key == KEYS.ESCAPE){
    //     alert('xxxx')
    //   }
    // }
    // useEffect(()=>{
    //   document.body.addEventListener('keydown',onKeydownEvent);
    // },[])

    return (
        <>
          <div className='font-size-12 popover-box-shadow'
               style={{margin: '-16px', padding: '18px 15px', width: '248px'}}>
            <span>{i18next.t("Default colors")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '2px'}}>
              {
                ARRAY_DEFAULT_COLORS.map(item => <div className={'cursor-pointer'} key={generateUUID2()}
                                                      data-color={item} style={{
                  width: '20px',
                  height: '20px',
                  margin: '3px 2px',
                  backgroundColor: item,
                  borderRadius: '10px',
                  border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                }} onClick={(e) => {
                  e.stopPropagation();
                  let szHex = e.currentTarget.dataset.color;
                  setFontStrokeColor(szHex);
                  updateData({currentItemFontColor: szHex})
                  setLastestColors(szHex as string);
                }} onMouseDown={(e)=>{
                  e.stopPropagation();
                  e.preventDefault();

                }}>
                </div>)
              }
            </div>
            <div className={'line'} style={{margin: '10px 0'}}></div>

            <span>{i18next.t("palette")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {
                ARRAY_COLORS.map(item => <div key={generateUUID2()} className={'font-color-item'} data-color={item}
                                              style={{
                                                width: '20px',
                                                height: '20px',
                                                margin: '3px 2px',
                                                backgroundColor: item,
                                                borderRadius: '2px',
                                                cursor: 'pointer',
                                                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                                              }} onClick={(e) => {
                  let szHex = e.currentTarget.dataset.color;
                  setFontStrokeColor(szHex);
                  updateData({currentItemFontColor: szHex})
                  setLastestColors(szHex as string);
                  if (window.onPointerDownEvent){
                    window.onPointerDownEvent(e);
                  }
                }} onMouseDown={(e)=>{
                  e.preventDefault();
                }}></div>)
              }
            </div>
            <div style={{height: '6px'}}></div>

            <div className='flex-row-vertical-center' style={{width: '100%'}}>
              <div className='flex-center' style={{
                width: '26px',
                height: '26px',
                backgroundColor: hasDropColor ? '#efefef' : 'transparent'
              }}>
                {
                  // hasDropColor &&
                  // <EyeDropper onCancel={() => {
                  //   // const arraySel = getSelectedElements(elements, appState);
                  //   // if (arraySel.length > 0) {
                  //   //   const element = arraySel[0];
                  //   //   updateData({
                  //   //     currentItemFontColor: element.strokeColor,
                  //   //     extra: {hasDropColor: false, dropColorClick: false}
                  //   //   })
                  //   // }
                  //   setHasDropColor(false);
                  // }}
                  //             onSelect={(color, event) => {
                  //               // updateData({
                  //               //   currentItemFontColor: color,
                  //               //   extra: {hasDropColor: false, dropColorClick: false}
                  //               // })
                  //               setHasDropColor(false);
                  //
                  //               setLastestColors(color as string);
                  //             }} onChange={() => {
                  //
                  // }} colorPickerType={"elementStroke"}>
                  //
                  // </EyeDropper>


                  // eyeDropper.open().then((eyeDropperResult: {
                  //   sRGBHex: string;
                  // }) => {
                  //   console.log(eyeDropperResult.sRGBHex)
                  //   setHasDropColor(false);
                  //   setFontStrokeColor(eyeDropperResult.sRGBHex);
                  //   setLastestColors(eyeDropperResult.sRGBHex);
                  // });
                }
                <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')}
                     onClick={async () => {
                       setHasDropColor(true);
                       const eyeDropper = new (window as any).EyeDropper();
                       try {
                         const result = await eyeDropper.open();
                         console.log(result.sRGBHex)
                         setHasDropColor(false);
                         setFontStrokeColor(result.sRGBHex);
                         setLastestColors(result.sRGBHex);
                         updateData({currentItemFontColor: result.sRGBHex})
                       } catch (err) {
                         setHasDropColor(false);
                       }
                     }}/>
              </div>
              <Alpha
                  style={{flexGrow: '1', marginLeft: '10px'}}
                  hsva={hexToHsva(isValidateHexColor(fontStrokeColor) ? fontStrokeColor : getDefaultFontStrokeColor)}
                  onChange={(newShade) => {
                    let szHexColor = hsvaToHexa(newShade as HsvaColor);
                    setFontStrokeColor(szHexColor);
                    updateData({currentItemFontColor: szHexColor})
                  }}
              />
            </div>
            <div style={{marginTop: '12px', width: '100%'}}>
              <span>HEX</span>
              <input className='default-font-size input-border' readOnly={false} style={{
                flexGrow: '1',
                borderRadius: '4px',
                outline: 'none',
                margin: '0 16px',
                height: '24px',
                textAlign: 'center',
                width: '130px',
              }}
                     value={fontStrokeColor}

                     onChange={(e) => {
                       /*
                       const szHexColor = "#"+e.currentTarget.value.replace("#","");
                       if(validHex(szHexColor)){
                         updateData({currentItemStrokeColor:szHexColor,extra:{tempItemStrokeColor:szHexColor}});
                       }else{
                         let szOriHex='TRANSPARENT';
                         const arraySelectedElements = getSelectedElements(elements,appState);

                         if (arraySelectedElements.length > 0) {
                           let element:any = arraySelectedElements[0];
                           if (!isTextElement(element)){
                             element = getBoundTextElement(element);
                           }
                           if (element != null){
                             szOriHex = element.strokeColor;
                           }
                         }
                         updateData({currentItemStrokeColor:szOriHex,extra:{tempItemStrokeColor:szHexColor}})
                       }
                        */
                       mInputValue = e.currentTarget.value;
                       setFontStrokeColor(mInputValue);
                       // updateData({extra: {tempItemStrokeColor: e.currentTarget.value}});
                     }}

                     onFocus={(event => {
                       mInputValue = (event.currentTarget.value)
                       event.currentTarget.select();
                       app.onPointDownEvent((activeTool, pointerDownState) => {
                         setLastestColors(getValidateHexColor(mInputValue));
                         updateData({currentItemFontColor: getValidateHexColor(mInputValue), extra: {}});
                         app.onPointDownEvent(null);
                       });
                     })}
                     onBlur={(event => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       updateData({currentItemFontColor: getValidateHexColor(mInputValue)});
                     })}
                     onKeyDown={(event => {
                       if (event.key === KEYS.ENTER) {
                         let szHexColor = getValidateHexColor(event.currentTarget.value)
                         setLastestColors(szHexColor);
                         updateData({currentItemFontColor: szHexColor, extra: {}});
                         event.currentTarget.blur();
                       }
                     })}
              />
              <span>
                  {
                    getFormValue(elements, appState, (element) =>
                        isTextElement(element) ? Math.floor(hexToRgba(element.strokeColor.toUpperCase()).a * 100) + '%' :
                            Math.floor(hexToRgba(getBoundTextElement(element)?.strokeColor || '#000000').a * 100) + '%', true, Math.floor(hexToRgba(appState.currentItemFontColor).a * 100) + '%')
                  }
                </span>
            </div>
            <div className='line' style={{margin: '12px 0'}}></div>

            <span className='text-color-a'>{i18next.t("lastestUse")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {
                getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                  width: '20px',
                  height: '20px',
                  margin: '3px 2px',
                  backgroundColor: item,
                  borderRadius: '2px',
                  cursor:'pointer',
                  border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
                }} onClick={(e) => {
                  let szHex = e.currentTarget.dataset.color;
                  // const arraySelectedElements = getSelectedElements(elements,appState);
                  // if (arraySelectedElements.length > 0){
                  //   const element = arraySelectedElements[0];
                  //   if (isTextElement(element)){
                  //     updateData({currentItemStrokeColor:szHex})
                  //   }
                  //   const boundTextElement = getBoundTextElement(element);
                  //   if (boundTextElement != null){
                  //     var arrayNewElements = [...elements];
                  //     let newBoundTextElement = {...boundTextElement,currentItemStrokeColor:szHex};
                  //     updateData({currentItemStrokeColor:szHex})
                  //   }
                  // }
                  setFontStrokeColor(szHex);
                  updateData({currentItemFontColor: szHex})

                  setLastestColors(szHex as string);
                }} onMouseDown={(e)=>{
                  e.preventDefault();
                }}></div>)
              }
            </div>
          </div>
          {/*<h3 aria-hidden="true">{i18next.t("labels.stroke")}</h3>*/}
          {/*<ColorPicker*/}
          {/*  topPicks={DEFAULT_ELEMENT_STROKE_PICKS}*/}
          {/*  palette={DEFAULT_ELEMENT_STROKE_COLOR_PALETTE}*/}
          {/*  type="elementStroke"*/}
          {/*  label={i18next.t("labels.stroke")}*/}
          {/*  color={getFormValue(*/}
          {/*    elements,*/}
          {/*    appState,*/}
          {/*    (element) => element.strokeColor,*/}
          {/*    true,*/}
          {/*    appState.currentItemStrokeColor,*/}
          {/*  )}*/}
          {/*  onChange={(color) => updateData({ currentItemStrokeColor: color })}*/}
          {/*  elements={elements}*/}
          {/*  appState={appState}*/}
          {/*  updateData={updateData}*/}
          {/*/>*/}
        </>
    )
  },
});

export const actionChangeBackgroundColor = register({
  name: "changeBackgroundColor",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      // ...(value.currentItemBackgroundColor && {
      //   elements: changeProperty(elements, appState, (el) =>
      //     newElementWith(el, {
      //       backgroundColor: value.currentItemBackgroundColor,
      //       extra:value.extra
      //     }),
      //   ),
      // }),
      elements: changeProperty(
          elements,
          appState, (el: any) => {
            // handerSvgFile(el,value);
            // var updates:any = {
            //   strokeColor: value.currentItemStrokeColor,
            //   fileId:el.fileId,
            // }
            // if (value.extra != null && value.extra != undefined){
            //   updates.extra = value.extra;
            // }
            if (isValidateHexColor(value?.currentItemBackgroundColor)) {
              value.backgroundColor = value.currentItemBackgroundColor;
            }
            return newElementWith(el, value)
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemBackgroundColor,
    };
  },
  PanelComponent: ({elements, appState, updateData, appProps, app}) => {
    const [isDropdownColor,setIsDropdownColor] = useState(false);
    return (
        <>
          <div className='flex-row-vertical-center font-size-12'>
            <Checkbox style={{
              marginLeft: '-8px',
              display: getFormValue(elements, appState, (element) => isTextElement(element) ? 'none' : 'inherit', true, appState.currentItemStrokeColor)
            }}
                      className='mr-8' onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                const arraySelectElements = getSelectedElements(elements, appState);
                var szLastColor = '#FFFFFF';
                if (arraySelectElements != null && arraySelectElements.length > 0) {
                  if (isValidateHexColor(arraySelectElements[0].extra?.tempLastBackgroundColor)) {
                    szLastColor = arraySelectElements[0].extra?.tempLastBackgroundColor;
                  }
                }
                updateData({currentItemBackgroundColor: szLastColor});
              } else {
                const arraySelectElements = getSelectedElements(elements, appState);
                var extra: any = {};
                if (arraySelectElements != null && arraySelectElements.length > 0) {
                  extra.tempLastBackgroundColor = arraySelectElements[0].backgroundColor;
                }
                updateData({currentItemBackgroundColor: 'TRANSPARENT', extra: extra});
              }
            }}
                      checked={
                        getFormValue(elements, appState, (element) =>
                                element.backgroundColor.toLowerCase() !== 'transparent',
                            true, appState.currentItemBackgroundColor !== 'transparent')
                      }
            />

            <Popover trigger={"click"} placement={"bottom"} onVisibleChange={(e) => {
              //隐藏...不会触发
              const arraySelectedElements = getSelectedElements(elements, appState);
              if (arraySelectedElements.length > 0) {
                const element = arraySelectedElements[0];
                updateData({currentItemBackgroundColor: element.backgroundColor, extra: null});
              }
            }} content={
              <div className='font-size-12' style={{margin: '-16px', padding: '18px 15px', width: '248px'}}>
                <span>{i18next.t("palette")}</span>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                  {
                    ARRAY_COLORS.map(item => <div key={generateUUID2()} data-color={item} style={{
                      width: '20px',
                      height: '20px',
                      margin: '3px 2px',
                      backgroundColor: item,
                      borderRadius: '2px',
                      border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                    }} onClick={(e) => {
                      let szHex = e.currentTarget.dataset.color;
                      updateData({currentItemBackgroundColor: szHex})
                      setLastestColors(szHex as string);
                    }}></div>)
                  }
                </div>
                <div style={{height: '6px'}}></div>
                <div className='flex-row-vertical-center' style={{width: '100%'}}>
                  <div className='flex-center' style={{
                    width: '26px',
                    height: '26px',
                    backgroundColor: isDropdownColor ? '#efefef' : 'transparent'
                  }}>
                    {
                      // getFormValue(elements, appState, (element) => element.extra?.hasDropColor, true, false) &&
                      // <EyeDropper onCancel={() => {
                      //   const arraySel = getSelectedElements(elements, appState);
                      //   if (arraySel.length > 0) {
                      //     const element = arraySel[0];
                      //     updateData({
                      //       currentItemBackgroundColor: element.backgroundColor,
                      //       extra: {hasDropColor: false, dropColorClick: false}
                      //     })
                      //   }
                      // }}
                      //             onSelect={(color, event) => {
                      //               updateData({
                      //                 currentItemBackgroundColor: color,
                      //                 extra: {hasDropColor: false, dropColorClick: false}
                      //               })
                      //               setLastestColors(color as string);
                      //             }} onChange={() => {
                      //
                      // }} colorPickerType={"elementStroke"}>
                      //
                      // </EyeDropper>
                    }
                    <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')} onClick={async () => {
                      // const arraySel = getSelectedElements(elements, appState);
                      // if (arraySel.length > 0) {
                      //   const element = arraySel[0];
                      //   updateData({
                      //     currentItemBackgroundColor: element.backgroundColor,
                      //     extra: {hasDropColor: true, dropColorClick: true}
                      //   })
                      // }
                      setIsDropdownColor(true);
                      const eyeDropper = new (window as any).EyeDropper();
                      try {
                        const result = await eyeDropper.open();
                        console.log(result.sRGBHex)
                        setIsDropdownColor(false);
                        // setba(result.sRGBHex);
                        setLastestColors(result.sRGBHex);
                      }catch (err) {
                        setIsDropdownColor(false);
                      }
                    }}/>
                  </div>
                  <Alpha
                      style={{flexGrow: '1', marginLeft: '10px'}}
                      hsva={
                        getFormValue(elements, appState, (element) => hexToHsva(element.backgroundColor.toUpperCase()), true, hexToHsva(appState.currentItemBackgroundColor))
                      }
                      onChange={(newShade, offset) => {
                        let szHexColor = hsvaToHexa(newShade as HsvaColor);
                        updateData({currentItemBackgroundColor: szHexColor})
                      }}
                      // onFocus={()=>{
                      //   setLastestColors(getValidateHexColor(mInputValue));
                      //   updateData({currentItemBackgroundColor:getValidateHexColor(mInputValue)});
                      // }}
                  />
                </div>
                <div style={{marginTop: '12px', width: '100%'}}>
                  <span>HEX</span>
                  <input className='default-font-size input-border' readOnly={false} style={{
                    flexGrow: '1',
                    borderRadius: '4px',
                    outline: 'none',
                    margin: '0 16px',
                    height: '24px',
                    textAlign: 'center',
                    width: '130px',
                  }}
                         value={
                           getFormValue(elements, appState, (element) => element.extra?.hasOwnProperty("tempItemBackgroundColor") ? element.extra?.tempItemBackgroundColor?.toLowerCase() : element.backgroundColor.toUpperCase(), true, appState.currentItemBackgroundColor)
                         }

                         onChange={(e) => {
                           /*
                           const szHexColor = "#"+e.currentTarget.value.replace("#","");

                           if(validHex(szHexColor)){
                             updateData({currentItemBackgroundColor:szHexColor,extra:{tempItemBackgroundColor:szHexColor}});
                           }else{
                             let szOriHex='TRANSPARENT';
                             const arraySelectedElements = getSelectedElements(elements,appState);

                             if (arraySelectedElements.length > 0) {
                               const element = arraySelectedElements[0];
                               szOriHex = element.backgroundColor;
                             }
                             updateData({currentItemBackgroundColor:szOriHex,extra:{tempItemBackgroundColor:szHexColor}})
                           }*/

                           mInputValue = e.currentTarget.value;
                           updateData({extra: {tempItemBackgroundColor: e.currentTarget.value}});
                         }}
                         onFocus={(event => {
                           mInputValue = (event.currentTarget.value)
                           event.currentTarget.select();
                           app.onPointDownEvent((activeTool, pointerDownState) => {
                             setLastestColors(getValidateHexColor(mInputValue));
                             updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue), extra: {}});
                             app.onPointDownEvent(null);
                           });
                         })}
                         onBlur={(event => {
                           setLastestColors(getValidateHexColor(mInputValue));
                           updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue)});
                         })}
                         onKeyDown={(event => {
                           if (event.key === KEYS.ENTER) {
                             let szHexColor = getValidateHexColor(event.currentTarget.value)
                             setLastestColors(szHexColor);
                             updateData({currentItemBackgroundColor: szHexColor, extra: {}});
                             event.currentTarget.blur();
                           }
                         })}

                  />
                  <span>
                {
                  getFormValue(elements, appState, (element) => Math.floor(hexToRgba(element.backgroundColor.toUpperCase()).a * 100) + '%', true, Math.floor(hexToRgba(appState.currentItemBackgroundColor).a * 100) + '%')
                }
              </span>
                </div>
                <div className='line' style={{margin: '12px 0'}}></div>

                <span className='text-color-a'>{i18next.t("lastestUse")}</span>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                  {
                    getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                      width: '20px', height: '20px', margin: '3px 2px',
                      backgroundColor: item, borderRadius: '2px', border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
                    }} onClick={(e) => {
                      let szHex = e.currentTarget.dataset.color;
                      updateData({currentItemBackgroundColor: szHex})
                    }}></div>)
                  }
                </div>
              </div>

            }>
              <div className='hovered' style={{
                width: '16px',
                height: '16px',
                border: '1px solid #efefef',
                backgroundColor: getFormValue(elements, appState, (element) => {
                  if (isValidateHexColor(element.extra?.tempLastBackgroundColor)) {
                    return element.extra.tempLastBackgroundColor;
                  }
                  return element.backgroundColor;
                }, true, appState.currentItemBackgroundColor)
              }}>

              </div>
            </Popover>

          </div>
          {/*<h3 aria-hidden="true">{i18next.t("labels.background")}</h3>*/}
          {/*<ColorPicker*/}
          {/*  topPicks={DEFAULT_ELEMENT_BACKGROUND_PICKS}*/}
          {/*  palette={DEFAULT_ELEMENT_BACKGROUND_COLOR_PALETTE}*/}
          {/*  type="elementBackground"*/}
          {/*  label={i18next.t("labels.background")}*/}
          {/*  color={getFormValue(*/}
          {/*    elements,*/}
          {/*    appState,*/}
          {/*    (element) => element.backgroundColor,*/}
          {/*    true,*/}
          {/*    appState.currentItemBackgroundColor,*/}
          {/*  )}*/}
          {/*  onChange={(color) => updateData({ currentItemBackgroundColor: color })}*/}
          {/*  elements={elements}*/}
          {/*  appState={appState}*/}
          {/*  updateData={updateData}*/}
          {/*/>*/}
        </>
    )
  }
});

/**
 * 更改背景弹窗
 * arrow 颜色
 */

export const actionChangeBackgroundColorPopover = register({
  name: "changeBackgroundColorPopover",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState, (el:any) => {
            if (!value)return el;

            const newValue = {...value};
            if (isValidateHexColor(newValue?.currentItemBackgroundColor)){
              if (el.type=='arrow' || el.type == 'line' || el.type == 'freedraw' || el.type == 'highlighter'){
                newValue.strokeColor = newValue.currentItemBackgroundColor;
                newValue.currentItemStrokeColor = newValue.currentItemBackgroundColor;
                delete newValue.currentItemBackgroundColor;
                if (el.type == 'arrow'){
                  localStorage.setItem(KEY_DRAW_ARROW_STROKE_COLOR,newValue.strokeColor);
                }
              }
              else{
                newValue.backgroundColor = newValue.currentItemBackgroundColor;
              }

              if (isStickyNotesElement(el)){
                //保存背景
                localStorage.setItem(KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,newValue?.currentItemBackgroundColor);
              }
              if (isTextElement(el) && !el.containerId){
                localStorage.setItem(KEY_DEFAULT_TEXT_BACKGROUND_COLOR,newValue?.currentItemBackgroundColor);
              }

            }
            if (isEmbeddableElement(el)){
              const div = document.getElementById('embedable-card-link-'+el.id);
              if (div){
                div.style.background = newValue.backgroundColor;
              }
            }

            postMessage(EVENT_BACKGROUND_COLOR_CHANGE,{backgroundColor:value.backgroundColor});
            return newElementWith(el, newValue)
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemBackgroundColor,
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps ,app}) => {
    const getDefaultBackgroundColor = getFormValue(elements, appState, (element) => element.backgroundColor?.toUpperCase(), true, appState.currentItemBackgroundColor)
    const [backgroundColor,setBackgroundColor] = useState(getDefaultBackgroundColor);
    const [isDropdownColor,setIsDropdownColor] = useState(false);
    const isSomeBackground = ()=>{
      const arrayElements = app.getSelectedElements();
      if (arrayElements.length > 0){
        const element = arrayElements[0];
        return isTextElement(element) || isShapeElement(element) || isStickyNotesElement(element) || isMindmapElement(element);
      }
    }
    return(
        <div className='font-size-12 popover-box-shadow'
             style={{margin: '-12px', padding: '18px 15px', width: '248px'}}>
          <span>{i18next.t("Default colors")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap',marginTop:'2px'}}>
            {
              (isSomeBackground()?ARRAY_DEFAULT_COLORS_1:ARRAY_DEFAULT_COLORS).map(item=><div className={'cursor-pointer'} key={generateUUID2()} data-color={item} style={{
                width: '20px',
                height: '20px',
                margin: '3px 2px',
                backgroundColor: item,
                borderRadius: '10px',
                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e)=>{
                let szHex = e.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }}>

                {
                  (item == 'transparent' || item == '#00000001') &&
                  <img className={'img-20'} src={getImagePathSvg('color_transparent')}/>
                }


              </div>)
            }
          </div>
          <div className={'line'} style={{margin:'10px 0'}}></div>

          <span>{i18next.t("palette")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              ARRAY_COLORS.map(item => <div className={'cursor-pointer'} key={generateUUID2()} data-color={item}
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              margin: '3px 2px',
                                              backgroundColor: item,
                                              borderRadius: '2px',
                                              border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                                            }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }}></div>)
            }
          </div>
          <div style={{height: '6px'}}></div>
          <div className='flex-row-vertical-center' style={{width: '100%'}}>
            <div className='flex-center' style={{
              width: '26px',
              height: '26px',
              backgroundColor: isDropdownColor ? '#efefef' : 'transparent'
            }}>
              {
                // getFormValue(elements, appState, (element) => element.extra?.hasDropColor, true, false) &&
                // <EyeDropper onCancel={() => {
                //   const arraySel = getSelectedElements(elements, appState);
                //   if (arraySel.length > 0) {
                //     const element = arraySel[0];
                //     updateData({
                //       currentItemBackgroundColor: element.backgroundColor,
                //       extra: {hasDropColor: false, dropColorClick: false}
                //     })
                //   }
                // }}
                //             onSelect={(color, event) => {
                //               updateData({
                //                 currentItemBackgroundColor: color,
                //                 extra: {hasDropColor: false, dropColorClick: false}
                //               })
                //               setLastestColors(color as string);
                //             }} onChange={() => {
                //
                // }} colorPickerType={"elementStroke"}>
                //
                // </EyeDropper>
              }
              <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')}
                   onClick={async () => {
                     // const arraySel = getSelectedElements(elements, appState);
                     // if (arraySel.length > 0) {
                     //   const element = arraySel[0];
                     //   updateData({
                     //     currentItemBackgroundColor: element.backgroundColor,
                     //     extra: {hasDropColor: true, dropColorClick: true}
                     //   })
                     // }
                     setIsDropdownColor(true);
                     const eyeDropper = new (window as any).EyeDropper();
                     try {
                       const result = await eyeDropper.open();
                       console.log(result.sRGBHex)
                       setIsDropdownColor(false);
                       setBackgroundColor(result.sRGBHex);
                       setLastestColors(result.sRGBHex);
                       updateData({currentItemBackgroundColor: result.sRGBHex})
                     } catch (err) {
                       setIsDropdownColor(false);
                     }
                   }}/>
            </div>
            <Alpha
                style={{flexGrow: '1', marginLeft: '10px'}}
                hsva={hexToHsva(isValidateHexColor(backgroundColor) ? backgroundColor : getDefaultBackgroundColor)}
                onChange={(newShade, offset) => {
                  let szHexColor = hsvaToHexa(newShade as HsvaColor);
                  setBackgroundColor(szHexColor);
                  updateData({currentItemBackgroundColor: szHexColor})
                }}
                // onFocus={()=>{
                //   setLastestColors(getValidateHexColor(mInputValue));
                //   updateData({currentItemBackgroundColor:getValidateHexColor(mInputValue)});
                // }}
            />
          </div>
          <div style={{marginTop: '12px', width: '100%'}}>
            <span>HEX</span>
            <input className='default-font-size input-border' readOnly={false} style={{
              flexGrow: '1',
              borderRadius: '4px',
              outline: 'none',
              margin: '0 16px',
              height: '24px',
              textAlign: 'center',
              width: '130px',
            }}
                   value={backgroundColor}

                   onChange={(e) => {
                     /*
                     const szHexColor = "#"+e.currentTarget.value.replace("#","");

                     if(validHex(szHexColor)){
                       updateData({currentItemBackgroundColor:szHexColor,extra:{tempItemBackgroundColor:szHexColor}});
                     }else{
                       let szOriHex='TRANSPARENT';
                       const arraySelectedElements = getSelectedElements(elements,appState);

                       if (arraySelectedElements.length > 0) {
                         const element = arraySelectedElements[0];
                         szOriHex = element.backgroundColor;
                       }
                       updateData({currentItemBackgroundColor:szOriHex,extra:{tempItemBackgroundColor:szHexColor}})
                     }*/

                     mInputValue = e.currentTarget.value;
                     setBackgroundColor(mInputValue);
                     // updateData({extra: {tempItemBackgroundColor: e.currentTarget.value}});
                   }}
                   onFocus={(event => {
                     mInputValue = (event.currentTarget.value)
                     event.currentTarget.select();
                     app.onPointDownEvent((activeTool, pointerDownState) => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue), extra: {}});
                       app.onPointDownEvent(null);
                     });
                   })}
                   onBlur={(event => {
                     setLastestColors(getValidateHexColor(mInputValue));
                     updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue)});
                   })}
                   onKeyDown={(event => {
                     if (event.key === KEYS.ENTER) {
                       let szHexColor = getValidateHexColor(event.currentTarget.value)
                       setLastestColors(szHexColor);
                       updateData({currentItemBackgroundColor: szHexColor, extra: {}});
                       event.currentTarget.blur();
                     }
                   })}

            />
            <span>
                    {
                      getFormValue(elements, appState, (element) => Math.floor(hexToRgba(element?.backgroundColor?.toUpperCase()).a * 100) + '%', true, Math.floor(hexToRgba(appState.currentItemBackgroundColor).a * 100) + '%')
                    }
                  </span>
          </div>
          <div className='line' style={{margin: '12px 0'}}></div>

          <span className='text-color-a'>{i18next.t("lastestUse")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                width: '20px', height: '20px', margin: '3px 2px',cursor:'pointer',
                backgroundColor: item, borderRadius: '2px', border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
              }} onClick={(e) => {
                let szHex = e.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }}></div>)
            }
          </div>
        </div>
    )
  },
});

export const actionChangeCardBackgroundColorPopover = register({
  name: "changeCardBackgroundColorPopover",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState, (el:any) => {
            if (!value)return el;

            const newValue = {...value};
            if (isValidateHexColor(newValue?.currentItemBackgroundColor)){
              if (el.type=='arrow' || el.type == 'line' || el.type == 'freedraw' || el.type == 'highlighter'){
                newValue.strokeColor = newValue.currentItemBackgroundColor;
                newValue.currentItemStrokeColor = newValue.currentItemBackgroundColor;
                delete newValue.currentItemBackgroundColor;
              }
              else{
                newValue.backgroundColor = newValue.currentItemBackgroundColor;
              }

              if (isStickyNotesElement(el)){
                localStorage.setItem(KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,newValue.currentItemBackgroundColor);
              }

              if (isTextElement(el) && !el.containerId){
                localStorage.setItem(KEY_DEFAULT_TEXT_BACKGROUND_COLOR,newValue?.currentItemBackgroundColor);
              }

              if (isNoteElement(el)){
                let jsonConfig:any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
                if (jsonConfig){
                  jsonConfig = JSON.parse(jsonConfig);
                }else{
                  jsonConfig = {};
                }
                jsonConfig.backgroundColor = newValue?.currentItemBackgroundColor;
                localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(jsonConfig));
              }
            }

            postMessage(EVENT_BACKGROUND_COLOR_CHANGE,{backgroundColor:value.backgroundColor});
            return newElementWith(el, newValue)
          },
          false,
      ),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemBackgroundColor,
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps ,app}) => {
    const getDefaultBackgroundColor = getFormValue(elements, appState, (element) => element.backgroundColor?.toUpperCase(), true, appState.currentItemBackgroundColor)
    const [backgroundColor,setBackgroundColor] = useState(getDefaultBackgroundColor);
    const [isDropdownColor,setIsDropdownColor] = useState(false);

    return(
        <div className='font-size-12 popover-box-shadow'
             style={{margin: '-12px', padding: '18px 15px', width: '248px'}} onMouseDown={(event)=>event.stopPropagation()}>
          <span>{i18next.t("Default colors")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap',marginTop:'2px'}}>
            {
              ARRAY_DEFAULT_CARD_COLORS.map(item=><div className={'cursor-pointer'} key={generateUUID2()} data-color={item} style={{
                width: '20px',
                height: '20px',
                margin: '3px 2px',
                backgroundColor: item,
                borderRadius: '10px',
                border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
              }} onMouseDown={(e)=>{
                let szHex = isDarkMode()?ARRAY_DEFAULT_DARK_USE_COLOR[e.currentTarget.dataset.color]??e.currentTarget.dataset.color: ARRAY_DEFAULT_USE_COLOR[e.currentTarget.dataset.color]??e.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }}>

              </div>)
            }
          </div>
          <div className={'line'} style={{margin:'10px 0'}}></div>

          <span>{i18next.t("palette")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              ARRAY_COLORS.map(item => <div className={'cursor-pointer'} key={generateUUID2()} data-color={item}
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              margin: '3px 2px',
                                              backgroundColor: item,
                                              borderRadius: '2px',
                                              border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                                            }} onMouseDown={(event)=> {
                event.stopPropagation();
                let szHex = event.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }} onClick={(e) => {
                                              e.stopPropagation();
              }}></div>)
            }
          </div>
          <div style={{height: '6px'}}></div>
          <div className='flex-row-vertical-center' style={{width: '100%'}}>
            <div className='flex-center' style={{
              width: '26px',
              height: '26px',
              backgroundColor: isDropdownColor ? '#efefef' : 'transparent'
            }}>
              {
                // getFormValue(elements, appState, (element) => element.extra?.hasDropColor, true, false) &&
                // <EyeDropper onCancel={() => {
                //   const arraySel = getSelectedElements(elements, appState);
                //   if (arraySel.length > 0) {
                //     const element = arraySel[0];
                //     updateData({
                //       currentItemBackgroundColor: element.backgroundColor,
                //       extra: {hasDropColor: false, dropColorClick: false}
                //     })
                //   }
                // }}
                //             onSelect={(color, event) => {
                //               updateData({
                //                 currentItemBackgroundColor: color,
                //                 extra: {hasDropColor: false, dropColorClick: false}
                //               })
                //               setLastestColors(color as string);
                //             }} onChange={() => {
                //
                // }} colorPickerType={"elementStroke"}>
                //
                // </EyeDropper>
              }
              <img className='img-mini-small-12 cursor-pointer' src={getImagePathWithTheme('pick_color')}
                   onClick={async () => {
                     // const arraySel = getSelectedElements(elements, appState);
                     // if (arraySel.length > 0) {
                     //   const element = arraySel[0];
                     //   updateData({
                     //     currentItemBackgroundColor: element.backgroundColor,
                     //     extra: {hasDropColor: true, dropColorClick: true}
                     //   })
                     // }
                     setIsDropdownColor(true);
                     const eyeDropper = new (window as any).EyeDropper();
                     try {
                       const result = await eyeDropper.open();
                       console.log(result.sRGBHex)
                       setIsDropdownColor(false);
                       setBackgroundColor(result.sRGBHex);
                       setLastestColors(result.sRGBHex);
                       updateData({currentItemBackgroundColor: result.sRGBHex})
                     } catch (err) {
                       setIsDropdownColor(false);
                     }
                   }}/>
            </div>
            <Alpha
                style={{flexGrow: '1', marginLeft: '10px'}}
                hsva={hexToHsva(isValidateHexColor(backgroundColor) ? backgroundColor : getDefaultBackgroundColor)}
                onChange={(newShade, offset) => {
                  let szHexColor = hsvaToHexa(newShade as HsvaColor);
                  setBackgroundColor(szHexColor);
                  updateData({currentItemBackgroundColor: szHexColor})
                }}
                // onFocus={()=>{
                //   setLastestColors(getValidateHexColor(mInputValue));
                //   updateData({currentItemBackgroundColor:getValidateHexColor(mInputValue)});
                // }}
            />
          </div>
          <div style={{marginTop: '12px', width: '100%'}} onMouseDown={(event)=>event.stopPropagation()}>
            <span>HEX</span>
            <input className='default-font-size input-border' readOnly={false} style={{
              flexGrow: '1',
              borderRadius: '4px',
              outline: 'none',
              margin: '0 16px',
              height: '24px',
              textAlign: 'center',
              width: '130px',
            }}
                   value={backgroundColor}

                   onChange={(e) => {
                     /*
                     const szHexColor = "#"+e.currentTarget.value.replace("#","");

                     if(validHex(szHexColor)){
                       updateData({currentItemBackgroundColor:szHexColor,extra:{tempItemBackgroundColor:szHexColor}});
                     }else{
                       let szOriHex='TRANSPARENT';
                       const arraySelectedElements = getSelectedElements(elements,appState);

                       if (arraySelectedElements.length > 0) {
                         const element = arraySelectedElements[0];
                         szOriHex = element.backgroundColor;
                       }
                       updateData({currentItemBackgroundColor:szOriHex,extra:{tempItemBackgroundColor:szHexColor}})
                     }*/

                     mInputValue = e.currentTarget.value;
                     setBackgroundColor(mInputValue);
                     // updateData({extra: {tempItemBackgroundColor: e.currentTarget.value}});
                   }}
                   onFocus={(event => {
                     mInputValue = (event.currentTarget.value)
                     event.currentTarget.select();
                     app.onPointDownEvent((activeTool, pointerDownState) => {
                       setLastestColors(getValidateHexColor(mInputValue));
                       updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue), extra: {}});
                       app.onPointDownEvent(null);
                     });
                   })}
                   onBlur={(event => {
                     setLastestColors(getValidateHexColor(mInputValue));
                     updateData({currentItemBackgroundColor: getValidateHexColor(mInputValue)});
                   })}
                   onKeyDown={(event => {
                     if (event.key === KEYS.ENTER) {
                       let szHexColor = getValidateHexColor(event.currentTarget.value)
                       setLastestColors(szHexColor);
                       updateData({currentItemBackgroundColor: szHexColor, extra: {}});
                       event.currentTarget.blur();
                     }
                   })}

            />
            <span>
                    {
                      getFormValue(elements, appState, (element) => Math.floor(hexToRgba(element?.backgroundColor?.toUpperCase()).a * 100) + '%', true, Math.floor(hexToRgba(appState.currentItemBackgroundColor).a * 100) + '%')
                    }
                  </span>
          </div>
          <div className='line' style={{margin: '12px 0'}}></div>

          <span className='text-color-a'>{i18next.t("lastestUse")}</span>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {
              getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                width: '20px', height: '20px', margin: '3px 2px',cursor:'pointer',
                backgroundColor: item, borderRadius: '2px', border: isWhiteColor(item) ? '1px solid #E6E3EE' : '0px'
              }} onMouseDown={(event)=> {
                event.stopPropagation();
                let szHex = event.currentTarget.dataset.color;
                setBackgroundColor(szHex);
                updateData({currentItemBackgroundColor: szHex})
                setLastestColors(szHex as string);
              }} onClick={(e) => {
                e.stopPropagation();
              }}></div>)
            }
          </div>
        </div>
    )
  },
});

export const actionChangeFillStyle = register({
  name: "changeFillStyle",
  trackEvent: false,
  perform: (elements, appState, value, app) => {
    trackEvent(
        "element",
        "changeFillStyle",
        `${value} (${app.device.editor.isMobile ? "mobile" : "desktop"})`,
    );
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            fillStyle: value,
          }),
      ),
      appState: {...appState, currentItemFillStyle: value},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => {
    const selectedElements = getSelectedElements(elements, appState);
    const allElementsZigZag =
        selectedElements.length > 0 &&
        selectedElements.every((el) => el.fillStyle === "zigzag");

    return (
        <fieldset style={{display: "none"}}>
          <legend>{i18next.t("labels.fill")}</legend>
          <ButtonIconSelect
              type="button"
              options={[
                {
                  value: "hachure",
                  text: `${
                      allElementsZigZag ? t("labels.zigzag") : t("labels.hachure")
                  } (${getShortcutKey("Alt-Click")})`,
                  icon: allElementsZigZag ? FillZigZagIcon : FillHachureIcon,
                  active: allElementsZigZag ? true : undefined,
                  testId: `fill-hachure`,
                },
                {
                  value: "cross-hatch",
                  text: t("labels.crossHatch"),
                  icon: FillCrossHatchIcon,
                  testId: `fill-cross-hatch`,
                },
                {
                  value: "solid",
                  text: t("labels.solid"),
                  icon: FillSolidIcon,
                  testId: `fill-solid`,
                },
              ]}
              value={getFormValue(
                  elements,
                  appState,
                  (element) => element.fillStyle,
                  (element) => element.hasOwnProperty("fillStyle"),
                  (hasSelection) =>
                      hasSelection ? null : appState.currentItemFillStyle,
              )}
              onClick={(value, event) => {
                const nextValue =
                    event.altKey &&
                    value === "hachure" &&
                    selectedElements.every((el) => el.fillStyle === "hachure")
                        ? "zigzag"
                        : value;

                updateData(nextValue);
              }}
          />
        </fieldset>
    );
  },
});

export const actionChangeStrokeWidth = register({
  name: "changeStrokeWidth",
  trackEvent: false,
  perform: (elements, appState, value) => {
    const arraySelectElements = getSelectedElements(elements, appState);
    const isHighlight = appState.activeTool.type === 'highlighter' || (arraySelectElements.length > 0 && arraySelectElements[0].type === 'highlighter');
    let updateStrokeWidth: any = {currentItemStrokeWidth: value};
    if (isHighlight) {
      updateStrokeWidth = {currentItemHighlightStrokeWidth: value};
    }
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            strokeWidth: value,
          }),
      ),
      appState: {...appState, ...updateStrokeWidth},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => (
      <fieldset>
        <Dropdown trigger={'hover'} menu={{
          items: ARRAY_STROKE_WIDTH, onClick: (item) => {
            // updateData(parseInt(item.key));
          }
        }}
                  dropdownRender={(oriOption) =>
                      <div style={{background: "white", borderRadius: '4px', overflow: 'hidden'}}>
                        {
                          ARRAY_STROKE_WIDTH.map(p => (
                              <div className='flex' style={{
                                background:
                                    ((getFormValue(
                                        elements,
                                        appState,
                                        (element) => {
                                          return element.strokeWidth;
                                        },
                                        (element) =>
                                            true,
                                        (hasSelection) =>
                                            hasSelection
                                                ? null
                                                : appState.currentItemStrokeWidth || 1,
                                    )) == parseInt(p.value) ? '#3670F7' : 'transparent'), color:
                                    ((getFormValue(
                                        elements,
                                        appState,
                                        (element) => {
                                          return element.strokeWidth;
                                        },
                                        (element) =>
                                            true,
                                        (hasSelection) =>
                                            hasSelection
                                                ? null
                                                : appState.currentItemStrokeWidth || 1,
                                    )) == parseInt(p.value) ? 'white' : 'black')
                              }}>
                                <div className='flex-row-vertical-center hovered-blue'
                                     style={{height: '32px', width: '100%'}}
                                     onClick={() => {
                                       updateData(parseInt(p.key));
                                     }}>
                                  <img className='img-mini-small-12 filter-img-white ml-12' src={imgPathPerfix() +
                                      ((getFormValue(
                                          elements,
                                          appState,
                                          (element) => {
                                            return element.strokeWidth;
                                          },
                                          (element) =>
                                              true,
                                          (hasSelection) =>
                                              hasSelection
                                                  ? null
                                                  : appState.currentItemStrokeWidth || 1,
                                      )) == parseInt(p.value) ? 'check_black.png' : 'transparent.png')
                                  }/>
                                  <span className='ml-16'>{p.label}</span>
                                </div>
                              </div>

                          ))
                        }
                      </div>
                  }
        >
          <div className='flex hovered-border'
               style={{marginLeft: '6px', minWidth: '108px', borderRadius: '4px', alignItems: 'center'}}>
            <img className='img-22'
                 src={imgPathPerfix() + 'line_width.png'}/>
            <span className='ml-6' style={{margin: '0px'}}>
          {getFormValue(
              elements,
              appState,
              (element) => element.strokeWidth,
              (element) => element.hasOwnProperty("strokeWidth"),
              (hasSelection) =>
                  hasSelection ? null : appState.activeTool.type === 'highlighter' ? appState.currentItemHighlightStrokeWidth : appState.currentItemStrokeWidth,
          )}
        </span>
          </div>

        </Dropdown>

        {/*<Select options={ARRAY_STROKE_WIDTH}*/}
        {/*        suffixIcon={null}*/}
        {/*        style={{width:'48px',marginLeft:'-1px',paddingLeft:'12px'}}*/}
        {/*        value={*/}
        {/*          getFormValue(*/}
        {/*              elements,*/}
        {/*              appState,*/}
        {/*              (element) => element.strokeWidth,*/}
        {/*              (element) => element.hasOwnProperty("strokeWidth"),*/}
        {/*              (hasSelection) =>*/}
        {/*                  hasSelection ? null : appState.currentItemStrokeWidth,*/}
        {/*          )*/}
        {/*        }*/}
        {/*        onChange={(e)=>{*/}
        {/*          updateData(parseInt(e));*/}
        {/*        }}*/}

        {/*        defaultValue={*/}
        {/*          getFormValue(*/}
        {/*              elements,*/}
        {/*              appState,*/}
        {/*              (element) => element.strokeWidth,*/}
        {/*              (element) => element.hasOwnProperty("strokeWidth"),*/}
        {/*              (hasSelection) =>*/}
        {/*                  hasSelection ? null : appState.currentItemStrokeWidth,*/}
        {/*          )*/}
        {/*        }*/}
        {/*>*/}
        {/*</Select>*/}


        {/*<legend>{i18next.t("labels.strokeWidth")}</legend>*/}
        {/*<ButtonIconSelect*/}
        {/*  group="stroke-width"*/}
        {/*  options={[*/}
        {/*    {*/}
        {/*      value: STROKE_WIDTH.thin,*/}
        {/*      text: t("labels.thin"),*/}
        {/*      icon: StrokeWidthBaseIcon,*/}
        {/*      testId: "strokeWidth-thin",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: STROKE_WIDTH.bold,*/}
        {/*      text: t("labels.bold"),*/}
        {/*      icon: StrokeWidthBoldIcon,*/}
        {/*      testId: "strokeWidth-bold",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: STROKE_WIDTH.extraBold,*/}
        {/*      text: t("labels.extraBold"),*/}
        {/*      icon: StrokeWidthExtraBoldIcon,*/}
        {/*      testId: "strokeWidth-extraBold",*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  value={getFormValue(*/}
        {/*    elements,*/}
        {/*    appState,*/}
        {/*    (element) => element.strokeWidth,*/}
        {/*    (element) => element.hasOwnProperty("strokeWidth"),*/}
        {/*    (hasSelection) =>*/}
        {/*      hasSelection ? null : appState.currentItemStrokeWidth,*/}
        {/*  )}*/}
        {/*  onChange={(value) => updateData(value)}*/}
        {/*/>*/}
      </fieldset>
  ),
});

/**
 * 修改stroke宽度
 */
export const actionChangeStrokeWidthWithToolbar = register({
  name: "changeStrokeWidthToolbar",
  trackEvent: false,
  perform: (elements, appState, value) => {
    const arraySelectElements = getSelectedElements(elements, appState);
    const isHighlight = appState.activeTool.type === 'highlighter' || (arraySelectElements.length > 0 && arraySelectElements[0].type === 'highlighter');
    const isArrow = (arraySelectElements.length > 0 && arraySelectElements[0].type === 'arrow');
    let updateStrokeWidth: any = {currentItemStrokeWidth: value};
    if (isHighlight) {
      updateStrokeWidth = {currentItemHighlightStrokeWidth: value};
    }
    if (isArrow){
      updateStrokeWidth = {currentItemArrowStrokeWidth: value};
      //记忆这个宽度.
      localStorage.setItem(KEY_DRAW_ARROW_STROKE_WIDTH,value+'');
    }

    for (let i=0;i<arraySelectElements.length;i++){
      const el = arraySelectElements[i];
      if (isNoteElement(el)){
        let jsonConfig:any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
        if (jsonConfig){
          jsonConfig = JSON.parse(jsonConfig);
        }else{
          jsonConfig = {};
        }
        jsonConfig.strokeWidth = value;
        localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(jsonConfig));
      }
    }


    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            strokeWidth: value,
          }),
      ),
      appState: {...appState, ...updateStrokeWidth},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => {
    const [strokeWidth,setStrokeWidth] = useState(getFormValue(
        elements,
        appState,
        (element) => element.strokeWidth,
        true,
        appState.currentItemStrokeWidth,
    ) ?? 1);
    return(
        <div style={{margin: '-12px', padding: '4px 16px', width: '254px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("Border weight")}</div>

            <div style={{display: 'flex', alignItems: 'center'}}>
              <input
                  style={{
                    width: '36px',
                    height: '24px',
                    border: '1px solid var(--input-border-color)',
                    borderRadius: '8px',
                    paddingLeft: '0px',
                    marginLeft: '2px',
                    textAlign: 'center',
                    fontSize: '12px',
                    background:'transparent'
                  }}
                  value={strokeWidth}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  onChange={(event) => {
                    var value = parseInt(event.target.value);
                    if (isNaN(value)) {
                      value = 1;
                    } else if (value > 100) {
                      value = 100;
                    } else if (value < 0) {
                      value = 0;
                    }
                    setStrokeWidth(value);
                    updateData(value)
                  }}
              />
            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: '1',
            marginLeft: '-4px',
            marginTop: '-2px',
            width: '100%'
          }}>
            {/*<input*/}
            {/*    type="range"*/}
            {/*    min="0"*/}
            {/*    max="100"*/}
            {/*    step="1"*/}
            {/*    style={{height: '3px', width: '100%'}}*/}
            {/*    onChange={(event) => updateData(+event.target.value)}*/}
            {/*    value={*/}
            {/*        getFormValue(*/}
            {/*            elements,*/}
            {/*            appState,*/}
            {/*            (element) => element.strokeWidth,*/}
            {/*            true,*/}
            {/*            appState.currentItemStrokeWidth,*/}
            {/*        ) ?? undefined*/}
            {/*    }*/}
            {/*/>*/}

            <Slider style={{width:'100%',marginRight:'-6px'}} tooltip={{open:false}} value={strokeWidth} onChange={(value)=>{
              setStrokeWidth(value);
              updateData(value)
            }}/>
          </div>
        </div>
    )
  },
});

export const actionChangeCornerWithToolbar = register({
  name: "changeCornerWidthToolbar",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) => {
            let jsonConfig: any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
            if (jsonConfig) {
              jsonConfig = JSON.parse(jsonConfig);
            } else {
              jsonConfig = {};
            }
            jsonConfig.corner = value.roundness?.value;
            localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE, JSON.stringify(jsonConfig));
            return newElementWith(el, value);
          }
      ),
      appState: {...appState},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => {
    const [cornerRound,setCornerRound] = useState(getFormValue(
        elements,
        appState,
        (element) => element.roundness?.value || 0,
        true,
        appState.currentItemRoundness?.value || 0,
    ) ?? 0);
    return (
        <div style={{margin: '-12px', padding: '4px 16px', width: '254px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("Corner rounding")}</div>

            <div style={{display: 'flex', alignItems: 'center'}}>
              <input
                  style={{
                    width: '36px',
                    height: '24px',
                    border: '1px solid var(--input-border-color)',
                    borderRadius: '8px',
                    paddingLeft: '0px',
                    marginLeft: '2px',
                    textAlign: 'center',
                    fontSize: '12px',
                    background:'transparent'
                  }}
                  value={cornerRound}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  onChange={(event) => {
                    var value = parseInt(event.target.value);
                    if (isNaN(value)) {
                      value = '';
                    } else if (value > 100) {
                      value = 100;
                    } else if (value < 0) {
                      value = 0;
                    }
                    setCornerRound(value);
                    if (isNumber(value)) {
                      updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:value},borderRadius: [value, value, value, value]});
                    }
                  }}
              />
            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: '1',
            marginLeft: '-4px',
            marginTop: '-2px',
            width: '100%'
          }}>
            {/*<input*/}
            {/*    type="range"*/}
            {/*    min="0"*/}
            {/*    max="100"*/}
            {/*    step="1"*/}
            {/*    style={{height: '3px', width: '100%'}}*/}
            {/*    onChange={(event) => updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:event.currentTarget.value}})}*/}
            {/*    value={*/}
            {/*        getFormValue(*/}
            {/*            elements,*/}
            {/*            appState,*/}
            {/*            (element) => element.roundness?.value || 0,*/}
            {/*            true,*/}
            {/*            appState.currentItemRoundness?.value || 0,*/}
            {/*        ) ?? undefined*/}
            {/*    }*/}
            {/*/>*/}

            <Slider style={{width:'100%',marginRight:'-6px'}} tooltip={{open:false}} min={0} max={100} value={cornerRound} onChange={(value)=>{
              setCornerRound(value);
              updateData({roundness:{type:ROUNDNESS.ADAPTIVE_RADIUS,value:value},borderRadius: [value, value, value, value]})
            }}/>
          </div>
        </div>
    )
  },
});

export const actionChangeSloppiness = register({
  name: "changeSloppiness",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            seed: randomInteger(),
            roughness: value,
          }),
      ),
      appState: {...appState, currentItemRoughness: value},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => (
      <fieldset style={{display: "none"}}>
        <legend>{i18next.t("labels.sloppiness")}</legend>
        <ButtonIconSelect
            group="sloppiness"
            options={[
              {
                value: 0,
                text: t("labels.architect"),
                icon: SloppinessArchitectIcon,
              },
              {
                value: 1,
                text: t("labels.artist"),
                icon: SloppinessArtistIcon,
              },
              {
                value: 2,
                text: t("labels.cartoonist"),
                icon: SloppinessCartoonistIcon,
              },
            ]}
            value={getFormValue(
                elements,
                appState,
                (element) => element.roughness,
                (element) => element.hasOwnProperty("roughness"),
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemRoughness,
            )}
            onChange={(value) => updateData(value)}
        />
      </fieldset>
  ),
});

export const actionChangeStrokeStyle = register({
  name: "changeStrokeStyle",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            strokeStyle: value,
          }),
      ),
      appState: {...appState, currentItemStrokeStyle: value},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => (
      <fieldset>
        <Select variant={"borderless"} className='hovered-border' style={{width: '113px', height: '26px'}}
                optionLabelProp={'divItem'}
                suffixIcon={<IconDropdownSelected/>}
                options={[
                  {
                    value: "solid",
                    label: t("labels.strokeStyle_solid"),
                    icon: StrokeWidthBaseIcon,
                    backgroundSize: '1px',
                    divItem: <div style={{
                      height: '1px',
                      border: '0.5px solid #333333',
                      width: '100%'
                    }}></div>
                  },
                  {
                    value: "dashed",
                    label: t("labels.strokeStyle_dashed"),
                    icon: StrokeStyleDashedIcon,
                    backgroundSize: '14px 1px',
                    divItem: <div style={{
                      height: '1px',
                      backgroundImage: 'linear-gradient(to right, #333 0%, #333 50%, transparent 50%)',
                      backgroundRepeat: 'repeat-x',
                      backgroundSize: '14px 1px',
                      width: '100%'
                    }}></div>
                  },
                  {
                    value: "dotted",
                    label: t("labels.strokeStyle_dotted"),
                    icon: StrokeStyleDottedIcon,
                    backgroundSize: '8px 1px',
                    divItem: <div style={{height:'1px',
                backgroundImage: 'linear-gradient(to right, #333 0%, #333 50%, transparent 50%)',
                backgroundRepeat:'repeat-x',
                backgroundSize:'8px 1px',
                width:'100%'}}></div>
            },
          ]}

          value={getFormValue(
              elements,
              appState,
              (element) => element.strokeStyle,
              (element) => element.hasOwnProperty("strokeStyle"),
              (hasSelection) =>
                  hasSelection ? null : appState.currentItemStrokeStyle,
          )}
          onChange={(value) => updateData(value)}
              optionRender={(item)=>(
                  <div style={{height:'16px',display:'flex',alignItems:'center'}}>
                    {item.data.divItem}
                  </div>
              )}
      >

      </Select>

      {/*<legend>{i18next.t("labels.strokeStyle")}</legend>*/}
      {/*<ButtonIconSelect*/}
      {/*  group="strokeStyle"*/}
      {/*  options={[*/}
      {/*    {*/}
      {/*      value: "solid",*/}
      {/*      text: t("labels.strokeStyle_solid"),*/}
      {/*      icon: StrokeWidthBaseIcon,*/}
      {/*    },*/}
      {/*    {*/}
      {/*      value: "dashed",*/}
      {/*      text: t("labels.strokeStyle_dashed"),*/}
      {/*      icon: StrokeStyleDashedIcon,*/}
      {/*    },*/}
      {/*    {*/}
      {/*      value: "dotted",*/}
      {/*      text: t("labels.strokeStyle_dotted"),*/}
      {/*      icon: StrokeStyleDottedIcon,*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*  value={getFormValue(*/}
      {/*    elements,*/}
      {/*    appState,*/}
      {/*    (element) => element.strokeStyle,*/}
      {/*    (element) => element.hasOwnProperty("strokeStyle"),*/}
      {/*    (hasSelection) =>*/}
      {/*      hasSelection ? null : appState.currentItemStrokeStyle,*/}
      {/*  )}*/}
      {/*  onChange={(value) => updateData(value)}*/}
      {/*/>*/}
    </fieldset>
  ),
});

/**
 * 水平排列的边框样式.
 */
export const actionChangeStrokeStyleHorizontal = register({
  name: "changeStrokeStyleHorizontal",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) =>{
        if (isArrowElement(el)){
          localStorage.setItem(KEY_DRAW_ARROW_LINE_STYLE,value);
        }
        return newElementWith(el, {
              strokeStyle: value,
            })
      }),
      appState: { ...appState, currentItemStrokeStyle: value },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [strokeStyle,setStrokeStyle] = useState(getFormValue(
        elements,
        appState,
        (element) => element.strokeStyle,
        (element) => element.hasOwnProperty("strokeStyle"),
        (hasSelection) =>
            hasSelection ? null : appState.currentItemStrokeStyle,
    ));
    return (
        <div className='flex-row-vertical-center' style={{justifyContent:'space-between'}}>
          {
              getFormValue(elements,appState,(element)=>element.type != 'line' && element.type != 'arrow',true,false) &&
              <img className={'cursor-pointer'} style={{
                width: '52px', height: '30px', borderRadius: '8px', background:strokeStyle  == 'none' ? COLOR_E5E5E5() : 'transparent'
              }} src={getImagePathWithTheme('tool_no_stroke')} onClick={() => {
                setStrokeStyle('none')
                updateData('none')
              }}/>
          }

          <img className={'cursor-pointer'} style={{
            width: '52px', height: '30px', borderRadius: '8px', background: strokeStyle == 'solid' ? COLOR_E5E5E5() : 'transparent'
          }} src={getImagePathWithTheme('tool_stroke_line')} onClick={() => {
            setStrokeStyle('solid')
            updateData('solid')
          }}/>
          <img className={'cursor-pointer'} style={{width: '52px', height: '30px',borderRadius:'8px',background:strokeStyle=='dashed'?COLOR_E5E5E5():'transparent'}} src={getImagePathWithTheme('tool_stroke_dash')} onClick={()=>{
            setStrokeStyle('dashed')
            updateData('dashed')
          }}/>
          <img className={'cursor-pointer'} style={{width: '52px', height: '30px',borderRadius:'8px',background:strokeStyle=='dotted'?COLOR_E5E5E5():'transparent'}} src={getImagePathWithTheme('tool_stroke_dot')} onClick={()=>{
            setStrokeStyle('dotted')
            updateData('dotted')
          }}/>
        </div>
    )
  },
});

export const actionChangeOpacity = register({
  name: "changeOpacity",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
        elements,
        appState,
        (el) =>
          newElementWith(el, {
            opacity: value,
          }),
        true,
      ),
      appState: { ...appState, currentItemOpacity: value },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => (
    <label className="control-label">
      <div className='flex-row-vertical-center'>
        <div className='font-size-12' style={{flexShrink:'0'}}>{i18next.t("noOpacity")}</div>
        <div style={{display:'flex',alignItems:'center',flexGrow:'1',marginLeft:'4px',marginTop:'1px'}}>
          <input
              type="range"
              min="0"
              max="100"
              step="1"
              style={{height:'3px',border:'0px solid var(--input-border-color)',background:'transparent'}}
              onChange={(event) => updateData(+event.target.value)}
              value={
                getFormValue(
                    elements,
                    appState,
                    (element) => element.opacity,
                    true,
                    appState.currentItemOpacity,
                ) ?? undefined
              }
          />
          <div style={{display:'flex',alignItems:'center'}}>
            <input
                className='text-color-a'
                style={{width:'38px', height:'26px',border:'0px solid var(--input-border-color)',background:'transparent',borderRadius:'3px',paddingLeft:'2px',marginLeft:'2px'}}
                value={
                  getFormValue(
                      elements,
                      appState,
                      (element) => element.opacity+'%',
                      true,
                      appState.currentItemOpacity+'%',
                  ) ?? undefined
                }
                onChange={(event)=>{
                  var value = parseInt(event.target.value);
                  if (isNaN(value)){
                    value = 1;
                  }else if (value > 100){
                    value = 100;
                  }else if (value < 0){
                    value = 0;
                  }
                  updateData(+value)
                }}
            />
            {/*<span style={{marginLeft:'0px'}}>%</span>*/}
          </div>
        </div>
      </div>
    </label>
  ),
});

/**
 * 透明度弹出
 */
export const actionChangeOpacityPopover = register({
  name: "changeOpacityPopover",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (el) =>
              newElementWith(el, {
                opacity: value,
              }),
          true,
      ),
      appState: { ...appState, currentItemOpacity: value },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [isOpacityPopover,setIsOpacityPopover] = useState(false);
    const [opacity,setOpacity] = useState(getFormValue(
        elements,
        appState,
        (element) => element.opacity,
        true,
        appState.currentItemOpacity,
    ) ?? 100);
    const onKeydownListener = (e)=> {
      // debugLog('actionProperties',e);
      if (e.key == KEYS.ESCAPE){
        if (isOpacityPopover){
          setIsOpacityPopover(false)
        }
      }

    }
    useEffect(()=>{
      document.body.addEventListener('keydown',onKeydownListener);
      // return ()=>{
      //   document.body.removeEventListener('keydown',onKeydownListener);
      // }
    },[])
    return(<Popover trigger={"click"} placement={"bottom"}
             arrow={false}
                    open={isOpacityPopover}
                    onOpenChange={(e)=>setIsOpacityPopover(e)}
             overlayStyle={{top: DRAW_TOOL_POPOVER_TOP}}
             content={
               <div style={{margin: '-12px', padding: '16px', width: '254px', height: '80px'}}>
                 <div style={{display: 'flex', justifyContent: 'space-between'}}>
                   <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("noOpacity")}</div>

                   <div style={{display: 'flex', alignItems: 'center'}}>
                     <input
                         style={{
                           width: '36px',
                           height: '24px',
                           border: '1px solid var(--input-border-color)',
                           background:'transparent',
                           borderRadius: '8px',
                           paddingLeft: '0px',
                           marginLeft: '2px',
                           textAlign: 'center',
                           fontSize: '12px'
                         }}
                         value={opacity}
                         onFocus={(e) => {
                           e.currentTarget.select();
                         }}
                         onChange={(event) => {
                           var value = parseInt(event.target.value);
                           if (isNaN(value)) {
                             value = 1;
                           } else if (value > 100) {
                             value = 100;
                           } else if (value < 0) {
                             value = 0;
                           }
                           setOpacity(value)
                           updateData(value)
                         }}
                     />
                     <span style={{marginLeft: '6px'}}>%</span>
                   </div>
                 </div>

                 <div style={{
                   display: 'flex',
                   alignItems: 'center',
                   flexGrow: '1',
                   marginLeft: '-4px',
                   marginTop: '1px',
                   width: '100%'
                 }}>
                   {/*<input*/}
                   {/*    type="range"*/}
                   {/*    min="0"*/}
                   {/*    max="100"*/}
                   {/*    step="1"*/}
                   {/*    style={{height: '3px', width: '100%'}}*/}
                   {/*    onChange={(event) => updateData(+event.target.value)}*/}
                   {/*    value={*/}
                   {/*        getFormValue(*/}
                   {/*            elements,*/}
                   {/*            appState,*/}
                   {/*            (element) => element.opacity,*/}
                   {/*            true,*/}
                   {/*            appState.currentItemOpacity,*/}
                   {/*        ) ?? undefined*/}
                   {/*    }*/}
                   {/*/>*/}
                   <Slider style={{width: '100%', marginRight: '-6px'}} tooltip={{open: false}}
                           value={opacity} onChange={(value) => {
                             setOpacity(value)
                              updateData(value)
                   }}/>
                 </div>
               </div>
             }>
      <img className={'img-30'} src={getImagePathWithTheme('toolbar_transparent')}/>
    </Popover>
    )},
});


/**
 * 透明度弹出
 */
export const actionChangeOpacityPopoverContent = register({
  name: "changeOpacityPopoverContent",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (el) =>
              newElementWith(el, {
                opacity: value,
              }),
          true,
      ),
      appState: { ...appState, currentItemOpacity: value },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [isOpacityPopover,setIsOpacityPopover] = useState(false);
    const [opacity,setOpacity] = useState(getFormValue(
        elements,
        appState,
        (element) => element.opacity,
        true,
        appState.currentItemOpacity,
    ) ?? 100);
    const onKeydownListener = (e)=> {
      // debugLog('actionProperties',e);
      if (e.key == KEYS.ESCAPE){
        if (isOpacityPopover){
          setIsOpacityPopover(false)
        }
      }

    }
    useEffect(()=>{
      document.body.addEventListener('keydown',onKeydownListener);
      // return ()=>{
      //   document.body.removeEventListener('keydown',onKeydownListener);
      // }
    },[])
    return (
        <div style={{margin: '-12px', padding: '16px', width: '254px', height: '80px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("noOpacity")}</div>

            <div style={{display: 'flex', alignItems: 'center'}}>
              <input
                  style={{
                    width: '36px',
                    height: '24px',
                    border: '1px solid var(--input-border-color)',
                    background: 'transparent',
                    borderRadius: '8px',
                    paddingLeft: '0px',
                    marginLeft: '2px',
                    textAlign: 'center',
                    fontSize: '12px'
                  }}
                  value={opacity}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  onChange={(event) => {
                    var value = parseInt(event.target.value);
                    if (isNaN(value)) {
                      value = 1;
                    } else if (value > 100) {
                      value = 100;
                    } else if (value < 0) {
                      value = 0;
                    }
                    setOpacity(value)
                    updateData(+value)
                  }}
              />
              <span style={{marginLeft: '6px'}}>%</span>
            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: '1',
            marginLeft: '-4px',
            marginTop: '1px',
            width: '100%'
          }}>
            <Slider style={{width: '100%', marginRight: '-6px'}} tooltip={{open: false}}
                    value={opacity} onChange={(value) => {
                      setOpacity(value);
                      updateData(value)
            }}/>
          </div>
        </div>
    )
  },
});

/**
 * 修改字体大小
 * 修改字体
 * 字体
 * 大小
 * @param elements
 * @param appState
 * @param getNewFontSize
 * @param fallbackValue
 */
const changeFontSize = (
    elements: readonly ExcalidrawElement[],
    appState: AppState,
    getNewFontSize: (element: ExcalidrawTextElement) => number,
    fallbackValue?: ExcalidrawTextElement["fontSize"],
) => {
  const newFontSizes = new Set<number>();
  return {
    elements: changeProperty(
        elements,
        appState,
        (oldElement) => {
          if (isStickyNotesElement(oldElement) && ENABLE_STICKYNOTE_RICHTEXT_20250815) {
            const newFontSize = getNewFontSize(oldElement);
            // const quill = QuillCache.get(oldElement.id);
            let updated: any = {};
            // if (oldElement.isActive || quill.getSelection()?.length > 0) {
            //   quill.format("size", `${newFontSize}px`);
            // } else {
            //   const length = quill.getLength();
            //   quill.formatText(0, length - 1, "size", `${newFontSize}px`);
            //   updated = { fontSize: newFontSize };
            // }
            updated = { fontSize: newFontSize };

            const newElement00000000000: ExcalidrawStickyNotesElement = newElementWith(
                oldElement,
                updated,
            );
            console.log(newElement00000000000)
            return newElement00000000000;
          }

            if (isTextElement(oldElement) && !oldElement.containerId && HAS_ENABLE_TIPTAP_TEXT) {
                const newFontSize = getNewFontSize(oldElement);
                // const quill = QuillCache.get(oldElement.id);
                let updated: any = {};
                // if (oldElement.isActive || quill.getSelection()?.length > 0) {
                //   quill.format("size", `${newFontSize}px`);
                // } else {
                //   const length = quill.getLength();
                //   quill.formatText(0, length - 1, "size", `${newFontSize}px`);
                //   updated = { fontSize: newFontSize };
                // }
                updated = { fontSize: newFontSize };

                const newElement00000000000: ExcalidrawStickyNotesElement = newElementWith(
                    oldElement,
                    updated,
                );
                return newElement00000000000;
            }

          if (isTextElement(oldElement) || isStickyNotesElement(oldElement)) {
            const newFontSize = getNewFontSize(oldElement);
            newFontSizes.add(newFontSize);

            let newElement: ExcalidrawTextElement = newElementWith(oldElement, {
              // fontSize: newFontSize,
              ...fallbackValue
            });

            if (isTextElement(oldElement)){
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
            }

            newElement = offsetElementAfterFontResize(oldElement, newElement);

            if (isStickyNotesElement(oldElement)){
              //自动调整下大小
              setTimeout(()=>{
                const txt = document.getElementById("stickyNotes-"+oldElement.id);
                if (txt){
                  const inputEvent = new InputEvent('input',{bubbles:true});
                  txt.dispatchEvent(inputEvent);
                }
              },200)
            }

            return newElement;
          }

          return oldElement;
        },
        true,
    ),
    appState: {
      ...appState,
      // update state only if we've set all select text elements to
      // the same font size
      currentItemFontSize:
          newFontSizes.size === 1
              ? [...newFontSizes][0]
              : fallbackValue.fontSize ?? appState.currentItemFontSize,
    },
    commitToHistory: true,
  };
};

/**
 * 文本字体大小修改
 * 文本
 * 字体
 * 大小修改
 * 字体大小
 */
export const actionChangeFontSize = register({
  name: "changeFontSize",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return changeFontSize(elements, appState, () => value.fontSize, value);
  },
  PanelComponent: ({elements, appState, updateData, app}) => {

    const changeValue = useCallback(
        (data: any) => {
          if (data.id !== Object.keys(appState.selectedElementIds)[0]) {
            return;
          }
          const quill = QuillCache.get(data.id);
          const { size } = quill.getFormat(data.range);

          if (!size) {
            return;
          }
          let value = "";
          if (Array.isArray(size)) {
            value = size[size.length-1].split('px')[0];//取最后那个。
          } else {
            value = size.split("px")[0];
          }
          // @ts-ignore
          setValue(value);
          setFontSize(parseInt(value));
        },
        [appState.selectedElementIds],
    );


    const selectedElement = elements.find(
        (element) => element.id === Object.keys(appState.selectedElementIds)[0],
    );
    const [value, setValue] = useState(selectedElement?.fontSize || DEFAULT_FONT_SIZE);

    useEffect(() => {
      if (Object.keys(appState.selectedElementIds).length !== 1) {
        return;
      }
      const selectedElement = elements.find(
          (element) => element.id === Object.keys(appState.selectedElementIds)[0],
      );
      if (!isStickyNotesElement(selectedElement)) {
        return;
      }

      StickyNoteEmitter.on("selection-change", changeValue);
      return () => {
        StickyNoteEmitter.off("selection-change", changeValue);
      };
    }, [changeValue, appState.selectedElementIds, elements]);


    const getFontSize = getFormValue(
        elements,
        appState,
        (element) => {
          if (element.extra?.tempFontSize) {
            return (element.extra?.tempFontSize);
          }

          if (isTextElement(element) || isStickyNotesElement(element)) {
            return Math.floor(element.fontSize);
          }
          const boundTextElement = getBoundTextElement(element);
          if (boundTextElement) {
            if (boundTextElement.extra?.tempFontSize) {
              return (boundTextElement.extra?.tempFontSize);
            }
            return Math.floor(boundTextElement.fontSize);
          }
          return DEFAULT_FONT_SIZE;
        },
        (element) =>
            isTextElement(element) || getBoundTextElement(element) || isStickyNotesElement(element) !== null,
        (hasSelection) =>
            hasSelection
                ? DEFAULT_FONT_SIZE
                : appState.currentItemFontSize || DEFAULT_FONT_SIZE,
    )
    const [fontSize,setFontSize] = useState((isStickyNotesElement(selectedElement) && ENABLE_STICKYNOTE_RICHTEXT_20250815)?value:getFontSize);


    useEffect(()=>{
      recvMessage(EVENT_UPDATE_FONT_SIZE,(msg,data)=>{
        setFontSize(data.data.fontSize);
      },true);
    },[])

    useEffect(()=>{
      if(isTextElement(app.getSelectedElements()[0])) {
        localStorage.setItem(KEY_DEFAULT_TEXT_FONT_SIZE,mInputValue);
      }
    },[fontSize]);
    return(
    <fieldset>
      <legend style={{display: 'none'}}>{i18next.t("labels.fontSize")}</legend>
      {/*<Dropdown menu={{items:ARRAY_FONT_SIZE,onClick:(item)=>{*/}
      {/*    updateData(parseInt(item.key));*/}
      {/*  }}} trigger={['click']} overlayStyle={{width:'32px',maxWidth:'32px',overflowX:'hidden', height:'280px',maxHeight:'280px',overflow: 'auto',*/}
      {/*  borderRadius: '4px',*/}
      {/*  border: '1px solid #DDDEE3'}}>*/}
      {/*  */}
      {/*</Dropdown>*/}

      <div className='flex-row-vertical-center'
           style={{
             borderRadius: '8px',
             border: '0px solid var(--input-border-color)',
             width: '40px',
             height: '30px'
           }}>
        <ConfigProvider
            theme={{
              components: {
                InputNumber: {
                  /* 这里是你的组件 token */
                  handleVisible: false
                },
              },
            }}
        >

          <input
              className='default-font-size input-center input-none hovered-border-blue'
              style={{
                width: '32px',
                height:'26px',
                borderRadius:'4px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: '0px',
                margin: '0px',
                background: 'transparent',
              }}
              value={fontSize}
              // onChange={(e, event) => {
              //   // updateData(e);
              //   console.log('inputNumber onChange....');
              //   if (typeof e === 'number') {
              //     mInputValue = e;
              //   } else {
              //     mInputValue = 0;
              //   }
              //
              //   updateData({extra: {tempFontSize: e}});
              // }}
              onChange={(event) => {
                // mInputValue = parseInt(event.currentTarget.value)
                // if (isNaN(mInputValue)) {
                //   mInputValue = 0;
                // }
                if (isNumber(event.currentTarget.value) || event.currentTarget.value == ''){
                  mInputValue = parseInt(event.currentTarget.value)
                  if (mInputValue > DEFAULT_MAX_FONT_SIZE || mInputValue < 0) {
                    mInputValue = DEFAULT_FONT_SIZE;
                  }
                  setFontSize(event.currentTarget.value);
                }

                // updateData({extra: {...selectedElement.extra,tempFontSize: mInputValue}});
              }}

              onFocus={(event => {
                mInputValue = parseInt(event.currentTarget.value)
                if (isNaN(mInputValue)) {
                  mInputValue = 0;
                }
                event.currentTarget.select();
                app.onPointDownEvent((activeTool, pointerDownState) => {
                  updateData({fontSize: mInputValue, extra: {...selectedElement.extra,tempFontSize:''}});
                  app.onPointDownEvent(null);
                });
              })}
              onBlur={(event => {
                setTimeout(()=>{
                  setFontSize(mInputValue)
                  setValue(mInputValue)
                },100)
                updateData({fontSize: mInputValue, extra: {...selectedElement.extra,tempFontSize:''}});
                window.globalRefreshList('refresh-element-height_'+selectedElement?.id,selectedElement?.id);
              })}
              onKeyDown={(event => {
                if (event.key === KEYS.ENTER) {
                  event.stopPropagation();
                  event.preventDefault();
                  if (!isNumber(event.currentTarget.value)) {
                    updateData({extra: {...selectedElement.extra,tempFontSize:''}});

                  } else {
                    setTimeout(()=>{
                      setFontSize(mInputValue)
                      setValue(mInputValue)
                    },10)
                    updateData({fontSize: mInputValue});
                    window.globalRefreshList('refresh-element-height_'+selectedElement?.id,selectedElement?.id);
                  }
                  event.currentTarget.blur();
                }
              })}></input>

          <div className={'flex-col'}>
            <div className='flex-center'
                 style={{width: '10px', borderLeft: '0px solid var(--home-left-border-color)', height: '6px'}}
                 onClick={() => {
                   let nFontSize = fontSize + 1;
                   mInputValue = nFontSize;
                   setFontSize(nFontSize);
                   updateData({fontSize: mInputValue});
                   window.globalRefreshList('refresh-element-height_'+selectedElement?.id,selectedElement?.id);
                 }}>
              <img  className={'action-property-'} style={{width: '10px', height: '6px'}} src={getImagePathWithTheme('tra_up.svg', true)}/>
            </div>
            <div className='flex-center'
                 style={{width: '10px', borderRight: '0px solid var(--home-left-border-color)', height: '6px',marginTop:'2px'}}
                 onClick={() => {
                   let nFontSize = fontSize - 1
                   if (nFontSize <= 0) {
                     nFontSize = 1;
                   }
                   mInputValue = nFontSize;
                   setFontSize(nFontSize);
                   updateData({fontSize: mInputValue});
                   window.globalRefreshList('refresh-element-height_'+selectedElement?.id,selectedElement?.id);
                 }}>
              <img style={{width: '10px', height: '6px'}} src={getImagePathWithTheme('tra_down.svg', true)}/>
            </div>
          </div>

        </ConfigProvider>

        {/*<img className='img-mini-small-12' src={imgPathPerfix()+"drop_down_gray.png"}/>*/}
      </div>


      <div style={{display: 'none', alignItems: 'center'}}>
        <div style={{
          display: 'flex', alignItems: 'center',
          border: '1px solid var(--border-color)',
          height: '32px', width: '100%', marginLeft: '16px',
          padding: '0 0px', borderRadius: '6px'
        }}>

          <Input className='input-no-hover' style={{height: '24px', border: '0px', padding: '0px', textAlign: 'center'}}
                 value={
                   getFormValue(
                       elements,
                       appState,
                       (element) => {
                         if (isTextElement(element)) {
                           return Math.floor(element.fontSize);
                         }
                         const boundTextElement = getBoundTextElement(element);
                         if (boundTextElement) {
                           return Math.floor(boundTextElement.fontSize);
                         }
                         return null;
                       },
                       (element) =>
                           isTextElement(element) || getBoundTextElement(element) !== null,
                       (hasSelection) =>
                           hasSelection
                               ? null
                               : appState.currentItemFontSize || DEFAULT_FONT_SIZE,
                   )
                 }
                 onChange={(e) => {
                   var value = (e.currentTarget.value);
                   const reg = /^-?\d*(\.\d*)?$/;
                   if (reg.test(value)) {
                     updateData(parseInt(value));
                   }
                 }}
          />
          <div className={'flex-col'}>
            <div className='hovered' onClick={() => {
              var arrayEles = elements;
              var selEle = undefined;
              for (var i = 0; i < arrayEles.length; i++) {
                if (appState.selectedElementIds[arrayEles[i].id] != undefined) {
                  selEle = arrayEles[i];
                  break;
                }
              }
              if (selEle == undefined) {
                selEle = appState.editingElement;
              }
              //inner text
              var selTextEle = selEle;
              if (!isTextElement(selEle)) {
                if (selEle.boundElements != undefined) {
                  for (var j = 0; j < selEle.boundElements.length; j++) {
                    var boundEle = selEle.boundElements[j];
                    if (boundEle.type === 'text') {
                      for (var i = 0; i < arrayEles.length; i++) {
                        var ele = arrayEles[i];
                        if (ele.id === boundEle.id) {
                          selTextEle = ele;
                          break;
                        }
                      }
                    }
                  }
                }
              }

              var newSize = selTextEle?.fontSize - 1;
              if (newSize < 2) {
                newSize = 2;
              }
              updateData(newSize);
            }} style={{
              width: '10px',
              height: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRight: '0px solid var(--border-color)',
              flexShrink: '0'
            }}>
              <img style={{width:'10px',height:'6px'}} src={getImagePathWithTheme('tra_up.svg', true)}/>
            </div>

            <div className='hovered' onClick={() => {
              var arrayEles = elements;
              var selEle = undefined;
              for (var i = 0; i < arrayEles.length; i++) {
                if (appState.selectedElementIds[arrayEles[i].id] != undefined) {
                  selEle = arrayEles[i];
                  break;
                }
              }

              if (selEle == undefined) {
                selEle = appState.editingElement;
              }

              //inner text
              var selTextEle = selEle;
              if (!isTextElement(selEle)) {
                if (selEle.boundElements != undefined) {
                  for (var j = 0; j < selEle.boundElements.length; j++) {
                    var boundEle = selEle.boundElements[j];
                    if (boundEle.type === 'text') {
                      for (var i = 0; i < arrayEles.length; i++) {
                        var ele = arrayEles[i];
                        if (ele.id === boundEle.id) {
                          selTextEle = ele;
                          break;
                        }
                      }
                    }
                  }
                }
              }


              var newSize = selTextEle?.fontSize + 1;
              if (newSize > DEFAULT_MAX_FONT_SIZE) {
                newSize = DEFAULT_FONT_SIZE;
              }
              updateData(newSize)
            }} style={{
              width: '10px',
              height: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderLeft: '0px solid var(--border-color)',
              flexShrink: '0'
            }}>
              <img style={{width:'10px',height:'6px'}} src={getImagePathWithTheme('tra_down.svg', true)}/>
            </div>
          </div>

        </div>
      </div>

    </fieldset>
    )},
});

export const actionDecreaseFontSize = register({
  name: "decreaseFontSize",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return changeFontSizeInOrDe(elements, appState, (element) =>
        // get previous value before relative increase (doesn't work fully
        // due to rounding and float precision issues)
        //     Math.round((1 / (1 + FONT_SIZE_RELATIVE_INCREASE_STEP)) * element.fontSize,),
        Math.round(element.fontSize - 1),
    );
  },
  keyTest: (event) => {
    return (
      event[KEYS.CTRL_OR_CMD] &&
      event.shiftKey &&
      // KEYS.COMMA needed for MacOS
      (event.key === KEYS.CHEVRON_LEFT || event.key === KEYS.COMMA)
    );
  },
});

export const actionIncreaseFontSize = register({
  name: "increaseFontSize",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return changeFontSizeInOrDe(elements, appState, (element) =>
      // Math.round(element.fontSize * (1 + FONT_SIZE_RELATIVE_INCREASE_STEP)),
        Math.round(element.fontSize + 1),
    );
  },
  keyTest: (event) => {
    return (
      event[KEYS.CTRL_OR_CMD] &&
      event.shiftKey &&
      // KEYS.PERIOD needed for MacOS
      (event.key === KEYS.CHEVRON_RIGHT || event.key === KEYS.PERIOD)
    );
  },
});

export const actionChangeFontFamily = register({
  name: "changeFontFamily",
  trackEvent: false,
  perform: (elements, appState, value) => {
    if (value.extra != undefined && value.extra.hasOwnProperty("isHover")){
      return {
        elements: changeProperty(
            elements,
            appState,
            (oldElement) => {
                const newElement: ExcalidrawTextElement = newElementWith(
                    oldElement,
                    {
                      fontFamily: value.fontFamily,
                      extra:value.extra.isHover?value.extra:null
                    },
                );
                return newElement;
            },
            true,
        ),
        appState: {
          ...appState,
          currentItemFontFamily: value.fontFamily,
        },
        commitToHistory: true,
      };
    }
    return {
      elements: changeProperty(
        elements,
        appState,
        (oldElement) => {
          if (isTextElement(oldElement) || isStickyNotesElement(oldElement)) {
            const newElement: ExcalidrawTextElement = newElementWith(
              oldElement,
              {
                fontFamily: value,
                // lineHeight: getDefaultLineHeight(value),
              },
            );
              if ((isTextElement(oldElement) && !HAS_ENABLE_TIPTAP_TEXT) || (isTextElement(oldElement) && oldElement.containerId)){
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
            }
              if (isTextElement(oldElement)){
                //保存字体名称...
                localStorage.setItem(KEY_DEFAULT_TEXT_FONT_FAMILY,value);
              }

            return newElement;
          }

          return oldElement;
        },
        true,
      ),
      appState: {
        ...appState,
        currentItemFontFamily: value,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [isOpenSelect,setIsOpenSelect] = useState(false);
    const [isHover,setIsHover] = useState(false);

    useEffect(()=>{
      recvMessage(EVENT_OPEN_SELECT_FONT_FAMILY,(msg,data)=>{
        setIsOpenSelect(true);
        setTimeout(()=>{
          document.getElementById('selectFontFamily')?.scroll(0,0);
        },200)
      },true)
    },[])
    const options: {
      value: FontFamilyValues;
      text: string;
      icon: JSX.Element;
      testId: string;
    }[] = [
      {
        value: FONT_FAMILY.OpenSans,
        text: t("labels.handDrawn"),
        icon: FreedrawIcon,
        testId: "font-family-virgil",
      },
      {
        value: FONT_FAMILY.Helvetica,
        text: t("labels.normal"),
        icon: FontFamilyNormalIcon,
        testId: "font-family-normal",
      },
      {
        value: FONT_FAMILY.Cascadia,
        text: t("labels.code"),
        icon: FontFamilyCodeIcon,
        testId: "font-family-code",
      },
    ];

    let arrayCustomFonts:any[] = [];
    for (let i=0;i<global.g_arrayFonts.length;i++){
      const font = global.g_arrayFonts[i];
      let item = { value: font.fontName,shortName:font.shortName, label:font.fontName ,showLabel:<span className='align-left' style={{fontFamily:font.fontName,whiteSpace:'nowrap',width:'126px',overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{font.fontName}</span>};
      arrayCustomFonts.push(item);
      FONT_FAMILY[font.fontName] = font.fontName;
    }

    //Virgil
    let arrayDefaultFonts =  [
      // { value: FONT_FAMILY.Default, label: i18next.t('Default font'),showLabel:<span className='align-left' style={{fontFamily:"default"}}>{i18next.t('Default font')}</span>},
      { value: FONT_FAMILY.Helvetica, label: 'Helvetica' ,showLabel:<span className='align-left' style={{fontFamily:"Helvetica"}}>Helvetica</span>},
      { value: FONT_FAMILY.OpenSans, label: 'Open sans',showLabel:<span className='align-left' style={{fontFamily:"Open sans"}}>{'Open sans'}</span>},
      { value: FONT_FAMILY.Cascadia, label: 'Cascadia',showLabel:<span className='align-left' style={{fontFamily:"Cascadia"}}>Cascadia</span> },
      // {value: FONT_FAMILY.Sparky,label: "Sparky"},
      // {value: FONT_FAMILY.Delight,label: "Delight"},
      // {value: FONT_FAMILY.HoneySilk,label: "HoneySilk"},
      // {value: FONT_FAMILY.Netigen,label: "Netigen"},
      // {value: FONT_FAMILY.Playfulist,label: "Playfulist"},
      // {value: FONT_FAMILY.WigglyCurves,label: "WigglyCurves"},
      {value: FONT_FAMILY.Winter,label: "Winter",showLabel:<span className='align-left' style={{fontFamily:"Winter"}}>Winter</span>},
      // {value: FONT_FAMILY.YeastyFlavors,label: "YeastyFlavors"},
      // {value: FONT_FAMILY.MUMMY_S,label: "MUMMY_S"},
      {value: FONT_FAMILY.Dufanthe,label: "Dufanthe",showLabel:<span className='align-left' style={{fontFamily:"Dufanthe"}}>Dufanthe</span>},
      // {value: FONT_FAMILY.PacifyAngry,label: "PacifyAngry"},
      {value: FONT_FAMILY.WinterCoffee,label: "WinterCoffee",showLabel:<span className='align-left' style={{fontFamily:"WinterCoffee"}}>WinterCoffee</span>},
      {value: FONT_FAMILY.Pacifico,label: "Pacifico",showLabel:<span className='align-left' style={{fontFamily:"Pacifico"}}>Pacifico</span>},
      // {value: FONT_FAMILY.MilkyCoffee,label: "MilkyCoffee"},
      {value: FONT_FAMILY.Gagalin,label: "Gagalin",showLabel:<span className='align-left' style={{fontFamily:"Gagalin"}}>Gagalin</span>},
      {value: FONT_FAMILY.AreaKilometer,label: "AreaKilometer",showLabel:<span className='align-left' style={{fontFamily:"AreaKilometer"}}>AreaKilometer</span>},
      // {value: FONT_FAMILY.Anggota,label: "Anggota"},
      {value: FONT_FAMILY.CallOfOpsDuty,label: "CallOfOpsDuty",showLabel:<span className='align-left' style={{fontFamily:"CallOfOpsDuty"}}>CallOfOpsDuty</span>},
      // {value: FONT_FAMILY.BlankNote,label: "BlankNote"},
      {value: FONT_FAMILY.Tropikal,label: "Tropikal",showLabel:<span className='align-left' style={{fontFamily:"Tropikal"}}>Tropikal</span>},
      // {value: FONT_FAMILY.MuyaoPleased,label: "MuyaoPleased"},
      // {value: FONT_FAMILY.Loftygoals,label: "Loftygoals"},
      // {value: FONT_FAMILY.NotesSans,label: "NotesSans"},
      {value: FONT_FAMILY.SAF,label: "SAF",showLabel:<span className='align-left' style={{fontFamily:"SAF"}}>SAF</span>},
      {value: FONT_FAMILY.Inter,label: "Inter",showLabel:<span className='align-left' style={{fontFamily:"Inter"}}>Inter</span>},
      {value: FONT_FAMILY.Poppins,label: "Poppins",showLabel:<span className='align-left' style={{fontFamily:"Poppins"}}>Poppins</span>},
      {value: FONT_FAMILY.Roboto,label: "Roboto",showLabel:<span className='align-left' style={{fontFamily:"Roboto"}}>Roboto</span>},
      {value: FONT_FAMILY.MontaguSlab,label: "MontaguSlab",showLabel:<span className='align-left' style={{fontFamily:"MontaguSlab"}}>MontaguSlab</span>},
      {value: FONT_FAMILY.Lora,label: "Lora",showLabel:<span className='align-left' style={{fontFamily:"Lora"}}>Lora</span>},
      {value: FONT_FAMILY.RobotoMono,label: "RobotoMono",showLabel:<span className='align-left' style={{fontFamily:"RobotoMono"}}>RobotoMono</span>}
    ]
    for (let i=0;i<arrayDefaultFonts.length;i++){
      let item:any = arrayDefaultFonts[i];
      item.showLabel = <span className='align-left' style={{fontFamily:item.label,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{item.label}</span>
      item.showLabel_1 = <span className='align-left' style={{fontFamily:item.label,whiteSpace:'nowrap',width:'68px',overflow:'hidden',textOverflow:'ellipsis',display:'block'}}>{item.label}</span>
    }

    let arrayOptions:any = arrayDefaultFonts;

    if (arrayCustomFonts.length > 0){
      arrayOptions = [
        {
          label: <span>Custom Fonts</span>,
          title: 'custom',
          options:arrayCustomFonts
        },
        {
          label: <span>Default Fonts</span>,
          title: 'default',
          options:arrayDefaultFonts
        }
      ]
    }

    const isFontFamilyExist = (fontFamily)=>{
      return Object.values(FONT_FAMILY).filter((p)=>p == fontFamily).length > 0;
    }

    //获取当前字体名称
    const getCurrentFontValue = ()=>{
      return getFormValue(
          elements,
          appState,
          (element) => {
            if (isTextElement(element) || isStickyNotesElement(element)) {
              if (isFontFamilyExist(element.fontFamily)){
                try {
                  const intValue = parseInt(element.fontFamily);
                  if (isNaN(intValue)){
                    return element.fontFamily;
                  }
                  return intValue;
                }catch (e){

                }
                return element.fontFamily ;
              }
              return  DEFAULT_FONT_FAMILY;
            }
            const boundTextElement = getBoundTextElement(element);
            if (boundTextElement) {
              return isFontFamilyExist(boundTextElement.fontFamily)? boundTextElement.fontFamily : DEFAULT_FONT_FAMILY;
            }
            return DEFAULT_FONT_FAMILY;
          },
          (element) =>
              isTextElement(element) || getBoundTextElement(element) || isStickyNotesElement(element) !== null,
          (hasSelection) =>
              hasSelection
                  ? DEFAULT_FONT_FAMILY
                  : isFontFamilyExist(appState.currentItemFontFamily)?appState.currentItemFontFamily : DEFAULT_FONT_FAMILY,
      )
    }

    //下拉渲染...
    const renderDropdown = ()=>{
      if (arrayCustomFonts.length == 0){
        return arrayDefaultFonts.map(p=>
            <div className='flex-row-vertical-center dropdown-item' key={p.value} onMouseDown={()=>{
              updateData(p.value);
              setIsOpenSelect(false)
            }}>
              <img style={{opacity:(getCurrentFontValue() == p.value)?'1':"0"}} className='img-14 mr-10 ml-10' src={getImagePathWithTheme('check_black')}/>
              {p.showLabel}
            </div>
        )
      }else{
        return(
            <div>
              {
                arrayOptions.map((item: any) => {
                  return (
                      <div key={generateUUID2()}  style={{margin:'4px 0 6px 0'}}>
                        {
                          <div className='ml-10 font-family-medium' style={{color:'#96A0B5',fontSize:'14px'}}>{item.label}</div>
                        }
                        {
                          item.options.map((p: any) => {
                            return (
                                <div key={generateUUID2()} className='flex-row-vertical-center dropdown-item' onMouseDown={()=>{
                                  updateData(p.value);
                                  setIsOpenSelect(false)
                                }}>
                                  <img style={{opacity: (getCurrentFontValue() == p.value) ? '1' : "0"}}
                                       className='img-14 mr-10 ml-10' src={getImagePathWithTheme('check_black')}/>
                                  {p.showLabel}
                                </div>)
                          })
                        }
                        <div style={{width: '120%', margin: '6px -16px 10px -16px',borderBottom:'1px solid var(--font-line-color)'}}></div>
                      </div>
                  )
                })
              }
            </div>
        )
      }
    }

    return (
        <fieldset style={{width: '100%'}}>
          {/*<legend>{i18next.t("labels.fontFamily")}</legend>*/}
          {/*<legend>Font</legend>*/}
          <div>
            <Select
                open={isOpenSelect}
                onDropdownVisibleChange={(e) => setIsOpenSelect(e)}
                className='hovered-border actionproperty-choose-font-family'
                variant={"borderless"}
                suffixIcon={<img className='img-mini-small-10' src={getImagePathWithTheme('drop_down_select')} onClick={()=>setIsOpenSelect(true)}/>}
                dropdownStyle={{width: '187px'}}

                // onMouseEnter={(e)=>{
                //   const arrayElements = getSelectedElements(elements,appState);
                //   if (arrayElements.length > 0){
                //     const element = arrayElements[0];
                //     let fontFamily = DEFAULT_FONT_FAMILY;
                //     if (isTextElement(element)){
                //       fontFamily = element.fontFamily;
                //     }
                //     const boundElement = getBoundTextElement(element);
                //     if (boundElement != null){
              //       fontFamily = boundElement.fontFamily;
              //     }
              //     updateData({fontFamily,extra:{isHover:true}})
              //   }
              // }}
              // onMouseLeave={(e)=>{
              //   const arrayElements = getSelectedElements(elements,appState);
              //   if (arrayElements.length > 0){
              //     const element = arrayElements[0];
              //     let fontFamily = DEFAULT_FONT_FAMILY;
              //     if (isTextElement(element)){
              //       fontFamily = element.fontFamily;
              //     }
              //     const boundElement = getBoundTextElement(element);
              //     if (boundElement != null){
              //       fontFamily = boundElement.fontFamily;
              //     }
              //     updateData({fontFamily,extra:{isHover:false}})
              //   }
              // }}
              style={{
                // width:getFormValue(
                //     elements,
                //     appState,
                //     (element) => {
                //       if (element.extra?.isHover)return '100%';
                //       return 'auto';
                //     },
                //     (element) =>
                //         isTextElement(element) || getBoundTextElement(element) !== null,
                //     (hasSelection) =>
                //         'auto',
                // ),
                width:'106px',
                height:'30px',
                fontSize:'12px',
                borderRadius:'8px',
                // border:'1px solid var(--input-border-color)',

                // marginLeft:getFormValue(
                //     elements,
                //     appState,
                //     (element) => {
                //       if (element.extra?.isHover)return '0px';
                //       return '-12px';
                //     },
                //     (element) =>
                //         isTextElement(element) || getBoundTextElement(element) !== null,
                //     (hasSelection) =>
                //         '-12px',
                // )
              }}
              options={arrayOptions}
              onChange={(key)=>{
                updateData(key)
              }}
              dropdownRender={(menu)=>(
                <div id={'selectFontFamily'} style={{display:"flex",flexDirection:'column',height:'320px',overflowX:'hidden',overflowY:'auto'}}>
                  {
                    renderDropdown()
                  }
                  <div className='flex-column-center'>
                    <div className='flex-center mt-10 mb-12 hovered' style={{minWidth: '106px',height:'30px',position:'relative',border:'1px solid var(--import-font-border-color)',borderRadius:'8px'}} onClick={()=>{
                      setIsOpenSelect(false);
                      postMessage(EVENT_SHOW_FONT_CHOOSE);
                    }}>
                      <span>{i18next.t("Import font")}</span>
                      {
                        !hasLicense() && !hasDesktopBaseLicense() &&
                        <img className='img-18' style={{position: 'absolute', right: '-8px', top: '-10px'}}
                             src={imgPathPerfix() + 'vip.png'}/>
                      }
                    </div>
                  </div>

                </div>
              )}
              optionRender={(oriOption, info) =>
                  <div className='flex-row-vertical-center'>
                    <img className='img-mini-small-12 filter-img-white' src={imgPathPerfix()+
                        ((getFormValue(
                            elements,
                            appState,
                            (element) => {
                              if (isTextElement(element)) {
                                return element.fontFamily ;
                              }
                              const boundTextElement = getBoundTextElement(element);
                              if (boundTextElement) {
                                return boundTextElement.fontFamily || DEFAULT_FONT_FAMILY;
                              }
                              return null;
                            },
                            (element) =>
                                isTextElement(element) || getBoundTextElement(element) !== null,
                            (hasSelection) =>
                                hasSelection
                                    ? null
                                    : appState.currentItemFontFamily || DEFAULT_FONT_FAMILY,
                        )) == oriOption.value ? 'check_black.png':'transparent.png')
                    }/>
                    <span className='ml-8' style={{fontFamily: (oriOption.data.shortName != undefined)?oriOption.data.shortName:oriOption.label}}>{oriOption.label}</span>
                  </div>

              }
              optionLabelProp={'showLabel_1'}
              value={getCurrentFontValue()}
          />
        </div>


        {/*<ButtonIconSelect<FontFamilyValues | false>*/}
        {/*  group="font-family"*/}
        {/*  options={options}*/}
        {/*  value={getFormValue(*/}
        {/*    elements,*/}
        {/*    appState,*/}
        {/*    (element) => {*/}
        {/*      if (isTextElement(element)) {*/}
        {/*        return element.fontFamily;*/}
        {/*      }*/}
        {/*      const boundTextElement = getBoundTextElement(element);*/}
        {/*      if (boundTextElement) {*/}
        {/*        return boundTextElement.fontFamily;*/}
        {/*      }*/}
        {/*      return null;*/}
        {/*    },*/}
        {/*    (element) =>*/}
        {/*      isTextElement(element) || getBoundTextElement(element) !== null,*/}
        {/*    (hasSelection) =>*/}
        {/*      hasSelection*/}
        {/*        ? null*/}
        {/*        : appState.currentItemFontFamily || DEFAULT_FONT_FAMILY,*/}
        {/*  )}*/}
        {/*  onChange={(value) => updateData(value)}*/}
        {/*/>*/}
      </fieldset>
    );
  },
});

export const actionChangeTextAlign = register({
  name: "changeTextAlign",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
        elements,
        appState,
        (oldElement) => {
          if (isStickyNotesElement(oldElement)) {
            const newElement: ExcalidrawStickyNotesElement = newElementWith(
                oldElement,
                {
                  textAlign: value,
                },
            );
            return newElement;
          }

          if (isTextElement(oldElement)) {
            const newElement: ExcalidrawTextElement = newElementWith(
              oldElement,
              { textAlign: value },
            );
            redrawTextBoundingBox(newElement, getContainerElement(oldElement));
            return newElement;
          }

          return oldElement;
        },
        true,
      ),
      appState: {
        ...appState,
        currentItemTextAlign: value,
      },
      commitToHistory: true,
    };
  },
  keyTest: (event) => {
    const isShortKey = event[KEYS.CTRL_OR_CMD] && event.shiftKey;
    if (!isShortKey) {
      return false;
    }
    const directKeys = [
      // KEYS.L,
      // KEYS.L.toLocaleUpperCase(),
      KEYS.C,
      KEYS.C.toLocaleUpperCase(),
      KEYS.R,
      KEYS.R.toLocaleUpperCase(),
    ];

    return directKeys.includes(event.key);
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    return (
      <fieldset>
        {/*<legend>{i18next.t("labels.textAlign")}</legend>*/}
        <div className='flex-row-vertical-center ml-12'>
          <div className='flex-center border-radius-4-with-hover' style={{padding:'0px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) => {
                  if (isTextElement(element)) {
                    return element.textAlign === 'left'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  const boundTextElement = getBoundTextElement(element);
                  if (boundTextElement) {
                    return boundTextElement.textAlign === 'left'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  return null;
                },
                (element) =>
                    isTextElement(element) || getBoundTextElement(element) !== null,
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemTextAlign,
            )}} onClick={()=>{
            updateData("left");
          }}>
            <img className='img-26' src={imgPathPerfix()+"align_left.png"}/>
          </div>

          <div className='flex-center border-radius-4-with-hover' style={{padding:'0px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) => {
                  if (isTextElement(element)) {
                    return element.textAlign === 'center'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  const boundTextElement = getBoundTextElement(element);
                  if (boundTextElement) {
                    return boundTextElement.textAlign === 'center'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  return null;
                },
                (element) =>
                    isTextElement(element) || getBoundTextElement(element) !== null,
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemTextAlign,
            ),margin:'0 12px'}} onClick={()=>{
            updateData("center")
          }}>
            <img className='img-26' src={imgPathPerfix()+"align_center.png"}/>
          </div>

          <div className='flex-center border-radius-4-with-hover' style={{padding:'0px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) => {
                  if (isTextElement(element)) {
                    return element.textAlign === 'right'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  const boundTextElement = getBoundTextElement(element);
                  if (boundTextElement) {
                    return boundTextElement.textAlign === 'right'?DEFAULT_ATTR_SELECT_COLOR:'transparent';
                  }
                  return null;
                },
                (element) =>
                    isTextElement(element) || getBoundTextElement(element) !== null,
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemTextAlign,
            )}} onClick={()=>{
            updateData("right")
          }}>
            <img className='img-26' src={imgPathPerfix()+"align_right.png"}/>
          </div>
        </div>

        {/*<ButtonIconSelect<TextAlign | false>*/}
        {/*  group="text-align"*/}
        {/*  options={[*/}
        {/*    {*/}
        {/*      value: "left",*/}
        {/*      text: t("labels.left"),*/}
        {/*      icon: TextAlignLeftIcon,*/}
        {/*      testId: "align-left",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: "center",*/}
        {/*      text: t("labels.center"),*/}
        {/*      icon: TextAlignCenterIcon,*/}
        {/*      testId: "align-horizontal-center",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: "right",*/}
        {/*      text: t("labels.right"),*/}
        {/*      icon: TextAlignRightIcon,*/}
        {/*      testId: "align-right",*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  value={getFormValue(*/}
        {/*    elements,*/}
        {/*    appState,*/}
        {/*    (element) => {*/}
        {/*      if (isTextElement(element)) {*/}
        {/*        return element.textAlign;*/}
        {/*      }*/}
        {/*      const boundTextElement = getBoundTextElement(element);*/}
        {/*      if (boundTextElement) {*/}
        {/*        return boundTextElement.textAlign;*/}
        {/*      }*/}
        {/*      return null;*/}
        {/*    },*/}
        {/*    (element) =>*/}
        {/*      isTextElement(element) || getBoundTextElement(element) !== null,*/}
        {/*    (hasSelection) =>*/}
        {/*      hasSelection ? null : appState.currentItemTextAlign,*/}
        {/*  )}*/}
        {/*  onChange={(value) => updateData(value)}*/}
        {/*/>*/}
      </fieldset>
    );
  },
});

/**
 * 弹出的文本对齐
 */
export const actionChangeTextAlignPopover= register({
  name: "changeTextAlignPopover",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
              if (isStickyNotesElement(oldElement)  || (isTextElement(oldElement) && !oldElement.containerId && HAS_ENABLE_TIPTAP_TEXT)) {
              const newElement: ExcalidrawStickyNotesElement = newElementWith(
                  oldElement,
                  {
                    textAlign: value,
                  },
              );

              if (StickyNoteTiptapCache.get(oldElement.id)){
                setTimeout(()=>{
                  // 保存当前光标位置（如果有的话）
                  const editor = StickyNoteTiptapCache.get(oldElement.id);
                  const currentPosition = editor.state.selection.from;
                  editor.chain().selectAll().setTextAlign(value).setTextSelection(currentPosition).run();
                },100)
              }

                if (TextTiptapCache.get(oldElement.id)) {
                  setTimeout(() => {
                    // 保存当前光标位置（如果有的话）
                    const editor = TextTiptapCache.get(oldElement.id);
                    const currentPosition = editor.state.selection.from;
                    editor.chain().selectAll().setTextAlign(value).setTextSelection(currentPosition).run();
                  }, 100)
                }

              return newElement;
            }

            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  { textAlign: value },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemTextAlign: value,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const getDefaultTextAlign = getFormValue(
        elements,
        appState,
        (element) => {
          if (isTextElement(element)) {
            return element.textAlign ;
          }
          const boundTextElement = getBoundTextElement(element);
          if (boundTextElement) {
            return boundTextElement.textAlign;
          }
          return 'left';
        },
        (element) =>
            isTextElement(element) || getBoundTextElement(element) !== null,
        (hasSelection) =>
            hasSelection ? null : appState.currentItemTextAlign,
    );

    const [textAlign,setTextAlign] = useState(getDefaultTextAlign);

    return (
        <div className='div-align'>
          <img className='img-30' src={getImagePathWithTheme('tool_align_text_left')}
               style={{
                 background: (textAlign === 'left')?COLOR_E5E5E5() : 'transparent'
               }}
               onClick={() => {
                 setTextAlign('left')
                 updateData("left");
               }}
          />
          <img className='img-30' src={getImagePathWithTheme('tool_align_text_center')}
               style={{
                 background: (textAlign === 'center')?COLOR_E5E5E5() : 'transparent'
               }}
               onClick={() => {
                 setTextAlign('center')
                 updateData("center");
               }}
          />
          <img className='img-30' src={getImagePathWithTheme('tool_align_text_right')}
               style={{
                 background: (textAlign === 'right')?COLOR_E5E5E5() : 'transparent'
               }}
               onClick={() => {
                 setTextAlign('right')
                 updateData("right");
               }}
          />
        </div>

  )
    ;
  },
});

export const actionChangeVerticalAlign = register({
  name: "changeVerticalAlign",
  trackEvent: {category: "element"},
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  {verticalAlign: value},
              );

              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => {
    return (
        <fieldset>
          <div className='flex-row-vertical-center'>
            <div className='flex-center hovered' style={{
              padding: '3px', backgroundColor: getFormValue(
                  elements,
                  appState,
                  (element) => {
                    const boundTextElement = getBoundTextElement(element);
                    if (boundTextElement) {
                      return boundTextElement.verticalAlign === VERTICAL_ALIGN.TOP ? '#F5F5F5' : 'transparent';
                    }
                    return null;
                  },
                  (element) =>
                      isTextElement(element) || getBoundTextElement(element) !== null,
                  (hasSelection) =>
                      (hasSelection ? null : VERTICAL_ALIGN.MIDDLE),
              )
            }} onClick={() => {
              updateData(VERTICAL_ALIGN.TOP);
            }}>
              <img className='img-mini-small-12' src={imgPathPerfix() + "align_vertical_top.png"}/>
            </div>

            <div className='flex-center hovered' style={{
              padding: '3px', backgroundColor: getFormValue(
                  elements,
                  appState,
                  (element) => {
                    const boundTextElement = getBoundTextElement(element);
                    if (boundTextElement) {
                      return boundTextElement.verticalAlign === VERTICAL_ALIGN.MIDDLE ? '#F5F5F5' : 'transparent';
                    }
                    return null;
                  },
                  (element) =>
                      isTextElement(element) || getBoundTextElement(element) !== null,
                  (hasSelection) =>
                      (hasSelection ? null : VERTICAL_ALIGN.MIDDLE),
              ),margin:'0 12px'}} onClick={()=>{
            updateData(VERTICAL_ALIGN.MIDDLE)
          }}>
            <img className='img-mini-small-12' src={imgPathPerfix()+"align_vertical_center.png"}/>
          </div>

          <div className='flex-center hovered' style={{padding:'3px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) => {
                  const boundTextElement = getBoundTextElement(element);
                  if (boundTextElement) {
                    return boundTextElement.verticalAlign === VERTICAL_ALIGN.BOTTOM?'#F5F5F5':'transparent';
                  }
                  return null;
                },
                (element) =>
                    isTextElement(element) || getBoundTextElement(element) !== null,
                (hasSelection) =>
                    (hasSelection ? null : VERTICAL_ALIGN.MIDDLE),
            )}} onClick={()=>{
            updateData(VERTICAL_ALIGN.BOTTOM)
          }}>
            <img className='img-mini-small-12' src={imgPathPerfix()+"align_vertical_bottom.png"}/>
          </div>
        </div>

        {/*<ButtonIconSelect<VerticalAlign | false>*/}
        {/*  group="text-align"*/}
        {/*  options={[*/}
        {/*    {*/}
        {/*      value: VERTICAL_ALIGN.TOP,*/}
        {/*      text: t("labels.alignTop"),*/}
        {/*      icon: <TextAlignTopIcon theme={appState.theme} />,*/}
        {/*      testId: "align-top",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: VERTICAL_ALIGN.MIDDLE,*/}
        {/*      text: t("labels.centerVertically"),*/}
        {/*      icon: <TextAlignMiddleIcon theme={appState.theme} />,*/}
        {/*      testId: "align-middle",*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: VERTICAL_ALIGN.BOTTOM,*/}
        {/*      text: t("labels.alignBottom"),*/}
        {/*      icon: <TextAlignBottomIcon theme={appState.theme} />,*/}
        {/*      testId: "align-bottom",*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  value={getFormValue(*/}
        {/*    elements,*/}
        {/*    appState,*/}
        {/*    (element) => {*/}
        {/*      if (isTextElement(element) && element.containerId) {*/}
        {/*        return element.verticalAlign;*/}
        {/*      }*/}
        {/*      const boundTextElement = getBoundTextElement(element);*/}
        {/*      if (boundTextElement) {*/}
        {/*        return boundTextElement.verticalAlign;*/}
        {/*      }*/}
        {/*      return null;*/}
        {/*    },*/}
        {/*    (element) =>*/}
        {/*      isTextElement(element) || getBoundTextElement(element) !== null,*/}
        {/*    (hasSelection) => (hasSelection ? null : VERTICAL_ALIGN.MIDDLE),*/}
        {/*  )}*/}
        {/*  onChange={(value) => updateData(value)}*/}
        {/*/>*/}
      </fieldset>
    );
  },
});

export const actionChangeRoundness = register({
  name: "changeRoundness",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) =>
        newElementWith(el, {
          roundness:
            value === "round"
              ? {
                  type: isUsingAdaptiveRadius(el.type)
                    ? ROUNDNESS.ADAPTIVE_RADIUS
                    : ROUNDNESS.PROPORTIONAL_RADIUS,
                }
              : null,
        }),
      ),
      appState: {
        ...appState,
        currentItemRoundness: value,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const targetElements = getTargetElements(
      getNonDeletedElements(elements),
      appState,
    );

    const hasLegacyRoundness = targetElements.some(
      (el) => el.roundness?.type === ROUNDNESS.LEGACY,
    );

    return (
      <fieldset>
        <div className='flex-row-vertical-center'>
          {/*<Checkbox onChange={(e)=>{*/}
          {/*  updateData(e.target.checked?'round':'sharp')*/}
          {/*}}*/}
          {/*          checked={*/}
          {/*            getFormValue(*/}
          {/*                elements,*/}
          {/*                appState,*/}
          {/*                (element) =>*/}
          {/*                    hasLegacyRoundness ? null : element.roundness ? true : false,*/}
          {/*                (element) => element.hasOwnProperty("roundness"),*/}
          {/*                (hasSelection) =>*/}
          {/*                    hasSelection ? null : appState.currentItemRoundness?true:false,*/}
          {/*            )*/}
          {/*          }*/}
          {/*/>*/}
          <div className='flex-center hovered' style={{padding:'3px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) =>
                    hasLegacyRoundness ? null : element.roundness ? "transparent" : "#efefef",
                (element) => element.hasOwnProperty("roundness"),
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemRoundness?"#efefef":"transparent",
            )}} onClick={()=>{
              updateData("sharp")
          }}>
            <img src={imgPathPerfix()+"sharp.png"} className='img-mini-small-12'></img>
          </div>

          <div className='ml-6 flex-center hovered' style={{padding:'3px',backgroundColor:getFormValue(
                elements,
                appState,
                (element) =>
                    hasLegacyRoundness ? null : element.roundness ? "#efefef" : "transparent",
                (element) => element.hasOwnProperty("roundness"),
                (hasSelection) =>
                    hasSelection ? null : appState.currentItemRoundness?"#efefef":"transparent",
            )}} onClick={()=>{
            updateData("round")
          }}>
            <img src={imgPathPerfix()+"corner.png"} className='img-mini-small-12'></img>
          </div>

          <span className='ml-6'></span>
        </div>


        {/*<legend>{i18next.t("labels.edges")}</legend>*/}
        {/*<ButtonIconSelect*/}
        {/*  group="edges"*/}
        {/*  options={[*/}
        {/*    {*/}
        {/*      value: "sharp",*/}
        {/*      text: t("labels.sharp"),*/}
        {/*      icon: EdgeSharpIcon,*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: "round",*/}
        {/*      text: t("labels.round"),*/}
        {/*      icon: EdgeRoundIcon,*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  value={getFormValue(*/}
        {/*    elements,*/}
        {/*    appState,*/}
        {/*    (element) =>*/}
        {/*      hasLegacyRoundness ? null : element.roundness ? "round" : "sharp",*/}
        {/*    (element) => element.hasOwnProperty("roundness"),*/}
        {/*    (hasSelection) =>*/}
        {/*      hasSelection ? null : appState.currentItemRoundness,*/}
        {/*  )}*/}
        {/*  onChange={(value) => updateData(value)}*/}
        {/*/>*/}
      </fieldset>
    );
  },
});

const getArrowheadOptions = (flip: boolean) => {
  return [
    {
      value: null,
      text: t("labels.arrowhead_none"),
      keyBinding: "q",
      icon: ArrowheadNoneIcon,
    },
    {
      value: "bar",
      text: t("labels.arrowhead_bar"),
      keyBinding: "e",
      icon: <ArrowheadBarIcon flip={flip} />,
    },
    {
      value: "arrow",
      text: t("labels.arrowhead_arrow"),
      keyBinding: "w",
      icon: <ArrowheadArrowIcon flip={flip} />,
    },
    {
      value: "triangle",
      text: t("labels.arrowhead_triangle"),
      icon: <ArrowheadTriangleIcon flip={flip} />,
      keyBinding: "t",
    },
    {
      value: "circle_outline",
      text: t("labels.arrowhead_circle_outline"),
      keyBinding: null,
      icon: <ArrowheadCircleOutlineIcon flip={flip} />,
      // showInPicker: false,
    },
    {
      value: "circle",
      text: t("labels.arrowhead_circle"),
      keyBinding: "r",
      icon: <ArrowheadCircleIcon flip={flip} />,
      // showInPicker: false,
    },
    {
      value: "dot",
      text: t("labels.arrowhead_circle"),
      keyBinding: null,
      icon: <ArrowheadCircleIcon flip={flip} />,
      showInPicker: false,
    },

    {
      value: "triangle_outline",
      text: t("labels.arrowhead_triangle_outline"),
      icon: <ArrowheadTriangleOutlineIcon flip={flip} />,
      keyBinding: null,
      showInPicker: false,
    },
    {
      value: "rectangle_outline",
      text: "Rectangle(outline)",
      icon: <ArrowheadRectangleOutlineIcon flip={flip} />,
      keyBinding: null,
      // showInPicker: false,
    },
    {
      value: "rectangle",
      text: "Rectangle",
      icon: <ArrowheadRectangleIcon flip={flip} />,
      keyBinding: null,
      // showInPicker: false,
    },
    {
      value: "diamond_outline",
      text: t("labels.arrowhead_diamond_outline"),
      icon: <ArrowheadDiamondOutlineIcon flip={flip} />,
      keyBinding: null,
      // showInPicker: false,
    },
    {
      value: "diamond",
      text: t("labels.arrowhead_diamond"),
      icon: <ArrowheadDiamondIcon flip={flip} />,
      keyBinding: null,
      // showInPicker: false,
    },
  ] as const;
};

export const actionChangeArrowhead = register({
  name: "changeArrowhead",
  trackEvent: false,
  perform: (
    elements,
    appState,
    value: { position: "start" | "end"; type: Arrowhead },
  ) => {
    return {
      elements: changeProperty(elements, appState, (el) => {
        if (isLinearElement(el)) {
          const { position, type } = value;

          if (position === "start") {
            const element: ExcalidrawLinearElement = newElementWith(el, {
              startArrowhead: type,
            });
            return element;
          } else if (position === "end") {
            const element: ExcalidrawLinearElement = newElementWith(el, {
              endArrowhead: type,
            });
            return element;
          }
        }

        return el;
      }),
      appState: {
        ...appState,
        [value.position === "start"
          ? "currentItemStartArrowhead"
          : "currentItemEndArrowhead"]: value.type,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const isRTL = getLanguage().rtl;

    return (
      <fieldset>
        <legend>{i18next.t("labels.arrowheads")}</legend>
        <div className="iconSelectList buttonList">
          <IconPicker
            label="arrowhead_start"
            options={getArrowheadOptions(!isRTL)}
            value={getFormValue<Arrowhead | null>(
              elements,
              appState,
              (element) =>
                isLinearElement(element) && canHaveArrowheads(element.type)
                  ? element.startArrowhead
                  : appState.currentItemStartArrowhead,
              true,
              appState.currentItemStartArrowhead,
            )}
            onChange={(value) => updateData({ position: "start", type: value })}
          />
          <IconPicker
            label="arrowhead_end"
            group="arrowheads"
            options={getArrowheadOptions(!!isRTL)}
            value={getFormValue<Arrowhead | null>(
              elements,
              appState,
              (element) =>
                isLinearElement(element) && canHaveArrowheads(element.type)
                  ? element.endArrowhead
                  : appState.currentItemEndArrowhead,
              true,
              appState.currentItemEndArrowhead,
            )}
            onChange={(value) => updateData({ position: "end", type: value })}
          />
        </div>
      </fieldset>
    );
  },
});

export const actionChangeBackgroundImage = register({
  name: "changeBackgroundImage",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
      actionType: "changeBackgroundImage",
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    return (
        <fieldset>
          <legend >{"Background"}</legend>

          <div className='flex-row-vertical-center mt-8 cursor-pointer'>
            <div style={{
              borderRadius: '6px',
              fontSize: '12px', alignItems: 'center', justifyContent: 'center',display:'flex',
              border: '1px solid #DDDEE3', flexGrow:'1', height: '24px'
            }}
                 onClick={() => updateData()}>
              Upload Image
            </div>
            <img className='img-mini-small-12 ml-12'
                 onClick={()=>{
                   const arraySelected = getSelectedElements(elements,appState);
                   if (arraySelected.length > 0) {
                      const arrayFrameBackgroundImage = elements.filter(p=>p.isFrameBackgroundImage && p.frameId == arraySelected[0].id);
                      arrayFrameBackgroundImage.forEach(p=>{
                        postMessage(EVENT_CANVAS_DELETE_ELEMENT, p.id);
                      })
                   }
                 }}
                 src={imgPathPerfix()+'remove_backgroundimage.png'}/>
          </div>

        </fieldset>
    );
  },
});



/**
 * 修改绘制中的stroke宽度
 */
export const actionChangeStrokeWidthWithDrawingToolbar = register({
  name: "changeStrokeWidthWithDrawingToolbar",
  trackEvent: false,
  perform: (elements, appState, value) => {
    const arraySelectElements = getSelectedElements(elements, appState);
    const isHighlight = appState.activeTool.type === 'highlighter' || (arraySelectElements.length > 0 && arraySelectElements[0].type === 'highlighter');
    let updateStrokeWidth: any = {currentItemStrokeWidth: value};
    if (isHighlight) {
      updateStrokeWidth = {currentItemHighlightStrokeWidth: value};
    }
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            ...updateStrokeWidth,
          }),
      ),
      appState: {...appState, ...updateStrokeWidth},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => {
    const [weight,setWeight] = useState(getFormValue(
        elements,
        appState,
        (element) => element.strokeWidth,
        true,
        appState.currentItemStrokeWidth,
    ) ?? ''
    );
    return(
        <div style={{margin: '-12px', padding: '4px 16px', width: '254px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("Weight")}</div>

            <div style={{display: 'flex', alignItems: 'center'}}>
              <input
                  style={{
                    width: '36px',
                    height: '24px',
                    border: '1px solid #DBDBDB',
                    borderRadius: '8px',
                    paddingLeft: '0px',
                    marginLeft: '2px',
                    textAlign: 'center',
                    fontSize: '12px'
                  }}
                  value={weight}
                  onFocus={(e) => {
                    e.currentTarget.select();
                  }}
                  onChange={(event) => {
                    setWeight(event.target.value);
                    var value = parseInt(event.target.value);
                    if (isNaN(value)) {
                      // value = '';
                    } else if (value > 100) {
                      value = 100;
                    } else if (value < 0) {
                      value = 0;
                    }

                    if (isNumber(value)) {
                      updateData(value)
                    }
                  }}
              />
            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: '1',
            marginLeft: '-4px',
            marginTop: '-2px',
            width: '100%'
          }}>
            <Slider style={{width:'100%',marginRight:'-6px'}} tooltip={{open:false}} min={1} max={20} value={weight} onChange={(value)=>{
              setWeight(value);
              updateData(value)
            }}/>
          </div>
        </div>
    )
  },
});

/**
 * 修改绘制状态中的颜色透明度
 */
export const actionChangeOpacyColorWithDrawingToolbar = register({
  name: "changeOpacyColorWithDrawingToolbar",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(elements, appState, (el) =>
          newElementWith(el, {
            strokeColor: value,
          }),
      ),
      appState: {...appState, currentItemStrokeColor:value},
      commitToHistory: true,
    };
  },
  PanelComponent: ({elements, appState, updateData}) => (
      <div style={{margin: '-12px', padding: '16px 16px', width: '254px'}}>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div className='font-size-12' style={{flexShrink: '0'}}>{i18next.t("Transparency")}</div>

          <div style={{display: 'flex', alignItems: 'center'}}>
            <input
                style={{
                  width: '36px',
                  height: '24px',
                  border: '1px solid #DBDBDB',
                  borderRadius: '8px',
                  paddingLeft: '0px',
                  marginLeft: '2px',
                  textAlign: 'center',
                  fontSize: '12px'
                }}
                value={Math.floor(hexToRgba(appState.currentItemStrokeColor).a * 100)}
                onFocus={(e) => {
                  e.currentTarget.select();
                }}
                onChange={(event) => {
                  const nAlpha = parseInt(event.currentTarget.value);

                  if (isNumber(nAlpha)) {
                    const rgba = hexToRgba(appState.currentItemStrokeColor)
                    rgba.a = nAlpha / 100;
                    const szNewHex = rgbaToHexa(rgba);
                    updateData(szNewHex);
                  } else {

                  }
                }}
            />
          </div>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          flexGrow: '1',
          marginLeft: '-4px',
          marginTop: '-2px',
          width: '100%'
        }}>
          <Slider style={{width: '100%', marginRight: '-6px'}} tooltip={{open: false}}
                  value={hexToRgba(appState.currentItemStrokeColor).a * 100}
                  onChange={(value) => {

                    const rgba = hexToRgba(appState.currentItemStrokeColor)
                    rgba.a = value / 100;
                    const szNewHex = rgbaToHexa(rgba)
                    updateData(szNewHex);
                  }}/>
        </div>
      </div>
  ),
});



export const actionChangeMindmapLayout = register({
  name: "changeMindmapLayout",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,

      appState,
      commitToHistory: true,
      actionType: value,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;
    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    return (
        <div>
          <legend>{"layout"}</legend>
          <ButtonIconSelect
              options={[
                {
                  value: "logicalStructure",
                  text: "logical structure",
                  icon: (
                      <svg
                          viewBox="0 0 1262 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2710"
                          width="15"
                          height="15"
                      >
                        <path
                            d="M870.85087 79.486795l0.783893-2.038123a117.427237 117.427237 0 0 1 54.323815-62.946643c15.677869-7.838934 32.453188-12.542295 50.012402-13.326189 56.283549-1.567787 112.567098-1.567787 168.850647 0l17.637602 2.35168c13.16941 3.135574 25.868484 7.838934 37.313328 14.893976 36.607824 22.73291 58.635229 64.279262 56.440327 106.609508-0.548725 11.758402-2.978795 23.516803-7.05504 34.491311-4.468193 12.542295-11.209676 24.300697-19.597336 34.491311-9.641889 11.758402-21.47868 21.949016-34.72648 29.004058-15.677869 8.622828-32.453188 12.542295-50.012401 14.110081-54.402205 1.567787-108.961188 0.783893-163.285004 0.783894-19.597336 0-38.410779-4.703361-55.656434-14.110082-25.554926-14.110082-45.465819-37.626885-54.872541-65.063156l-3.135573 0.783894c-48.601393 2.35168-97.202786-1.567787-145.80418 0.783893a105.825614 105.825614 0 0 0-30.963791 7.055041 99.005741 99.005741 0 0 0-62.711475 91.401975V470.649621h241.439179v-1.254229c4.703361-12.542295 10.974508-24.143918 19.597336-34.334533 9.406721-11.758402 21.165123-21.400291 34.491311-28.612111 15.677869-7.838934 32.139631-12.542295 49.385287-13.326188 56.440328-1.567787 112.880655-1.567787 168.53709 0l17.559213 2.35168c13.326188 3.135574 25.868484 7.838934 37.626885 14.893976 36.451045 22.73291 58.478451 64.279262 56.440327 106.609507-0.783893 11.758402-3.135574 23.516803-7.055041 34.491312a118.916635 118.916635 0 0 1-54.480594 63.495368c-15.677869 8.622828-32.139631 12.542295-49.855622 14.110082-54.480594 1.567787-108.961188 0.783893-163.363393 0.783894-19.597336 0-38.410779-4.703361-55.656434-14.110082a119.151803 119.151803 0 0 1-54.245426-64.279262H629.254912c0 73.685983-2.665238 147.371967 0.156778 220.274056a96.73245 96.73245 0 0 0 9.485111 37.626885c10.504172 21.949016 29.396004 39.978565 52.207303 48.601394 9.406721 3.919467 20.381229 6.271148 30.571844 7.05504 47.033606 2.35168 94.851106 0.783893 141.884713 0.783894 1.567787 0 3.919467 0 6.271147 0.548725l0.783894-1.802955a115.624282 115.624282 0 0 1 54.088647-62.711475c15.677869-8.38766 32.139631-12.542295 50.16918-14.110082 56.440328-1.17584 112.096762-1.17584 168.53709 0 6.271148 0.783893 11.758402 1.25423 17.245655 2.351681 13.326188 2.900406 25.868484 7.838934 36.842992 14.893975a117.740795 117.740795 0 0 1-4.703361 203.812294c-15.677869 8.622828-32.688356 12.542295-50.16918 14.110082-54.480594 1.097451-108.961188 0-163.049835 0a124.639057 124.639057 0 0 1-55.656435-14.110082c-25.868484-14.110082-45.465819-37.626885-54.87254-65.063155l-3.135574 0.783893c-48.601393 1.567787-97.202786 0.783893-145.569012 0-20.381229-0.783893-40.762459-4.703361-60.359795-12.542295a177.630253 177.630253 0 0 1-111.0777-164.304065V549.038965c-54.872541 0-109.431524 1.332619-164.147286 1.567787-4.546582 12.385516-10.974508 23.90875-19.597336 34.020975-9.406721 11.758402-21.165123 21.400291-34.491312 28.612111-15.677869 7.838934-32.531578 12.542295-50.16918 13.326188-54.088647 1.567787-108.961188 0-163.049835 0-19.597336-0.783893-38.410779-5.487254-55.656434-14.110082a120.71959 120.71959 0 0 1-61.300467-109.745081c0.783893-11.758402 3.135574-23.516803 7.055041-34.491312 4.703361-12.542295 11.758402-24.300697 19.597336-34.491311 10.190615-11.758402 21.949016-21.165123 35.275204-29.004057 15.677869-8.622828 32.453188-12.542295 50.169181-14.110082 56.440328-1.567787 112.880655-1.567787 168.772257 0 6.271148 0 11.758402 0.783893 18.029549 1.567787 13.326188 2.35168 25.868484 7.055041 37.626885 14.110082 23.516803 14.110082 40.762459 36.059098 49.620455 61.143688H550.865568c0-73.685983-0.783893-146.588073 0-220.274057L551.649461 235.481589a177.316696 177.316696 0 0 1 114.762-147.999081 178.727704 178.727704 0 0 1 56.283549-10.73934C769.963784 78.467733 817.154169 78.702901 864.422943 78.702901c2.194902 0 4.311414 0.313557 6.427927 0.783894zM982.477295 862.596341a40.60568 40.60568 0 0 0-29.474393 12.855852 41.703131 41.703131 0 0 0-7.838934 12.855853c-6.271148 17.480824 0.783893 37.391717 16.461762 47.033606a39.978565 39.978565 0 0 0 18.343106 5.487254c53.618311 1.411008 107.236623 1.411008 160.854934 0a38.410779 38.410779 0 0 0 34.804869-25.554926 39.900176 39.900176 0 0 0-16.461762-47.033606 39.978565 39.978565 0 0 0-18.343107-5.487255c-52.756028-1.411008-105.512057-0.156779-158.346475-0.156778z m0-391.94672a40.60568 40.60568 0 0 0-29.474393 12.855852 41.703131 41.703131 0 0 0-7.838934 12.855853c-6.271148 17.480824 0.783893 37.391717 16.461762 47.033606a39.978565 39.978565 0 0 0 18.343106 5.487254c53.618311 1.411008 107.236623 1.411008 160.854934 0a38.410779 38.410779 0 0 0 34.804869-25.554926 39.900176 39.900176 0 0 0-16.461762-47.033606 39.978565 39.978565 0 0 0-18.343107-5.487254C1088.067742 469.238613 1035.311713 470.649621 982.477295 470.649621z m0-391.94672a40.60568 40.60568 0 0 0-29.474393 12.855853 41.703131 41.703131 0 0 0-7.838934 12.855852c-6.271148 17.480824 0.783893 37.391717 16.461762 47.033607a39.978565 39.978565 0 0 0 18.343106 5.487254c53.618311 1.411008 107.236623 1.411008 160.854934 0a38.410779 38.410779 0 0 0 34.804869-25.554927 39.900176 39.900176 0 0 0-16.461762-47.033606 39.978565 39.978565 0 0 0-18.343107-5.487254C1088.067742 77.291893 1035.311713 78.702901 982.477295 78.702901z"
                            fill=""
                            p-id="2711"
                        ></path>
                      </svg>
                  ),
                },
                {
                  value: "organizationStructure",
                  text: "organization structure",
                  icon: (
                      <svg
                          viewBox="0 0 1255 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2868"
                          width="15"
                          height="15"
                      >
                        <path
                            d="M549.12728 235.88939L509.433222 235.732497a122.690724 122.690724 0 0 1-55.697195-14.120416 119.552854 119.552854 0 0 1-57.815258-74.21063 116.72877 116.72877 0 0 1 3.530104-69.817611 117.513238 117.513238 0 0 1 54.3636-62.992744c15.689351-7.844675 32.476956-12.551481 50.04903-13.335948 56.32477-1.568935 112.649539-1.568935 168.974308 0l17.65052 2.353403c13.179055 3.13787 25.887429 7.844675 37.340655 14.904883 36.634634 22.749559 58.678172 64.326338 56.481663 106.687586-0.549127 11.767013-2.980977 23.534026-7.060208 34.516572-4.471465 12.551481-11.217886 24.318494-19.611688 34.516572-9.648951 11.767013-21.494411 21.965091-34.751912 29.025299-15.689351 8.629143-32.39851 12.551481-50.04903 14.120415-15.061777 0.784468-30.202 0.784468-45.263777 0.784468V471.072759c68.719357 0 137.51716-2.353403 206.314964 0.235341 21.180624 1.333595 42.04746 5.491273 61.972936 13.335948 51.774858 20.396156 93.116297 62.914297 112.178858 115.159835 7.295548 20.396156 10.982546 41.57678 11.767013 62.757404 0.470681 40.792312 0.23534 82.369092 0 123.161404 2.039616 0 4.079231 0 6.040401 0.784467 17.572073 1.568935 34.516572 5.491273 50.049029 14.120416 13.335948 7.060208 25.102961 17.258286 34.673465 29.025299 8.472249 10.198078 15.21867 21.965091 19.768582 34.516572 3.922338 10.982546 6.27574 22.749559 6.275741 34.516572 2.353403 43.145715-20.396156 84.722495-56.481664 106.687586-11.767013 7.060208-24.318494 11.767013-37.654442 14.904883-6.27574 1.333595-11.767013 1.568935-18.042753 2.353403-28.240832 0.784468-56.481663 0-85.506962 0-19.611689-0.313787-38.43891-4.706805-55.697196-14.120416a118.297705 118.297705 0 0 1-61.816042-109.511669c0.784468-11.767013 3.13787-23.534026 7.060208-34.516572 4.706805-12.551481 11.374779-24.318494 19.611688-34.516572 9.805844-11.767013 21.651304-21.415964 34.908806-28.633065 15.689351-8.236909 32.39851-12.551481 49.970582-13.806629 1.568935 0 3.451657 0 5.491273-0.313787 0-41.106099 1.804275-82.369092 0.235341-123.632085-0.784468-12.551481-3.294764-25.102961-7.844676-36.869974a118.219259 118.219259 0 0 0-69.033144-67.464209c-13.335948-4.706805-26.907237-7.060208-40.949205-7.060208H627.574034v235.340263h6.0404c17.572073 1.333595 34.516572 5.491273 50.049029 14.120416 13.335948 7.060208 25.102961 16.866052 34.673466 28.554618 8.472249 10.198078 15.21867 21.965091 19.768582 34.516572 3.922338 10.982546 6.27574 22.749559 6.27574 34.516572 2.353403 42.753481-20.396156 84.330261-56.481663 106.687586a125.20102 125.20102 0 0 1-55.697195 16.944499c-28.240832 0.784468-56.481663 0-85.506963 0-19.611689-0.392234-38.43891-4.706805-55.697195-14.120416a118.454599 118.454599 0 0 1-61.816042-109.433222c0.784468-11.767013 3.13787-23.534026 7.060207-34.516572 4.706805-12.551481 11.374779-24.318494 19.611689-34.516572 9.805844-11.767013 21.651304-21.180624 34.908806-28.711512 15.689351-8.236909 32.39851-12.551481 49.970582-14.120416h5.883507V549.519514c-67.464209 0-134.928417-2.353403-202.392626 0.156893a119.16062 119.16062 0 0 0-44.71465 11.37478c-26.671896 12.708374-47.85252 35.301039-58.599726 62.757403-4.706805 11.923907-7.060208 24.475387-7.844675 37.262208-1.568935 41.184546-0.784468 82.525985 0 123.788978a122.376937 122.376937 0 0 1 56.481663 14.27731c13.335948 7.060208 25.102961 16.866052 34.516572 28.554618 8.629143 10.198078 15.061777 21.965091 19.611688 34.359679 3.922338 10.982546 6.27574 22.749559 7.060208 34.516572a120.258874 120.258874 0 0 1-56.481663 106.687585c-11.767013 6.903314-24.318494 11.767013-37.654442 14.591097-5.726613 1.176701-11.767013 1.725829-17.493626 2.196509-28.240832 0.784468-56.638557 0.156894-84.957835 0.156893a122.690724 122.690724 0 0 1-55.697195-14.120416c-28.240832-15.689351-49.970582-42.753481-58.050599-74.210629-3.13787-11.531673-4.314571-23.534026-3.686997-35.301039 0.784468-11.767013 3.13787-23.534026 7.060208-34.516572 4.706805-12.551481 11.296333-24.1616 19.611688-34.359679 9.727398-11.767013 21.572857-21.415964 34.830359-28.633065 15.689351-7.844675 32.163169-12.551481 49.970583-13.335948h5.334379c-0.392234-40.792312 0.627574-81.584624 1.176701-122.376937 0.784468-22.749559 5.099039-45.499117 13.492842-66.679741 21.180624-53.343793 65.346146-94.920573 119.6313-113.747794 20.003922-6.27574 41.027652-9.413611 62.36517-10.198078H549.12728v-235.340263z m-355.834477 627.1818c-12.002353 0-23.92626 0.23534-35.928614 0.235341a40.635419 40.635419 0 0 0-29.49598 12.865267 41.733673 41.733673 0 0 0-7.844675 12.865268c-6.27574 17.493626 0.784468 37.419102 16.473818 47.068053a40.007845 40.007845 0 0 0 18.356541 5.491272c27.456364 0.784468 54.912728 0.784468 82.525985 0a40.007845 40.007845 0 0 0 18.278094-5.491272c15.689351-9.648951 22.749559-29.574426 16.473819-47.068053a35.693273 35.693273 0 0 0-7.060208-11.453226 37.183762 37.183762 0 0 0-11.767013-9.570504 43.616395 43.616395 0 0 0-16.473819-4.706805 1506.334575 1506.334575 0 0 0-43.930182-0.235341z m784.467542 0c-11.923907 0-23.92626 0.23534-35.928613 0.235341a40.635419 40.635419 0 0 0-29.49598 12.865267 41.733673 41.733673 0 0 0-7.844675 12.865268c-6.27574 17.493626 0.784468 37.419102 16.473818 47.068053a40.007845 40.007845 0 0 0 18.356541 5.491272c27.456364 0.784468 54.912728 0.784468 82.525985 0a40.007845 40.007845 0 0 0 18.278094-5.491272c15.689351-9.648951 22.749559-29.574426 16.473818-47.068053a35.693273 35.693273 0 0 0-7.060208-11.453226 37.183762 37.183762 0 0 0-11.767013-9.570504 43.616395 43.616395 0 0 0-16.473818-4.706805c-12.551481-0.23534-25.887429-0.313787-38.43891-0.235341a41.890567 41.890567 0 0 1-6.27574 0zM549.676407 863.306531a40.635419 40.635419 0 0 0-29.495979 12.865267 65.424593 65.424593 0 0 0-7.844676 12.865268c-6.27574 17.493626 0.784468 37.419102 16.473819 47.068053 6.27574 3.37321 11.767013 5.099039 18.827221 5.491272 27.456364 0.784468 54.912728 0.784468 82.369092 0a42.204354 42.204354 0 0 0 18.827221-5.491272 39.929398 39.929398 0 0 0 10.198078-58.521279 37.183762 37.183762 0 0 0-11.767014-9.570504 36.791528 36.791528 0 0 0-16.473818-4.706805c-26.671896-0.627574-53.343793 0-80.015689 0z"
                            fill=""
                            p-id="2869"
                        ></path>
                      </svg>
                  ),
                },
              ]}
              value={null}
              type="button"
              onClick={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                currentMindMap.setLayout(value);
                const zoom = appState.zoom.value;
                addMindMapControls(node, currentMindMap, isDarkMode()?addIconWhite:addIcon, OFFSET,zoom);
              }}
          />
        </div>
    );
  },
});

export const actionChangeLineStyle = register({
  name: "changeLineStyle",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,

      appState,
      commitToHistory: true,
      actionType: value,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const genPresets = (presets = presetPalettes) =>
        Object.entries(presets).map<Presets>(([label, colors]) => ({
          label,
          colors,
        }));
    const { token } = theme.useToken();
    const presets = genPresets({
      primary: generate(token.colorPrimary),
      red,
      green,
    });

    const { element, node } = appState.mindmap.selected;
    if (!node || !element) {
      return null;
    }

    const mindMap = mindMapCache.get(element.id);

    let lineColor = node.getStyle("lineColor");
    if (lineColor === "transparent") {
      lineColor = "rgb(255, 255, 255)";
    }

    if (!lineColor) {
      lineColor = mindMap
          ? // @ts-ignore
          mindMap.rainbowLines.getNodeColor(node)
          : "rgb(255, 255, 255)";
    }

    return (
        <div>
          <legend>{"Line Style"}</legend>

          <AntdColorPicker
              showText
              disabled={node.isRoot}
              format={"rgb"}
              value={lineColor}
              presets={presets}
              onChangeComplete={(color) => {
                node.setStyle("lineColor", color.toRgbString());
                addMindMapControls(node, mindMap, isDarkMode()?addIconWhite:addIcon, OFFSET);
              }}
          />
        </div>
    );
  },
});

export const actionChangeNodeStyle = register({
  name: "changeNodeStyle",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,

      appState,
      commitToHistory: true,
      actionType: value,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const genPresets = (presets = presetPalettes) =>
        Object.entries(presets).map<Presets>(([label, colors]) => ({
          label,
          colors,
        }));
    const { token } = theme.useToken();
    const presets = genPresets({
      primary: generate(token.colorPrimary),
      red,
      green,
    });

    const { element, node } = appState.mindmap.selected;
    if (!node || !element) {
      return null;
    }
    const mindMap = mindMapCache.get(element.id);

    let fillColor = node.getStyle("fillColor");
    if (fillColor === "transparent") {
      fillColor = "rgb(255, 255, 255)";
    }
    return (
        <div>
          <legend>{"Node Style"}</legend>

          <AntdColorPicker
              showText
              format={"rgb"}
              value={fillColor}
              presets={presets}
              onChangeComplete={(color) => {
                node.setStyle("fillColor", color.toRgbString());
                addMindMapControls(node, mindMap, isDarkMode()?addIconWhite:addIcon, OFFSET);
              }}
          />
        </div>
    );
  },
});


export const actionChangeFontColor = register({
  name: "changeFontColor",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      ...(value.currentItemStrokeColor && {
        elements: changeProperty(
            elements,
            appState,
            (el) => {
              return hasStrokeColor(el.type)
                  ? newElementWith(el, {
                    strokeColor: value.currentItemStrokeColor,
                  })
                  : el;
            },
            true,
        ),
      }),
      appState: {
        ...appState,
        ...value,
      },
      commitToHistory: !!value.currentItemStrokeColor,
      actionType: "color",
    };
  },
  PanelComponent: ({ elements, appState, updateData, appProps }) => (
      <>
        <ColorPicker
            topPicks={DEFAULT_ELEMENT_STROKE_PICKS}
            palette={DEFAULT_ELEMENT_STROKE_COLOR_PALETTE}
            type="elementStroke"
            label={i18next.t("labels.stroke")}
            color={getFormValue(
                elements,
                appState,
                (element) => element.strokeColor,
                true,
                appState.currentItemStrokeColor,
            )}
            onChange={(color) => updateData({ currentItemStrokeColor: color })}
            elements={elements}
            appState={appState}
            updateData={updateData}
        />
      </>
  ),
});

export const actionChangeTextBold = register({
  name: "changeTextBold",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
            // if (isTextElement(oldElement) && oldElement.containerId){
            //   //形状里面的文字
            //   const quill = QuillCache.get(oldElement.id);
            //   const range = quill.getSelection();
            //   if (range) {
            //     const format = quill.getFormat(range.index, range.length);
            //     quill.formatText(range.index, range.length, "bold", !format.bold);
            //   } else {
            //     const length = quill.getLength();
            //     const format = quill.getFormat(0, length - 1);
            //     quill.formatText(0, length - 1, "bold", !format.bold);
            //   }
            //   return;
            // }
            if (isStickyNotesElement(oldElement) || (isTextElement(oldElement) && !oldElement.containerId && HAS_ENABLE_TIPTAP_TEXT)) {
              // const quill = QuillCache.get(oldElement.id);
              // const range = quill.getSelection();
              // if (range) {
              //   const format = quill.getFormat(range.index, range.length);
              //   quill.formatText(range.index, range.length, "bold", !format.bold);
              // } else {
              //   const length = quill.getLength();
              //   const format = quill.getFormat(0, length - 1);
              //   quill.formatText(0, length - 1, "bold", !format.bold);
              // }
              if (StickyNoteTiptapCache.get(oldElement.id)){
                const editor = StickyNoteTiptapCache.get(oldElement.id);
                // 保存当前光标位置（如果有的话）
                const currentPosition = editor.state.selection.from;
                editor.chain().selectAll().toggleBold().setTextSelection(currentPosition).blur().run();
              }

                if (TextTiptapCache.get(oldElement.id)){
                    const editor = TextTiptapCache.get(oldElement.id);
                    // 保存当前光标位置（如果有的话）
                    const currentPosition = editor.state.selection.from;
                    editor.chain().selectAll().toggleBold().setTextSelection(currentPosition).blur().run();
                }

              return oldElement;
            }

            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  { bold: !oldElement.bold },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemBold: !appState.currentItemBold,
      },
      commitToHistory: true,
      actionType: "bold",
    };
  },
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.B,
  PanelComponent: ({ updateData, appState }) => (
      // <Button
      //     type="dashed"
      //     onClick={(value) => updateData(value)}
      //     shape="circle"
      //     icon={<BoldOutlined rev={undefined}/>}
      // />
      <img className='img-30 click-background' src={getImagePathWithTheme('tool_bold')} onClick={(value) => updateData(value)}/>
  ),
});

export const actionChangeTextItalic = register({
  name: "changeTextItalic",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
              if (isStickyNotesElement(oldElement) || (isTextElement(oldElement) && !oldElement.containerId && HAS_ENABLE_TIPTAP_TEXT)) {
              // const quill = QuillCache.get(oldElement.id);
              // const range = quill.getSelection();
              // if (range) {
              //   const format = quill.getFormat(range.index, range.length);
              //   quill.formatText(
              //       range.index,
              //       range.length,
              //       "italic",
              //       !format.italic,
              //   );
              // } else {
              //   const length = quill.getLength();
              //   const format = quill.getFormat(0, length - 1);
              //   quill.formatText(0, length - 1, "italic", !format.italic);
              // }
              if (StickyNoteTiptapCache.get(oldElement.id)){
                const editor = StickyNoteTiptapCache.get(oldElement.id);
                // 保存当前光标位置（如果有的话）
                const currentPosition = editor.state.selection.from;
                editor.chain().selectAll().toggleItalic().setTextSelection(currentPosition).blur().run();
              }

                  if (TextTiptapCache.get(oldElement.id)){
                      const editor = TextTiptapCache.get(oldElement.id);
                      // 保存当前光标位置（如果有的话）
                      const currentPosition = editor.state.selection.from;
                      editor.chain().selectAll().toggleItalic().setTextSelection(currentPosition).blur().run();
                  }

              return oldElement;
            }

            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  { italic: !oldElement.italic },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemItalic: !appState.currentItemItalic,
      },
      commitToHistory: true,
      actionType: "italic",
    };
  },
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.L,
  PanelComponent: ({ updateData, appState }) => (
      // <Button
      //     type="dashed"
      //     shape="circle"
      //     onClick={(value) => updateData(value)}
      //     icon={<ItalicOutlined rev={undefined} />}
      // />
      <img className='img-30 click-background' src={getImagePathWithTheme('tool_italic')} onClick={(value) => updateData(value)}/>
  ),
});

export const actionChangeTextUnderline = register({
  name: "changeTextUnderline",
  trackEvent: false,
  keyTest: (event) => event[KEYS.CTRL_OR_CMD] && event.key === KEYS.U,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
              if (isStickyNotesElement(oldElement)  || (isTextElement(oldElement) && HAS_ENABLE_TIPTAP_TEXT)) {
              // const quill = QuillCache.get(oldElement.id);
              // const range = quill.getSelection();
              // if (range) {
              //   const format = quill.getFormat(range.index, range.length);
              //   quill.formatText(
              //       range.index,
              //       range.length,
              //       "underline",
              //       !format.underline,
              //   );
              // } else {
              //   const length = quill.getLength();
              //   const format = quill.getFormat(0, length - 1);
              //   quill.formatText(0, length - 1, "underline", !format.underline);
              // }
              if (StickyNoteTiptapCache.get(oldElement.id)){
                const editor = StickyNoteTiptapCache.get(oldElement.id);
                // 保存当前光标位置（如果有的话）
                const currentPosition = editor.state.selection.from;
                editor.chain().selectAll().toggleUnderline().setTextSelection(currentPosition).blur().run();
              }

                  if (TextTiptapCache.get(oldElement.id)){
                      const editor = TextTiptapCache.get(oldElement.id);
                      // 保存当前光标位置（如果有的话）
                      const currentPosition = editor.state.selection.from;
                      editor.chain().selectAll().toggleUnderline().setTextSelection(currentPosition).blur().run();
                  }

              return oldElement;
            }

            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  { underline: !oldElement.underline },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemUnderline: !appState.currentItemUnderline,
      },
      commitToHistory: true,
      actionType: "underline",
    };
  },
  PanelComponent: ({ updateData, appState }) => (
      // <Button
      //     type="dashed"
      //     shape="circle"
      //     onClick={(value) => updateData(value)}
      //     icon={<UnderlineOutlined rev={undefined} />}
      // />
      <img className='img-30 click-background' src={getImagePathWithTheme('tool_underline')} onClick={(value) => updateData(value)}/>
  ),
});

export const actionChangeTextStrikeout = register({
  name: "changeTextStrikeout",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
              if (isStickyNotesElement(oldElement)  || (isTextElement(oldElement) && HAS_ENABLE_TIPTAP_TEXT)) {
              // const quill = QuillCache.get(oldElement.id);
              // const range = quill.getSelection();
              // if (range) {
              //   const format = quill.getFormat(range.index, range.length);
              //   quill.formatText(
              //       range.index,
              //       range.length,
              //       "strike",
              //       !format.strike,
              //   );
              // } else {
              //   const length = quill.getLength();
              //   const format = quill.getFormat(0, length - 1);
              //   quill.formatText(0, length - 1, "strike", !format.strike);
              // }
              if (StickyNoteTiptapCache.get(oldElement.id)){
                const editor = StickyNoteTiptapCache.get(oldElement.id);
                // 保存当前光标位置（如果有的话）
                const currentPosition = editor.state.selection.from;
                editor.chain().selectAll().toggleStrike().setTextSelection(currentPosition).blur().run();
              }

              if (TextTiptapCache.get(oldElement.id)){
                  const editor = TextTiptapCache.get(oldElement.id);
                  // 保存当前光标位置（如果有的话）
                  const currentPosition = editor.state.selection.from;
                  editor.chain().selectAll().toggleStrike().setTextSelection(currentPosition).blur().run();
              }

              return oldElement;
            }

            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  { strikeout: !oldElement.strikeout },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemStrikeout: !appState.currentItemStrikeout,
      },
      commitToHistory: true,
      actionType: "strikeout",
    };
  },
  PanelComponent: ({ updateData, appState }) => (
      // <Button
      //     type="dashed"
      //     shape="circle"
      //     onClick={(value) => updateData(value)}
      //     icon={<StrikethroughOutlined rev={undefined} />}
      // />
      <img className='img-30 click-background' src={getImagePathWithTheme('tool_strike')} onClick={(value) => updateData(value)}/>
  ),
});

export const actionChangeLineType = register({
  name: "changeLineType",
  trackEvent: false,
  perform: (elements, appState, value) => {
    const nextElements = changeProperty(elements, appState, (el) =>
        newElementWith(el, {
          roundness:
              value === "round"
                  ? {
                    type: isUsingAdaptiveRadius(el.type)
                        ? ROUNDNESS.ADAPTIVE_RADIUS
                        : ROUNDNESS.PROPORTIONAL_RADIUS,
                  }
                  : value === "elbow"
                      ? { type: ROUNDNESS.ELBOW }
                      : null,
        }),
    );

    // Keep bound endpoints anchored when switching connector type.
    //
    // In particular, ELBOW (orthogonal) connectors rely on
    // `startConnectionDirection/endConnectionDirection` stored on the bound
    // elements. When we change roundness via a pure property update, those
    // cached directions (or endpoint coordinates) might become stale and the
    // endpoint can visually "detach".
    const patches = new Map<ExcalidrawElement["id"], ExcalidrawElement>();
    const byId = arrayToMap(nextElements);
    const getPatched = (id: ExcalidrawElement["id"]) =>
        patches.get(id) ?? byId.get(id);

    const selected = getSelectedElements(nextElements, appState);
    selected.forEach((sel) => {
      const element = getPatched(sel.id);
      if (!element || !isLinearElement(element)) {
        return;
      }

      // Ensure start-side connection direction exists/updates (but don't move
      // the line origin here to avoid shifting the whole connector).
      if (element.startBinding) {
        const startEl = getPatched(element.startBinding.elementId);
        if (startEl && isBindableElement(startEl)) {
          const { connectionDirection } = getFocusPointForConnection(
              startEl,
              element,
              "start",
          );
          patches.set(
              startEl.id,
              newElementWith(startEl, { startConnectionDirection: connectionDirection }),
          );
        }
      }

      // For end binding, also snap last point to the bound element so it
      // doesn't drift after type change.
      if (element.endBinding) {
        const endEl = getPatched(element.endBinding.elementId);
        if (endEl && isBindableElement(endEl)) {
          const { focusPointAbs, connectionDirection } = getFocusPointForConnection(
              endEl,
              element,
              "end",
          );

          patches.set(
              endEl.id,
              newElementWith(endEl, { endConnectionDirection: connectionDirection }),
          );

          // `element.points` is readonly; create a writable copy before editing.
          const nextPoints = element.points.map(
              (p) => [p[0], p[1]] as [number, number],
          );
          if (nextPoints.length) {
            nextPoints[nextPoints.length - 1] = [
              focusPointAbs[0] - element.x,
              focusPointAbs[1] - element.y,
            ];
            patches.set(
                element.id,
                newElementWith(element, {
                  // IMPORTANT: when updating `points` via `newElementWith`, we must
                  // also update width/height (normally handled by `mutateElement`)
                  // otherwise bounds & binding math can go stale and connectors
                  // may appear to detach after subsequent moves.
                  points: nextPoints as ExcalidrawLinearElement["points"],
                  ...getSizeFromPoints(nextPoints),
                }),
            );
          }
        }
      }
    });

    const patchedElements = patches.size
        ? nextElements.map((el) => patches.get(el.id) ?? el)
        : nextElements;

    return {
      elements: patchedElements,
      appState: {
        ...appState,
        // currentItemRoundness: value,
      },
      commitToHistory: true,
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const targetElements = getTargetElements(
        getNonDeletedElements(elements),
        appState,
    );

    const hasLegacyRoundness = targetElements.some(
        (el) => el.roundness?.type === ROUNDNESS.LEGACY,
    );

    return (
        <fieldset>
          <legend>Line type</legend>
          <ButtonIconSelect
              group="edges"
              options={[
                {
                  value: "sharp",
                  text: "sharp",
                  icon: (
                      <svg
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="1500"
                          width="200"
                          height="200"
                      >
                        <path
                            d="M956.4 307.6v-240h-240v204.6l-445 445H68v240h240V751.3l443.7-443.7h204.7z m-190-190h140v140h-140v-140zM258 907.2H118v-140h140v140z"
                            fill="#515151"
                            p-id="1501"
                        ></path>
                      </svg>
                  ),
                },
                {
                  value: "round",
                  text: "round",
                  icon: (
                      <svg
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="5635"
                          width="200"
                          height="200"
                      >
                        <path
                            d="M170.666667 955.733333H85.333333a17.066667 17.066667 0 0 1-17.066666-17.066666v-85.333334a17.066667 17.066667 0 0 1 17.066666-17.066666h25.275734C107.332267 586.888533 167.970133 399.274667 290.986667 278.408533 411.904 159.607467 595.080533 103.0144 836.266667 110.301867V85.333333a17.066667 17.066667 0 0 1 17.066666-17.066666h85.333334a17.066667 17.066667 0 0 1 17.066666 17.066666v85.333334a17.066667 17.066667 0 0 1-17.066666 17.066666h-85.333334a17.066667 17.066667 0 0 1-17.066666-17.066666V144.452267c-231.918933-7.031467-407.159467 46.114133-521.352534 158.293333C198.724267 416.9216 141.5168 596.343467 144.7424 836.266667H170.666667a17.066667 17.066667 0 0 1 17.066666 17.066666v85.333334a17.066667 17.066667 0 0 1-17.066666 17.066666z m-68.266667-34.133333h51.2v-51.2H102.4v51.2zM870.4 153.6h51.2V102.4h-51.2v51.2z"
                            p-id="5636"
                        ></path>
                      </svg>
                  ),
                },
              ]}
              value={getFormValue(
                  elements,
                  appState,
                  (element) =>
                      hasLegacyRoundness ? null : element.roundness ? "round" : "sharp",
                  (element) => element.hasOwnProperty("roundness"),
                  (hasSelection) =>
                      hasSelection ? null : appState.currentItemRoundness,
              )}
              onChange={(value) => updateData(value)}
          />
        </fieldset>
    );
  },
});


export const actionChangeMindmapFontFamily = register({
  name: "changeMindmapFontFamily",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
    };
  },

  PanelComponent: ({ elements, appState, updateData }) => {
    const options: {
      value: FontFamilyValues;
      label: string;
    }[] = fontFamilyList.map((item) => {
      return {
        value: item.key,
        label: item.label,
      } as unknown as {
        value: FontFamilyValues;
        label: string;
      };
    });
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;
    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    const fontFamily = useMemo(() => {
      if (!elementId) {
        return;
      }
      const currentMindMap = mindMapCache.get(elementId)!;
      const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
      const fontFamily = currentThemeConfig?.root?.fontFamily || false;
      return fontFamily;
    }, [elementId]);

    if (!fontFamily) {
      return null;
    }
    return (
        <fieldset>
          <legend>font family</legend>
          <DropdownSelector<FontFamilyValues | false>
              group="font-family"
              options={options}
              value={fontFamily}
              onChange={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                const currentThemeConfig = {
                  ...currentMindMap.getThemeConfig(undefined),
                };
                currentThemeConfig.root.fontFamily = value;
                currentThemeConfig.second.fontFamily = value;
                currentThemeConfig.node.fontFamily = value;
                currentMindMap.setThemeConfig(currentThemeConfig);

                Object.values(currentMindMap.renderer.nodeCache).forEach(
                    (node: any) => {
                      node.setStyle("fontFamily", value);
                    },
                );
              }}
          />
        </fieldset>
    );
  },
});
export const actionChangeMindmapRootFontSize = register({
  name: "changeMindmapRootFontSize",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
    };
  },

  PanelComponent: ({ elements, appState, updateData }) => {
    const options: {
      value: FontFamilyValues;
      label: string;
    }[] = fontSizeList.map((item) => {
      return {
        value: item,
        label: `${item}`,
      } as unknown as {
        value: FontFamilyValues;
        label: string;
      };
    });
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;

    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    const fontSize = useMemo(() => {
      if (!elementId) {
        return;
      }
      const currentMindMap = mindMapCache.get(elementId)!;
      const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
      const fontSize = currentThemeConfig?.root?.fontSize || false;
      return fontSize;
    }, [elementId]);
    if (!fontSize) {
      return null;
    }
    return (
        <fieldset>
          <legend>root font size</legend>
          <DropdownSelector<FontFamilyValues | false>
              group="root-font-size"
              options={options}
              value={fontSize}
              onChange={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                const currentThemeConfig = {
                  ...currentMindMap.getThemeConfig(undefined),
                };
                currentThemeConfig.root.fontSize = value;
                currentMindMap.setThemeConfig(currentThemeConfig);
                node.setStyle("fontSize", value);
              }}
          />
        </fieldset>
    );
  },
});
export const actionChangeMindmapFontSize = register({
  name: "changeMindmapFontSize",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
    };
  },

  PanelComponent: ({ elements, appState, updateData }) => {
    const options: {
      value: FontFamilyValues;
      label: string;
    }[] = fontSizeList.map((item) => {
      return {
        value: item,
        label: `${item}`,
      } as unknown as {
        value: FontFamilyValues;
        label: string;
      };
    });
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;

    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    const fontSize = useMemo(() => {
      if (!elementId) {
        return;
      }
      const currentMindMap = mindMapCache.get(elementId)!;
      const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
      const fontSize = currentThemeConfig?.node?.fontSize || false;
      return fontSize;
    }, [elementId]);
    if (!fontSize) {
      return null;
    }
    return (
        <fieldset>
          <legend>font size</legend>
          <DropdownSelector<FontFamilyValues | false>
              group="root-font-size"
              options={options}
              value={fontSize}
              onChange={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                const currentThemeConfig = {
                  ...currentMindMap.getThemeConfig(undefined),
                };
                currentThemeConfig.second.fontSize = value;
                currentThemeConfig.node.fontSize = value;
                currentMindMap.setThemeConfig(currentThemeConfig);
                Object.values(currentMindMap.renderer.nodeCache).forEach(
                    (node: any) => {
                      if (!node.isRoot) {
                        node.setStyle("fontSize", value);
                      }
                    },
                );
              }}
          />
        </fieldset>
    );
  },
});
export const actionChangeMindmapLineWidth = register({
  name: "changeMindmapLineWidth",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
    };
  },

  PanelComponent: ({ elements, appState, updateData }) => {
    const options: {
      value: FontFamilyValues;
      label: string;
    }[] = lineWidthList.map((item) => {
      return {
        value: item,
        label: `${item}`,
      } as unknown as {
        value: FontFamilyValues;
        label: string;
      };
    });
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;

    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    const lineWidth = useMemo(() => {
      if (!elementId) {
        return;
      }
      const currentMindMap = mindMapCache.get(elementId)!;
      const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
      const lineWidth = currentThemeConfig?.lineWidth || 1;
      return lineWidth;
    }, [elementId]);
    if (!lineWidth) {
      return null;
    }
    return (
        <fieldset>
          <legend>line width</legend>
          <DropdownSelector<FontFamilyValues | false>
              group="root-font-size"
              options={options}
              value={lineWidth}
              onChange={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                const currentThemeConfig = {
                  ...currentMindMap.getThemeConfig(undefined),
                };
                currentThemeConfig.lineWidth = value;
                currentMindMap.setThemeConfig(currentThemeConfig);
                Object.values(currentMindMap.renderer.nodeCache).forEach(
                    (node: any) => {
                      node.setStyle("lineWidth", value);
                    },
                );
              }}
          />
        </fieldset>
    );
  },
});
export const actionChangeMindmapLineStyle = register({
  name: "changeMindmapLineStyle",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements,
      appState,
      commitToHistory: true,
    };
  },

  PanelComponent: ({ elements, appState, updateData }) => {
    const options: {
      value: FontFamilyValues;
      label: string;
    }[] = lineStyleList.map((item) => {
      return {
        value: item.key,
        label: item.label,
      } as unknown as {
        value: FontFamilyValues;
        label: string;
      };
    });
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;

    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    const lineStyle = useMemo(() => {
      if (!elementId) {
        return;
      }
      const currentMindMap = mindMapCache.get(elementId)!;
      const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
      const lineStyle = currentThemeConfig?.lineStyle || "curve";
      return lineStyle;
    }, [elementId]);
    if (!lineStyle) {
      return null;
    }
    return (
        <fieldset>
          <legend>line style</legend>
          <DropdownSelector<FontFamilyValues | false>
              group="root-font-size"
              options={options}
              value={lineStyle}
              onChange={(value) => {
                const currentMindMap = mindMapCache.get(elementId)!;
                const currentThemeConfig = {
                  ...currentMindMap.getThemeConfig(undefined),
                };
                console.log(currentThemeConfig);
                currentThemeConfig.lineStyle = value;
                currentMindMap.setThemeConfig(currentThemeConfig);
                Object.values(currentMindMap.renderer.nodeCache).forEach(
                    (node: any) => {
                      node.setStyle("lineStyle", value);
                    },
                );
              }}
          />
        </fieldset>
    );
  },
});
export const actionChangeMindmapStyle = register({
  name: "changeMindmapStyle",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return changeFontSize(elements, appState, () => value, value);
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const [elementId, setelementId] = useState("");
    const { element, node } = appState.mindmap.selected;
    useEffect(() => {
      if (!elements.length) {
        return;
      }

      const elementId = getFormValue(
          elements,
          appState,
          (element) => element.id,
          true,
          "",
      );

      setelementId(elementId || element!.id);
    }, [appState, element, elements]);
    return (
        <fieldset>
          <button
              onClick={() => {
                // const currentMindMap = mindMapCache.get(elementId)!;
                // const currentThemeConfig = currentMindMap.getThemeConfig(undefined);
                // themeConfig.lineWidth = currentThemeConfig.lineWidth;
                // themeConfig.lineStyle = currentThemeConfig.lineStyle;
                // themeConfig.root = currentThemeConfig.root;
                // themeConfig.second = currentThemeConfig.second;
                // themeConfig.node = currentThemeConfig.node;
                // currentMindMap.setThemeConfig(themeConfig);
              }}
          >
            设置为默认样式
          </button>
        </fieldset>
    );
  },
});

export const actionChangeLineHeight = register({
  name: "changeLineHeight",
  trackEvent: false,
  perform: (elements, appState, value) => {
    return {
      elements: changeProperty(
          elements,
          appState,
          (oldElement) => {
            if (isTextElement(oldElement)) {
              const newElement: ExcalidrawTextElement = newElementWith(
                  oldElement,
                  {
                    lineHeight: value,
                  },
              );
              redrawTextBoundingBox(newElement, getContainerElement(oldElement));
              return newElement;
            }

            return oldElement;
          },
          true,
      ),
      appState: {
        ...appState,
        currentItemLineHeight: value,
      },
      commitToHistory: true,
      actionType: "lineHeight",
    };
  },
  PanelComponent: ({ elements, appState, updateData }) => {
    const getDefaultValue = ()=>{
      return getFormValue(
          elements,
          appState,
          (element) => {
            if (isTextElement(element)) {
              return element.lineHeight;
            }
            const boundTextElement = getBoundTextElement(element);
            if (boundTextElement) {
              return boundTextElement.lineHeight;
            }
            return null;
          },
          (element) =>
              isTextElement(element) ||
              isStickyNotesElement(element) ||
              getBoundTextElement(element) !== null,
          (hasSelection) =>
              hasSelection
                  ? null
                  : appState.currentItemLineHeight || DEFAULT_LINE_HEIGHT,
      )
    }
    const [lineHeight,setLineHeight] = useState<any>(getDefaultValue());
    const options: {
      value: FontFamilyValues;
      label: string;
      icon: JSX.Element;
      testId: string;
    }[] = [
      {
        value: 1.25,
        label: "1.25",
        icon: FontSizeSmallIcon,
        testId: "fontSize-small",
      },
      {
        value: 1.5,
        label: "1.5",
        icon: FontSizeMediumIcon,
        testId: "fontSize-medium",
      },
      {
        value: 2,
        label: "2",
        icon: FontSizeLargeIcon,
        testId: "fontSize-large",
      },
    ];
    return (
        <div className={'flex-col'}>
          <div className={'flex-row-vertical-center'}>
            <span>{i18next.t("Line spacing")}</span>
            <input
                className={'input-border'}
                style={{
                  width: '36px',
                  height: '24px',
                  borderRadius: '8px',
                  padding: '0px 4px',
                  marginLeft: 'auto',
                  textAlign: 'center',
                  fontSize: '12px'
                }}
                value={lineHeight}
                onFocus={(e) => {
                  e.currentTarget.select();
                }}
                onKeyDown={(event)=>{
                  if (event.key == KEYS.ENTER) {
                    let fValue = parseFloat(lineHeight + '');
                    if (isNaN(fValue) || fValue <= 0.5) {
                      fValue = 1.25;
                      setLineHeight(fValue);
                    }
                    updateData(fValue);
                  }
                }}
                onBlur={(event)=>{
                  updateData(lineHeight);
                }}
                onChange={(event) => {
                  const fValue = (event.currentTarget.value);
                  if (isNumberOrFloat(fValue)) {
                    setLineHeight((fValue))
                  } else {
                    if (event.currentTarget.value == '') {
                      setLineHeight('');
                    }
                  }
                }}
            />
          </div>
          <Slider style={{width: '100%', marginRight: '-4px',marginLeft:'-0px', marginTop:'26px'}}
                  min={0.5}
                  max={10}
                  step={0.01}
                  tooltip={{open: false}} value={lineHeight}
                  onChange={(value) => {
                    setLineHeight(value);
                    updateData(value)
                  }}/>
        </div>
    );
  },
});

export const isNumberOrFloat = (num) => {
  const regex = /^-?\d*\.?\d*$/;
  return regex.test(num);
};
























